/* THIS IS A GENERATED FILE - DO NOT MODIFY */
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AddDeliveryEventInput = {
  eventTypeId: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['JSON']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddLineDriveInput = {
  enabledDaysOfWeek: Array<Scalars['Int']['input']>;
  endHubId: Scalars['Int']['input'];
  endTime: TimeInput;
  startHubId: Scalars['Int']['input'];
  startTime: TimeInput;
};

export type AddOnItem = {
  __typename?: 'AddOnItem';
  addonType: AddOnItemType;
  displayText: Scalars['String']['output'];
  extraText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
};

export enum AddOnItemType {
  Donation = 'DONATION',
  Side = 'SIDE'
}

export type AddUserFromHubInput = {
  hubIds: Array<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  archived: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  latitude: Scalars['Float']['output'];
  linkedSubscriptionId?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  phone: Scalars['String']['output'];
  province: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  streetNumber?: Maybe<Scalars['String']['output']>;
  timeWindows: Array<TimeWindow>;
  unit?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
  zipCodeInfo?: Maybe<ZipCode>;
};


export type AddressTimeWindowsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInput = {
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  googlePlaceId?: InputMaybe<Scalars['String']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  province: Scalars['String']['input'];
  route?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  streetNumber?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type AdminAddGroupOrderResult = MutationResponse & {
  __typename?: 'AdminAddGroupOrderResult';
  groupOrder?: Maybe<GroupOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminBulkGiftCardsInput = {
  emails: Array<Scalars['String']['input']>;
  month: Scalars['String']['input'];
  valueInCents: Scalars['Int']['input'];
};

export type AdminBulkPartnerGiftCardsInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  giftCodeNames: Array<Scalars['String']['input']>;
  valueInCents: Scalars['Int']['input'];
};

export type AdminBulkRechargeGiftCardsInput = {
  addedValueInCents: Scalars['Int']['input'];
  giftCodeNames: Array<Scalars['String']['input']>;
};

export type AdminBulkShefGiftCardsInput = {
  isMealPlanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  message: Scalars['String']['input'];
  shefUserIds: Array<Scalars['String']['input']>;
  valueInCents: Scalars['Int']['input'];
};

export type AdminCreateEventConfig = {
  destination?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  sampleRate: Scalars['Float']['input'];
};

export type AdminModifyGroupOrderInput = {
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  orderStatus?: InputMaybe<OrderStatus>;
  phone?: InputMaybe<Scalars['String']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdminOrganizationsResults = {
  __typename?: 'AdminOrganizationsResults';
  organizations: Array<Organization>;
  pagination: Pagination;
};

export type AdminOutstandingShefChargesResults = {
  __typename?: 'AdminOutstandingShefChargesResults';
  charges: Array<ShefCharge>;
  pagination: Pagination;
};

export type AdminPromoCodeResults = {
  __typename?: 'AdminPromoCodeResults';
  pagination: Pagination;
  promoCodes: Array<PromoCode>;
};

export type AdminRegionShefRankingInput = {
  rank: Scalars['Int']['input'];
  shefId: Scalars['String']['input'];
  tier: Scalars['Int']['input'];
};

export type AdminShefApplicationUpdateInput = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  aiEvaluationStatus?: InputMaybe<ShefApplicationEvaluationOutcome>;
  archiveReason?: InputMaybe<Scalars['String']['input']>;
  bioEditedAt?: InputMaybe<Scalars['DateTime']['input']>;
  informationSessionCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  menuWebinarCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  offWaitlistAt?: InputMaybe<Scalars['DateTime']['input']>;
  orientationCallCompletedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orientationCallMissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  orientationCallScheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
  overallScore?: InputMaybe<ShefApplicationEvaluationOutcome>;
  profilePhotoRejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  starterKitPickedUpAt?: InputMaybe<Scalars['DateTime']['input']>;
  tastingMarkedMissingAt?: InputMaybe<Scalars['DateTime']['input']>;
  tastingReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tastingResult?: InputMaybe<Scalars['String']['input']>;
  tastingResultReceivedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdminShefChargesPageResults = {
  __typename?: 'AdminShefChargesPageResults';
  charges: Array<ShefCharge>;
  pagination: Pagination;
};

export type AdminShefFoodhandlersResults = {
  __typename?: 'AdminShefFoodhandlersResults';
  pagination: Pagination;
  shefs: Array<User>;
};

export type AdminShefResults = {
  __typename?: 'AdminShefResults';
  pagination: Pagination;
  shefs: Array<User>;
};

export type AdminSkipMealPlanGroupOrderInput = {
  deliveryDate: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AdminSkipMealPlanGroupOrderResponse = MutationResponse & {
  __typename?: 'AdminSkipMealPlanGroupOrderResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AdminTableRunStorefrontResults = {
  __typename?: 'AdminTableRunStorefrontResults';
  pagination: Pagination;
  storefronts: Array<TableRunStorefront>;
};

export type AdminUpdateEventConfig = {
  destination?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
  sampleRate: Scalars['Float']['input'];
};

export type AdminUserResults = {
  __typename?: 'AdminUserResults';
  pagination: Pagination;
  users: Array<User>;
};

export type AlgoliaPaginationResult = {
  __typename?: 'AlgoliaPaginationResult';
  isEnd: Scalars['Boolean']['output'];
  nbHits?: Maybe<Scalars['Int']['output']>;
  queryIdx: Scalars['Int']['output'];
};

export type AlgoliaPaginationState = {
  isEnd: Scalars['Boolean']['input'];
  nbHits?: InputMaybe<Scalars['Int']['input']>;
  queryIdx: Scalars['Int']['input'];
};

export enum ApplicationStatus {
  FoodTastingConfirmed = 'FOOD_TASTING_CONFIRMED',
  FoodTastingReminded = 'FOOD_TASTING_REMINDED',
  FoodTastingScheduled = 'FOOD_TASTING_SCHEDULED',
  OnboardingCallScheduled = 'ONBOARDING_CALL_SCHEDULED',
  Open = 'OPEN',
  OrientationCallScheduled = 'ORIENTATION_CALL_SCHEDULED'
}

export type ApplyTimeWindowMigrationResponse = MutationResponse & {
  __typename?: 'ApplyTimeWindowMigrationResponse';
  deliveryWindowIdsCreated: Array<Scalars['String']['output']>;
  groupOrdersMoved: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  ordersMoved: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  zipsMigrated: Scalars['Int']['output'];
};

export type AuthResult = AuthResults & {
  __typename?: 'AuthResult';
  isExistingUser: Scalars['Boolean']['output'];
  isImpersonatedUser?: Maybe<Scalars['Boolean']['output']>;
  token: Scalars['String']['output'];
  user: User;
};

export type AuthResult3 = AuthResults & {
  __typename?: 'AuthResult3';
  isExistingUser?: Maybe<Scalars['Boolean']['output']>;
  isImpersonatedUser?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type AuthResults = {
  isExistingUser?: Maybe<Scalars['Boolean']['output']>;
  isImpersonatedUser?: Maybe<Scalars['Boolean']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export enum AuthRole {
  Admin = 'ADMIN',
  ApprovedShef = 'APPROVED_SHEF',
  CustomLogicOnResolver = 'CUSTOM_LOGIC_ON_RESOLVER',
  MenuCurator = 'MENU_CURATOR',
  Owner = 'OWNER',
  PhotoEditor = 'PHOTO_EDITOR',
  Public = 'PUBLIC',
  RelatedShef = 'RELATED_SHEF',
  Shef = 'SHEF'
}

export type AvailableSubcuisine = {
  __typename?: 'AvailableSubcuisine';
  shefCount: Scalars['Int']['output'];
  subcuisine: CuisineCategory;
};

/**
 * Which product a record belongs to. Resolves to `common/Brand`; the values are mapped in
 * `src/gql/gqlEnumResolvers.ts`.
 */
export enum Brand {
  Shef = 'SHEF',
  TableRun = 'TABLE_RUN'
}

export enum BrowseFilter {
  Cuisine = 'CUISINE',
  Dietary = 'DIETARY',
  Protein = 'PROTEIN',
  Segment = 'SEGMENT'
}

export type BulkAdminShefApplicationUpdateInput = {
  shefApplicationUpdateInput: AdminShefApplicationUpdateInput;
  shefId: Scalars['String']['input'];
};

export type BulkCreateShefChargeInput = {
  amountCents: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: ShefChargeReason;
  rowIndex: Scalars['Int']['input'];
  shefUserId: Scalars['String']['input'];
};

export type BulkCreateShefChargeResult = {
  __typename?: 'BulkCreateShefChargeResult';
  charge?: Maybe<ShefCharge>;
  created: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  existingAmountCentsForNote?: Maybe<Scalars['Int']['output']>;
  rowIndex: Scalars['Int']['output'];
  shefUserId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type BulkDiscountTier = {
  __typename?: 'BulkDiscountTier';
  discountRate: Scalars['Float']['output'];
  maxSubtotal?: Maybe<Scalars['Int']['output']>;
  minSubtotal: Scalars['Int']['output'];
};

/**
 * The outcome of one row of a CSV bulk operation. `rowIndex` is the row's position in the
 * submitted input, so a caller can map a failure back to the line the admin typed.
 */
export type BulkPromoCodeRowResult = {
  __typename?: 'BulkPromoCodeRowResult';
  code?: Maybe<PromoCode>;
  error?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type BundleFoodItem = {
  __typename?: 'BundleFoodItem';
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type CacheOptionsInput = {
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  staleWhileRevalidate?: InputMaybe<Scalars['Int']['input']>;
};

export type CancelMealPlanInput = {
  id: Scalars['String']['input'];
  upcomingOrderToCancelDeliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type CancelMealPlanResponse = MutationResponse & {
  __typename?: 'CancelMealPlanResponse';
  mealPlan?: Maybe<MealPlan>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CancelMyTableRunMealPlanInput = {
  mealPlanId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CancelMyTableRunMealPlanResult = MutationResponse & {
  __typename?: 'CancelMyTableRunMealPlanResult';
  mealPlan: TableRunMealPlan;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum CancelOrderNotificationFrequency {
  AllOrders = 'ALL_ORDERS',
  NeverNotify = 'NEVER_NOTIFY'
}

export type CartAddOnItem = {
  __typename?: 'CartAddOnItem';
  addOnItem: AddOnItem;
  addOnItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type CartDeliveryDateSpend = {
  __typename?: 'CartDeliveryDateSpend';
  deliveryDate: Scalars['String']['output'];
  spend: Scalars['Int']['output'];
};

export type CartFoodItem = {
  __typename?: 'CartFoodItem';
  foodItemId: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};

export type CartLineItem = {
  __typename?: 'CartLineItem';
  createdAt: Scalars['String']['output'];
  customizationIds?: Maybe<Array<Scalars['String']['output']>>;
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  shef: PublicShef;
  shefId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CartLineItemInput = {
  customizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  foodItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type CartResults = {
  __typename?: 'CartResults';
  addOnItems: Array<CartAddOnItem>;
  bulkDiscountTiers: Array<BulkDiscountTier>;
  deliveryDateSpend: Array<CartDeliveryDateSpend>;
  foodItems: Array<CartLineItem>;
  recentlyAdded: Scalars['Boolean']['output'];
};

export type CategoricalRatings = {
  __typename?: 'CategoricalRatings';
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CategoricalRatingsResults = {
  __typename?: 'CategoricalRatingsResults';
  negativeRatings: Array<CategoricalRatings>;
  positiveRatings: Array<CategoricalRatings>;
};

export type CategoryPageContent = {
  __typename?: 'CategoryPageContent';
  fadeSegmentBackground?: Maybe<Scalars['Boolean']['output']>;
  heroBackgroundUrl?: Maybe<Scalars['String']['output']>;
  heroBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  heroBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  illustrationUrl?: Maybe<Scalars['String']['output']>;
  moreCuisinesBackgroundUrl: Scalars['String']['output'];
  moreCuisinesBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  moreCuisinesBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  pageType: CategoryPageType;
  patternedStripUrl: Scalars['String']['output'];
  referralStripBackgroundUrl: Scalars['String']['output'];
  referralStripBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  referralStripBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  referralStripTextColor: ReferralStripTextColor;
  searchSuggestions?: Maybe<Array<CategoryPageSearchSuggestion>>;
  segmentBackgroundUrl: Scalars['String']['output'];
  segmentBackgroundUrlDesktop?: Maybe<Scalars['String']['output']>;
  segmentBackgroundUrlTablet?: Maybe<Scalars['String']['output']>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CategoryPageRecentReviewResult = {
  __typename?: 'CategoryPageRecentReviewResult';
  recentReviews: Array<RecentReview>;
};

export type CategoryPageSearchSuggestion = {
  __typename?: 'CategoryPageSearchSuggestion';
  display: Scalars['String']['output'];
  searchQuery?: Maybe<Scalars['String']['output']>;
};

export enum CategoryPageType {
  SubCuisine = 'SUB_CUISINE',
  TopLevel = 'TOP_LEVEL'
}

export enum CelebrityEventType {
  BingingWithBabish = 'BINGING_WITH_BABISH',
  MasterChefNyesha = 'MASTER_CHEF_NYESHA'
}

export enum ChangeRequestChangeTypeFilter {
  All = 'ALL',
  HasPhoto = 'HAS_PHOTO',
  NoPhoto = 'NO_PHOTO'
}

export enum ChangeRequestFoodTypeFilter {
  All = 'ALL',
  Dessert = 'DESSERT',
  Main = 'MAIN',
  Side = 'SIDE'
}

export enum ChangeRequestOriginFilter {
  All = 'ALL',
  LiveDishEdit = 'LIVE_DISH_EDIT',
  NewDish = 'NEW_DISH'
}

export enum ChangeRequestPhotoStatusFilter {
  All = 'ALL',
  Approved = 'APPROVED',
  NeedsPhotoEdits = 'NEEDS_PHOTO_EDITS',
  NeedsPhotoEditsReview = 'NEEDS_PHOTO_EDITS_REVIEW',
  New = 'NEW',
  Uneditable = 'UNEDITABLE'
}

export enum ChangeRequestReviewStatusFilter {
  All = 'ALL',
  PendingAdminReview = 'PENDING_ADMIN_REVIEW',
  PendingShefReview = 'PENDING_SHEF_REVIEW'
}

export enum ChangeRequestShefTypeFilter {
  All = 'ALL',
  MarketplaceShef = 'MARKETPLACE_SHEF',
  MealPlanShef = 'MEAL_PLAN_SHEF'
}

export enum ChangeRequestUserTypeFilter {
  All = 'ALL',
  Applicants = 'APPLICANTS',
  Approved = 'APPROVED'
}

export type CityPageCity = {
  __typename?: 'CityPageCity';
  cityName: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['String']['output'];
  publishedAt: Scalars['Date']['output'];
  source: Scalars['String']['output'];
  stateNameLong: Scalars['String']['output'];
  stateNameShort: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  zipCode: Scalars['String']['output'];
  zipCodeInfo: ZipCode;
};

export type CityPageContent = {
  __typename?: 'CityPageContent';
  dishes: Array<CityPageDish>;
  numDishes: Scalars['Int']['output'];
  shefs: Array<CityPageShef>;
};

export type CityPageDish = {
  __typename?: 'CityPageDish';
  averageRating: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portion: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  ratingCount: Scalars['Int']['output'];
  shef: CityPageDishShefInfo;
  slug?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type CityPageDishShefInfo = {
  __typename?: 'CityPageDishShefInfo';
  businessName?: Maybe<Scalars['String']['output']>;
  formattedCuisineCategories?: Maybe<Scalars['String']['output']>;
  publicName: Scalars['String']['output'];
};

export type CityPageFilter = {
  __typename?: 'CityPageFilter';
  cuisineCategory?: Maybe<CuisineCategory>;
  cuisineCategoryId?: Maybe<Scalars['String']['output']>;
  dietaryFilter?: Maybe<Scalars['String']['output']>;
};

export type CityPageFilterInput = {
  cuisineCategoryId?: InputMaybe<Scalars['String']['input']>;
  dietaryFilter?: InputMaybe<Scalars['String']['input']>;
};

export type CityPageShef = {
  __typename?: 'CityPageShef';
  bio?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  formattedCuisineCategories?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  publicName: Scalars['String']['output'];
  rating?: Maybe<ShefRating>;
};

export type CloseTableRunStorefrontResult = MutationResponse & {
  __typename?: 'CloseTableRunStorefrontResult';
  canceledOrderCount: Scalars['Int']['output'];
  failedToCancelCount: Scalars['Int']['output'];
  failedToRefundOrderCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  /**
   * Paid one-time orders refunded in full. They were charged at checkout, so unlike held orders they
   * are unwound with a refund rather than a cancellation.
   */
  refundedOrderCount: Scalars['Int']['output'];
  skippedPastCutoffCount: Scalars['Int']['output'];
  storefront: TableRunStorefront;
  success: Scalars['Boolean']['output'];
};

export type CombinedSearchResults = {
  __typename?: 'CombinedSearchResults';
  cuisineResults: Array<CuisineSearchResult>;
  dishResults: DishSearchResults;
  shefResults: ShefSearchResults;
  showGiftCardResult: Scalars['Boolean']['output'];
};

export type Config = {
  __typename?: 'Config';
  id: Scalars['Int']['output'];
  name: FeatureName;
  overrides: Array<ConfigOverride>;
  type: ConfigType;
  value: Scalars['String']['output'];
};

export type ConfigOverride = {
  __typename?: 'ConfigOverride';
  id: Scalars['Int']['output'];
  segment: Scalars['String']['output'];
  segmentValue?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ConfigOverrideInput = {
  segment: Scalars['String']['input'];
  segmentValue?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export enum ConfigSegmentValueType {
  Json = 'JSON'
}

export enum ConfigType {
  Bool = 'BOOL',
  Json = 'JSON',
  Number = 'NUMBER',
  String = 'STRING'
}

export type ConsumerModifyGroupOrderInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  addOnItemsSubtotal: Scalars['Int']['input'];
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  perShefOrders: Array<PerShefOrderModifyInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  replaceRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  shefTip: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsumerModifyOrderInput = {
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  modifyLineItems?: InputMaybe<ModifyLineItemInput>;
  orderId: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  replaceRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type ConsumerOrderResults = {
  __typename?: 'ConsumerOrderResults';
  count: Scalars['Int']['output'];
  orders: Array<Order>;
};

export enum ConsumerOrderStatus {
  Delivered = 'DELIVERED',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Received = 'RECEIVED',
  ShefCooking = 'SHEF_COOKING',
  ShefPrepping = 'SHEF_PREPPING'
}

export type ConsumerOrderTotal = {
  __typename?: 'ConsumerOrderTotal';
  deliveryFee: Scalars['Int']['output'];
  /**
   * Deprecated: Use `promoApplied`. This value will equal `promoApplied` for now
   * @deprecated Use promoApplied
   */
  discountApplied: Scalars['Int']['output'];
  /**
   * Deprecated: use `promoBalance`. This value will always equal `promoBalance`
   * @deprecated Use promoBalance
   */
  discountBalance: Scalars['Int']['output'];
  /** Amount deducted from order using a gift card */
  giftCardApplied?: Maybe<Scalars['Int']['output']>;
  grandTotal: Scalars['Int']['output'];
  /** Temporary property to hold amount deducted via discounts */
  nonPromoDiscountApplied: Scalars['Int']['output'];
  /** Amount deducted from order using a promo code (excluding gift cards) */
  promoApplied: Scalars['Int']['output'];
  /** Amount left that can be refunded to the promo code */
  promoBalance: Scalars['Int']['output'];
  refund: Scalars['Int']['output'];
  /** Amount left that can be refunded to the user's payment method */
  refundableBalance: Scalars['Int']['output'];
  /**
   * Reusable-container deposit charged with this order, in cents. Sourced from the separate
   * ReusableDeposit transaction (kept off the order total), so it is 0 unless a deposit was charged.
   */
  reusableDeposit?: Maybe<Scalars['Int']['output']>;
  reusablePackagingCleaningFee?: Maybe<Scalars['Int']['output']>;
  salesTax: Scalars['Int']['output'];
  serviceFee: Scalars['Int']['output'];
  shefTip: Scalars['Int']['output'];
  smallOrderFee: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
};

export type ConsumerReferralInfo = {
  __typename?: 'ConsumerReferralInfo';
  adImageUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<ReferralCode>;
  earningsInCents?: Maybe<Scalars['Int']['output']>;
  eligibleAt?: Maybe<Scalars['Date']['output']>;
  referredCount?: Maybe<Scalars['Int']['output']>;
  referredCountUnique?: Maybe<Scalars['Int']['output']>;
};

export type ContentItem = FoodItem | PublicShef;

export type CoreMenuAdditionInput = {
  effectiveFrom?: InputMaybe<Scalars['Date']['input']>;
  foodItemId: Scalars['Int']['input'];
};

export type CoreMenuRemovalInput = {
  effectiveUntil: Scalars['Date']['input'];
  foodItemId: Scalars['Int']['input'];
};

export type CreateAddOnItemInput = {
  displayText: Scalars['String']['input'];
  extraText?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type CreateHeldMealPlanGroupOrderFromPerShefOrdersInput = {
  deliveryDate: Scalars['String']['input'];
  giftCardCode?: InputMaybe<Scalars['String']['input']>;
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanId: Scalars['String']['input'];
  perShefOrders: Array<PerShefOrderInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shouldCreatePlaceholder?: InputMaybe<Scalars['Boolean']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateHeldMealPlanGroupOrderFromPerShefOrdersResponse = MutationResponse & {
  __typename?: 'CreateHeldMealPlanGroupOrderFromPerShefOrdersResponse';
  groupOrder?: Maybe<GroupOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateHeldMealPlanGroupOrderInput = {
  deliveryDate: Scalars['String']['input'];
  mealPlanId: Scalars['String']['input'];
};

export type CreateMealPlanSetupIntentResponse = MutationResponse & {
  __typename?: 'CreateMealPlanSetupIntentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreateMerchandisePageTagFilterInput = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type CreateMyTableRunStorefrontInput = {
  slug: Scalars['String']['input'];
  subscribePricePerServingCents?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSetupIntentForPaymentMethodResult = {
  __typename?: 'CreateSetupIntentForPaymentMethodResult';
  clientSecret: Scalars['String']['output'];
};

export type CreateSetupIntentForTableRunCheckoutResult = {
  __typename?: 'CreateSetupIntentForTableRunCheckoutResult';
  clientSecret: Scalars['String']['output'];
};

export type CreateSetupIntentForWssFinalizeResult = {
  __typename?: 'CreateSetupIntentForWssFinalizeResult';
  clientSecret: Scalars['String']['output'];
};

export type CreateShefChargeInput = {
  amountCents: Scalars['Int']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: ShefChargeReason;
  shefId: Scalars['String']['input'];
};

export type CreateShefChargeResult = {
  __typename?: 'CreateShefChargeResult';
  charge: ShefCharge;
  created: Scalars['Boolean']['output'];
  existingAmountCentsForNote?: Maybe<Scalars['Int']['output']>;
};

export type CreateTableRunMealPlanInput = {
  /**
   * A new address, for a customer with none saved. Created as part of the same transaction that
   * places the order, so a shef who cannot deliver there leaves no address behind.
   */
  deliveryAddress?: InputMaybe<AddressInput>;
  /** A saved address. Supply exactly one of `deliveryAddressId` or `deliveryAddress`. */
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The delivery window the customer chose, from `TableRunStorefront.deliveryTimeWindows`. Required
   * once the storefront has windows to offer: it is what tells the courier when to collect and when
   * to hand over, and an order without one cannot be dispatched.
   */
  deliveryTimeWindowId?: InputMaybe<Scalars['Int']['input']>;
  foodItemIds: Array<Scalars['ID']['input']>;
  mealsPerWeek: Scalars['Int']['input'];
  numServings: Scalars['Int']['input'];
  paymentMethodId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};

export type CreateTableRunStorefrontInput = {
  shefId: Scalars['ID']['input'];
  slug: Scalars['String']['input'];
  subscribePricePerServingCents?: InputMaybe<Scalars['Int']['input']>;
};

export type CuisineCategory = {
  __typename?: 'CuisineCategory';
  ancestorCuisines: Array<CuisineCategory>;
  categoryPageContent?: Maybe<CategoryPageContent>;
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  rootCuisineId: Scalars['String']['output'];
  subcuisines: Array<CuisineCategory>;
  title: Scalars['String']['output'];
  type: CuisineCategoryType;
};

export enum CuisineCategoryType {
  Allergen = 'ALLERGEN',
  Dietary = 'DIETARY',
  FoodItemSpecialty = 'FOOD_ITEM_SPECIALTY',
  FoodStyle = 'FOOD_STYLE',
  Holiday = 'HOLIDAY',
  Internal = 'INTERNAL',
  Region = 'REGION',
  RegionCountry = 'REGION_COUNTRY',
  RegionStyle = 'REGION_STYLE',
  RegionSubregion = 'REGION_SUBREGION',
  Verified = 'VERIFIED'
}

export enum CuisineRegion {
  African = 'AFRICAN',
  American = 'AMERICAN',
  Asian = 'ASIAN',
  BakedGoods = 'BAKED_GOODS',
  Bangladeshi = 'BANGLADESHI',
  Caribbean = 'CARIBBEAN',
  Chinese = 'CHINESE',
  Donations = 'DONATIONS',
  EasternEuropean = 'EASTERN_EUROPEAN',
  European = 'EUROPEAN',
  French = 'FRENCH',
  Fusion = 'FUSION',
  Hungarian = 'HUNGARIAN',
  Indian = 'INDIAN',
  International = 'INTERNATIONAL',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  NativeAmerican = 'NATIVE_AMERICAN',
  Nepalese = 'NEPALESE',
  Other = 'OTHER',
  Pakistani = 'PAKISTANI',
  Russian = 'RUSSIAN',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  Southern = 'SOUTHERN',
  SouthAsian = 'SOUTH_ASIAN',
  SouthPacific = 'SOUTH_PACIFIC',
  Specialty = 'SPECIALTY'
}

export type CuisineSearchResult = {
  __typename?: 'CuisineSearchResult';
  category: CuisineCategory;
  numDishes: Scalars['Int']['output'];
  numShefs: Scalars['Int']['output'];
};

export enum CustomizationCategory {
  ServingSize = 'SERVING_SIZE',
  SpiceLevel = 'SPICE_LEVEL'
}

export type DateRange = {
  __typename?: 'DateRange';
  begin?: Maybe<Scalars['DateTime']['output']>;
  bounds: Scalars['String']['output'];
  end?: Maybe<Scalars['DateTime']['output']>;
};

export type DayStats = {
  __typename?: 'DayStats';
  date?: Maybe<Scalars['DateTime']['output']>;
  grossSum?: Maybe<Scalars['Int']['output']>;
  orderCount?: Maybe<Scalars['Int']['output']>;
  valueSum?: Maybe<Scalars['Int']['output']>;
};

export type DeleteDeliveryEventInput = {
  eventTypeId: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteMealPlanShefPayoutOverrideInput = {
  id: Scalars['String']['input'];
};

export type DeleteMealPlanShefPayoutOverrideResponse = {
  __typename?: 'DeleteMealPlanShefPayoutOverrideResponse';
  deletedCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Delivery = {
  __typename?: 'Delivery';
  driverName?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryTime?: Maybe<Scalars['DateTime']['output']>;
  estimatedPickupTime?: Maybe<Scalars['DateTime']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  tip?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum DeliveryDateChangePossible {
  No = 'NO',
  WithOrderChanges = 'WITH_ORDER_CHANGES',
  Yes = 'YES'
}

export type DeliveryDaysInput = {
  fridayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mondayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  saturdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  sundayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  type: GeoInputType;
  wednesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeliveryEvent = {
  __typename?: 'DeliveryEvent';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<DeliveryEventType>;
  eventTypeId: Scalars['String']['output'];
  groupOrderId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  meta?: Maybe<Scalars['JSON']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeliveryEventType = {
  __typename?: 'DeliveryEventType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeliveryHub = {
  __typename?: 'DeliveryHub';
  city: Scalars['String']['output'];
  code: Scalars['String']['output'];
  dropoffWindowEndTimeMinutesFromMidnight?: Maybe<Scalars['Int']['output']>;
  dropoffWindowStartTimeMinutesFromMidnight?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pickupInstructions: Scalars['String']['output'];
  province: Scalars['String']['output'];
  region: RegionInfo;
  street: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type DeliveryPrice = {
  __typename?: 'DeliveryPrice';
  deliveryDiscount: Scalars['Int']['output'];
  finalDeliveryPrice: Scalars['Int']['output'];
  rawDeliveryCost: Scalars['Int']['output'];
};

export type DeliveryTimeRange = {
  __typename?: 'DeliveryTimeRange';
  endMinutesOffset: Scalars['Int']['output'];
  startMinutesOffset: Scalars['Int']['output'];
};

export type DeliveryWindow = {
  __typename?: 'DeliveryWindow';
  enabled: Scalars['Boolean']['output'];
  timeWindow?: Maybe<TimeWindow>;
  timeWindowId: Scalars['Int']['output'];
};

export enum DietType {
  Halal = 'halal',
  Omnivore = 'omnivore',
  Paleo = 'paleo',
  Pescatarian = 'pescatarian',
  Vegan = 'vegan',
  Vegetarian = 'vegetarian',
  Whole30 = 'whole30'
}

export type DietaryAnalysis = {
  __typename?: 'DietaryAnalysis';
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  dairyFree?: Maybe<Scalars['Boolean']['output']>;
  glutenFree?: Maybe<Scalars['Boolean']['output']>;
  lowFodmap?: Maybe<Scalars['Boolean']['output']>;
  paleo?: Maybe<Scalars['Boolean']['output']>;
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  whole30?: Maybe<Scalars['Boolean']['output']>;
};

export type DietaryDetails = {
  __typename?: 'DietaryDetails';
  dietaryTag: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  responses: Array<VerifiedDietaryResponse>;
  summaryDisplay: Scalars['String']['output'];
  summaryExplanation?: Maybe<Scalars['String']['output']>;
  summaryId: Scalars['String']['output'];
};

export enum DietaryRestriction {
  Avocado = 'avocado',
  Beef = 'beef',
  BellPepper = 'bellPepper',
  Cilantro = 'cilantro',
  Dairy = 'dairy',
  DairyFree = 'dairyFree',
  Eggs = 'eggs',
  Garlic = 'garlic',
  Gluten = 'gluten',
  GlutenFree = 'glutenFree',
  Mushrooms = 'mushrooms',
  Nuts = 'nuts',
  Onions = 'onions',
  Pork = 'pork',
  Sesame = 'sesame',
  Shellfish = 'shellfish',
  Soy = 'soy'
}

/**
 * The different types of content in segments
 *
 * Note: if a new type is added to this union, you'll need to manually add it to the
 * `IDishFirstContentItem` type in './explore/dish-first/types'
 */
export type DishFirstContentItem = CuisineCategory | ExploreSegmentShef | FoodItem | PublicShef;

export enum DishFirstSegmentFilter {
  African = 'AFRICAN',
  All = 'ALL',
  American = 'AMERICAN',
  BakedGoods = 'BAKED_GOODS',
  BalancedMeals = 'BALANCED_MEALS',
  Bangladeshi = 'BANGLADESHI',
  BowlsAndPlates = 'BOWLS_AND_PLATES',
  Caribbean = 'CARIBBEAN',
  Chinese = 'CHINESE',
  Classics = 'CLASSICS',
  ConsumerPackagedGoods = 'CONSUMER_PACKAGED_GOODS',
  Cuisines = 'CUISINES',
  Customizations = 'CUSTOMIZATIONS',
  Desserts = 'DESSERTS',
  FamilySize = 'FAMILY_SIZE',
  FarmersMarket = 'FARMERS_MARKET',
  Favorites = 'FAVORITES',
  French = 'FRENCH',
  Healthy = 'HEALTHY',
  Hungarian = 'HUNGARIAN',
  Indian = 'INDIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  KidFriendly = 'KID_FRIENDLY',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  LocalIndianMarket = 'LOCAL_INDIAN_MARKET',
  LunarNewYear = 'LUNAR_NEW_YEAR',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  MixedHalalKitchen = 'MIXED_HALAL_KITCHEN',
  MothersDay = 'MOTHERS_DAY',
  Nepalese = 'NEPALESE',
  New = 'NEW',
  NewShefs = 'NEW_SHEFS',
  NextDay = 'NEXT_DAY',
  OrderAgain = 'ORDER_AGAIN',
  Pakistani = 'PAKISTANI',
  Professional = 'PROFESSIONAL',
  Promos = 'PROMOS',
  RecommendedShefs = 'RECOMMENDED_SHEFS',
  Russian = 'RUSSIAN',
  ShefsYouFollow = 'SHEFS_YOU_FOLLOW',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  Southern = 'SOUTHERN',
  Specialty = 'SPECIALTY',
  StaffPicks = 'STAFF_PICKS',
  StrictHalalKitchen = 'STRICT_HALAL_KITCHEN',
  WalletFriendly = 'WALLET_FRIENDLY',
  Winter = 'WINTER'
}

export type DishSearchResults = {
  __typename?: 'DishSearchResults';
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  results: Array<FoodItem>;
};

export enum DishTag {
  AntibioticFree = 'ANTIBIOTIC_FREE',
  LocallySourced = 'LOCALLY_SOURCED',
  PastureRaised = 'PASTURE_RAISED'
}

export type DropOffScanInput = {
  droppedOffAt?: InputMaybe<Scalars['DateTime']['input']>;
  droppedOffWithinWindow: Scalars['Boolean']['input'];
  orderId: Scalars['Int']['input'];
  scannedAtHubId: Scalars['Int']['input'];
};

export type DuplicateFoodItemInput = {
  availableFriday: Scalars['Boolean']['input'];
  availableMonday: Scalars['Boolean']['input'];
  availableSaturday: Scalars['Boolean']['input'];
  availableSunday: Scalars['Boolean']['input'];
  availableThursday: Scalars['Boolean']['input'];
  availableTuesday: Scalars['Boolean']['input'];
  availableWednesday: Scalars['Boolean']['input'];
  capacity: Scalars['Int']['input'];
  foodType: FoodType;
  isFlexibleSides: Scalars['Boolean']['input'];
  isMarketplace: Scalars['Boolean']['input'];
  mealPlanFoodType?: InputMaybe<MealPlanFoodType>;
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  sourceFoodItemId: Scalars['Int']['input'];
};

export type DuplicateFoodItemResult = {
  __typename?: 'DuplicateFoodItemResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  foodItem?: Maybe<FoodItem>;
  sourceFoodItemId: Scalars['Int']['output'];
};

export type DuplicateOrderToCartResponse = {
  __typename?: 'DuplicateOrderToCartResponse';
  addedItems: Array<CartLineItem>;
  success: Scalars['Boolean']['output'];
};

export type ExpectedPaginationInfoInput = {
  expectedPreviousPageFinalItemId: Scalars['String']['input'];
  expectedPreviousPageFinalSegmentId: Scalars['String']['input'];
};

export type Experiment = {
  __typename?: 'Experiment';
  name: Scalars['String']['output'];
  rollout?: Maybe<Scalars['Int']['output']>;
  selectedVariant?: Maybe<Scalars['String']['output']>;
  variants: Array<Variant>;
};

export type ExploreCuisineResults = {
  __typename?: 'ExploreCuisineResults';
  ancestorCuisinesAvailability: Array<CuisineSearchResult>;
  availableDeliveryDays: Array<Scalars['String']['output']>;
  segments: Array<ExploreSegment>;
};

export type ExploreFilterOptionsResults = {
  __typename?: 'ExploreFilterOptionsResults';
  availableDeliveryDays: Array<NumberAvailableShefsResult>;
  availableSegmentFilterIcons: Array<SegmentFilter>;
  availableSubcuisines: Array<AvailableSubcuisine>;
  isEcoFriendlyFilterAvailable: Scalars['Boolean']['output'];
};

export type ExploreFoodItemsContent = {
  __typename?: 'ExploreFoodItemsContent';
  isInPreview: Scalars['Boolean']['output'];
  items: Array<DishFirstContentItem>;
  total: Scalars['Int']['output'];
};

export type ExploreFoodItemsFilterInput = {
  availabilityDates?: InputMaybe<Array<Scalars['String']['input']>>;
  browseFilter?: InputMaybe<BrowseFilter>;
  cuisineFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  dishTypeFilters?: InputMaybe<Array<FoodTypeCoalesced>>;
  isEcoFriendlyPackaging?: InputMaybe<Scalars['Boolean']['input']>;
  minDishRating?: InputMaybe<Scalars['Int']['input']>;
  priceLevelFilters?: InputMaybe<Array<PriceLevel>>;
  proteinFilters?: InputMaybe<Array<Protein>>;
  segmentFilters?: InputMaybe<Array<DishFirstSegmentFilter>>;
  smallScreen?: InputMaybe<Scalars['Boolean']['input']>;
  spiceLevelFilters?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ExploreFoodItemsFilterOptionsResults = {
  __typename?: 'ExploreFoodItemsFilterOptionsResults';
  availableCuisines: Array<CuisineCategory>;
  availableDeliveryDays: Array<NumberAvailableDishesResult>;
  isEcoFriendlyFilterAvailable: Scalars['Boolean']['output'];
  totalShefs: Scalars['Int']['output'];
};

export type ExploreFoodItemsPreviewFilter = {
  __typename?: 'ExploreFoodItemsPreviewFilter';
  availabilityDates?: Maybe<Array<Scalars['String']['output']>>;
  cuisineFilters?: Maybe<Array<Scalars['String']['output']>>;
  dietaryFilters?: Maybe<Array<Scalars['String']['output']>>;
  dishTypeFilters?: Maybe<Array<FoodTypeCoalesced>>;
  isEcoFriendlyPackaging?: Maybe<Scalars['Boolean']['output']>;
  minDishRating?: Maybe<Scalars['Int']['output']>;
  priceLevelFilters?: Maybe<Array<PriceLevel>>;
  proteinFilters?: Maybe<Array<Protein>>;
  spiceLevelFilters?: Maybe<Array<Scalars['Int']['output']>>;
  tagFilters?: Maybe<Array<Scalars['String']['output']>>;
};

export type ExploreFoodItemsSegment = {
  __typename?: 'ExploreFoodItemsSegment';
  cacheKey: Scalars['String']['output'];
  categoryPageContent?: Maybe<CategoryPageContent>;
  content: ExploreFoodItemsContent;
  displayName: Scalars['String']['output'];
  heroImageSrc?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<SegmentIcon>;
  id: Scalars['String']['output'];
  layout: ExploreFoodItemsSegmentLayout;
  preview?: Maybe<ExploreFoodItemsSegmentPreview>;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type ExploreFoodItemsSegmentContentArgs = {
  filter?: InputMaybe<ExploreFoodItemsFilterInput>;
};

export enum ExploreFoodItemsSegmentLayout {
  Carousel = 'CAROUSEL',
  Cuisines = 'CUISINES',
  Generic = 'GENERIC'
}

export type ExploreFoodItemsSegmentPreview = {
  __typename?: 'ExploreFoodItemsSegmentPreview';
  seeAllFilter?: Maybe<ExploreFoodItemsPreviewFilter>;
  seeAllText: Scalars['String']['output'];
  showAllFiltersWhenExpanded: Scalars['Boolean']['output'];
};

export type ExploreMerchandisePage = {
  __typename?: 'ExploreMerchandisePage';
  excludeTagsOp: TaggedShefOp;
  heroPhotoUrl: Scalars['String']['output'];
  id: Scalars['String']['output'];
  includeTagsOp: TaggedShefOp;
  pageName: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  tagFilters: Array<ExploreMerchandisePageTagFilter>;
  title: Scalars['String']['output'];
};

export type ExploreMerchandisePageInput = {
  excludeTagsOp: TaggedShefOp;
  heroPhotoUrl: Scalars['String']['input'];
  includeTagsOp: TaggedShefOp;
  pageName: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ExploreMerchandisePageTagFilter = {
  __typename?: 'ExploreMerchandisePageTagFilter';
  exclude?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  pageId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
};

export type ExploreMerchandiseResults = {
  __typename?: 'ExploreMerchandiseResults';
  availableDeliveryDays: Array<Scalars['String']['output']>;
  segments: Array<ExploreSegment>;
};

export type ExploreSegment = {
  __typename?: 'ExploreSegment';
  cacheKey: Scalars['String']['output'];
  content: ExploreSegmentContent;
  displayName: Scalars['String']['output'];
  icon?: Maybe<SegmentIcon>;
  id: Scalars['String']['output'];
  layout: SegmentLayout;
  preview?: Maybe<ExploreSegmentPreview>;
  subcuisineSegmentDetails?: Maybe<SubcuisineSegmentDetails>;
  subtitle?: Maybe<Scalars['String']['output']>;
};


export type ExploreSegmentContentArgs = {
  filter?: InputMaybe<ExploreSegmentsFilterInput>;
};

export type ExploreSegmentContent = {
  __typename?: 'ExploreSegmentContent';
  isInPreview: Scalars['Boolean']['output'];
  items: Array<ContentItem>;
  total: Scalars['Int']['output'];
};

export type ExploreSegmentPreview = {
  __typename?: 'ExploreSegmentPreview';
  seeAllText: Scalars['String']['output'];
  showAllFiltersWhenExpanded: Scalars['Boolean']['output'];
};

export type ExploreSegmentShef = {
  __typename?: 'ExploreSegmentShef';
  dishPreviewImage: Scalars['String']['output'];
  isMealPlanShef?: Maybe<Scalars['Boolean']['output']>;
  nextAvailableDate?: Maybe<Scalars['String']['output']>;
  numDishes: Scalars['Int']['output'];
  shef: PublicShef;
};

export type ExploreSegmentsFilterInput = {
  cuisineFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryDays?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  excludePromoSegment?: InputMaybe<Scalars['Boolean']['input']>;
  isEcoFriendlyPackaging?: InputMaybe<Scalars['Boolean']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  segmentFilters?: InputMaybe<Array<SegmentFilter>>;
  smallScreen: Scalars['Boolean']['input'];
  spiceLevelFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode: Scalars['String']['input'];
};

export type FacebookEvent = {
  data?: InputMaybe<Scalars['String']['input']>;
  eid: Scalars['String']['input'];
  fbc?: InputMaybe<Scalars['String']['input']>;
  fbp?: InputMaybe<Scalars['String']['input']>;
};

export enum FeatureName {
  AdminDeleteUsersKey = 'ADMIN_DELETE_USERS_KEY',
  ApiSyncEnabled = 'API_SYNC_ENABLED',
  ApplePay = 'APPLE_PAY',
  AppleSignInOnWebEnabled = 'APPLE_SIGN_IN_ON_WEB_ENABLED',
  BecomeAShefLpV2Enabled = 'BECOME_A_SHEF_LP_V2_ENABLED',
  BulkDiscountEnabled = 'BULK_DISCOUNT_ENABLED',
  CalendlyIgnoreEventList = 'CALENDLY_IGNORE_EVENT_LIST',
  CalendlyOrientationCallLink = 'CALENDLY_ORIENTATION_CALL_LINK',
  CalendlyShefMenuWebinarCallEventIds = 'CALENDLY_SHEF_MENU_WEBINAR_CALL_EVENT_IDS',
  CalendlyShefOnboardingCallEventIds = 'CALENDLY_SHEF_ONBOARDING_CALL_EVENT_IDS',
  CalendlyShefOrientationCallEventIds = 'CALENDLY_SHEF_ORIENTATION_CALL_EVENT_IDS',
  CancelDoordashDeliveryPhoneNumber = 'CANCEL_DOORDASH_DELIVERY_PHONE_NUMBER',
  CcpaConsentBannerEnabled = 'CCPA_CONSENT_BANNER_ENABLED',
  ChatBusinessRiskKeywords = 'CHAT_BUSINESS_RISK_KEYWORDS',
  ChatCustomizationKeywords = 'CHAT_CUSTOMIZATION_KEYWORDS',
  ChatEnabled = 'CHAT_ENABLED',
  ChatFeedbackKeywords = 'CHAT_FEEDBACK_KEYWORDS',
  ChatSupportKeywords = 'CHAT_SUPPORT_KEYWORDS',
  ConsumerDeleteUserEnabled = 'CONSUMER_DELETE_USER_ENABLED',
  CpgUpsellItems = 'CPG_UPSELL_ITEMS',
  DayOfOrdersEmail = 'DAY_OF_ORDERS_EMAIL',
  DdDeliveryNotes = 'DD_DELIVERY_NOTES',
  DefaultPlanUpdateEnabled = 'DEFAULT_PLAN_UPDATE_ENABLED',
  DeliveryCostDirectViaNash = 'DELIVERY_COST_DIRECT_VIA_NASH',
  DeliveryCostEmeraldCity = 'DELIVERY_COST_EMERALD_CITY',
  DeliveryCostEoe = 'DELIVERY_COST_EOE',
  DeliveryCostFarias = 'DELIVERY_COST_FARIAS',
  DeliveryCostFrayt = 'DELIVERY_COST_FRAYT',
  DeliveryCostFulflld = 'DELIVERY_COST_FULFLLD',
  DeliveryCostHungry = 'DELIVERY_COST_HUNGRY',
  DeliveryCostLalamove = 'DELIVERY_COST_LALAMOVE',
  DeliveryCostLogiscal = 'DELIVERY_COST_LOGISCAL',
  DeliveryCostNash = 'DELIVERY_COST_NASH',
  DeliveryCostVamo = 'DELIVERY_COST_VAMO',
  DisabledFixedIntervalTasks = 'DISABLED_FIXED_INTERVAL_TASKS',
  DisableAdminPages = 'DISABLE_ADMIN_PAGES',
  DishwasherApiUrl = 'DISHWASHER_API_URL',
  DishwasherEnabled = 'DISHWASHER_ENABLED',
  DishCreationV2 = 'DISH_CREATION_V2',
  DishFirstNavEnabled = 'DISH_FIRST_NAV_ENABLED',
  DishFirstV3Rollout = 'DISH_FIRST_V3_ROLLOUT',
  DoordashDeliverySms = 'DOORDASH_DELIVERY_SMS',
  DoorDashTip = 'DOOR_DASH_TIP',
  DoorToDoorDeliveryDiscount = 'DOOR_TO_DOOR_DELIVERY_DISCOUNT',
  DuplicateDishEnabled = 'DUPLICATE_DISH_ENABLED',
  DynamicShefSortingEnabled = 'DYNAMIC_SHEF_SORTING_ENABLED',
  EmailBlockList = 'EMAIL_BLOCK_LIST',
  EmailFoodItemChangesApproved = 'EMAIL_FOOD_ITEM_CHANGES_APPROVED',
  EmailFoodItemChangesRejected = 'EMAIL_FOOD_ITEM_CHANGES_REJECTED',
  EmailFoodItemCommentAdded = 'EMAIL_FOOD_ITEM_COMMENT_ADDED',
  EmailHeldOrderCanceled = 'EMAIL_HELD_ORDER_CANCELED',
  EmailLastAvailabilityReminder = 'EMAIL_LAST_AVAILABILITY_REMINDER',
  EmailMealPlanShefReplaced = 'EMAIL_MEAL_PLAN_SHEF_REPLACED',
  EmailMessageTransactionTask = 'EMAIL_MESSAGE_TRANSACTION_TASK',
  EmailOrderCancelled = 'EMAIL_ORDER_CANCELLED',
  EmailOrderRefunded = 'EMAIL_ORDER_REFUNDED',
  EmailOrderUpdated = 'EMAIL_ORDER_UPDATED',
  EmailReferralReward = 'EMAIL_REFERRAL_REWARD',
  EmailShefAvailabilityNotification = 'EMAIL_SHEF_AVAILABILITY_NOTIFICATION',
  EmailShefGiftCard = 'EMAIL_SHEF_GIFT_CARD',
  EmailTablerunDeliveryDay = 'EMAIL_TABLERUN_DELIVERY_DAY',
  EmailTablerunExistingCustomerIntroduction = 'EMAIL_TABLERUN_EXISTING_CUSTOMER_INTRODUCTION',
  EmailTablerunHeldOrderCanceled = 'EMAIL_TABLERUN_HELD_ORDER_CANCELED',
  EmailTablerunOrderReceipt = 'EMAIL_TABLERUN_ORDER_RECEIPT',
  EmailTablerunOrderRefunded = 'EMAIL_TABLERUN_ORDER_REFUNDED',
  EmailTablerunSubscriptionReceipt = 'EMAIL_TABLERUN_SUBSCRIPTION_RECEIPT',
  EmailTrialOrderCancelled = 'EMAIL_TRIAL_ORDER_CANCELLED',
  EmailWssProposalApproved = 'EMAIL_WSS_PROPOSAL_APPROVED',
  EmailWssProposalChangesRequested = 'EMAIL_WSS_PROPOSAL_CHANGES_REQUESTED',
  EmailWssProposalRejected = 'EMAIL_WSS_PROPOSAL_REJECTED',
  ExploreWeeklyShefServiceTabsEnabled = 'EXPLORE_WEEKLY_SHEF_SERVICE_TABS_ENABLED',
  ExpressCheckoutV1Enabled = 'EXPRESS_CHECKOUT_V1_ENABLED',
  FavoritesV2Enabled = 'FAVORITES_V2_ENABLED',
  FavoriteShefs = 'FAVORITE_SHEFS',
  FixedIntervalShefSocialDigest = 'FIXED_INTERVAL_SHEF_SOCIAL_DIGEST',
  FlexServingsPaymentEnabled = 'FLEX_SERVINGS_PAYMENT_ENABLED',
  FoodItemCompositeScoreEnabled = 'FOOD_ITEM_COMPOSITE_SCORE_ENABLED',
  FoodItemEmbeddingsTask = 'FOOD_ITEM_EMBEDDINGS_TASK',
  FoodItemMacrosEnabled = 'FOOD_ITEM_MACROS_ENABLED',
  FoodItemValidationActingUserId = 'FOOD_ITEM_VALIDATION_ACTING_USER_ID',
  FoodItemValidationActionMode = 'FOOD_ITEM_VALIDATION_ACTION_MODE',
  FoodItemValidationDismissalHidingEnabled = 'FOOD_ITEM_VALIDATION_DISMISSAL_HIDING_ENABLED',
  FoodItemValidationEnabled = 'FOOD_ITEM_VALIDATION_ENABLED',
  FoodItemValidationIssuesPageEnabled = 'FOOD_ITEM_VALIDATION_ISSUES_PAGE_ENABLED',
  FoodItemValidationPreviewEnabled = 'FOOD_ITEM_VALIDATION_PREVIEW_ENABLED',
  FoodItemValidationShefFormEnabled = 'FOOD_ITEM_VALIDATION_SHEF_FORM_ENABLED',
  ForYouPageEnabled = 'FOR_YOU_PAGE_ENABLED',
  FraudDetectionEnabled = 'FRAUD_DETECTION_ENABLED',
  FringeEnabledForShef = 'FRINGE_ENABLED_FOR_SHEF',
  FringeOverrideEnabled = 'FRINGE_OVERRIDE_ENABLED',
  GetNewFoodCommentMessagesTask = 'GET_NEW_FOOD_COMMENT_MESSAGES_TASK',
  GiftCardPurchaseEnabled = 'GIFT_CARD_PURCHASE_ENABLED',
  GiftCardRedemptionEnabled = 'GIFT_CARD_REDEMPTION_ENABLED',
  GooglePay = 'GOOGLE_PAY',
  GroupOrderMutationsEnabled = 'GROUP_ORDER_MUTATIONS_ENABLED',
  GroupOrderTotalsEnabled = 'GROUP_ORDER_TOTALS_ENABLED',
  GroupOrderVerificationEnabled = 'GROUP_ORDER_VERIFICATION_ENABLED',
  HideHomepageOneTimeTxEnabled = 'HIDE_HOMEPAGE_ONE_TIME_TX_ENABLED',
  HolidayMenusEnabled = 'HOLIDAY_MENUS_ENABLED',
  HomepageRefreshEnabled = 'HOMEPAGE_REFRESH_ENABLED',
  ImpactComEnabled = 'IMPACT_COM_ENABLED',
  InlineStripeLinkEnabled = 'INLINE_STRIPE_LINK_ENABLED',
  IntakeHouseholdConsolidationV2Enabled = 'INTAKE_HOUSEHOLD_CONSOLIDATION_V2_ENABLED',
  IntakeOptimizationEnabled = 'INTAKE_OPTIMIZATION_ENABLED',
  IntakeSettingsBeforeCalendarEnabled = 'INTAKE_SETTINGS_BEFORE_CALENDAR_ENABLED',
  IntervalReviewReminderEnabled = 'INTERVAL_REVIEW_REMINDER_ENABLED',
  LeadCaptureModalEnabled = 'LEAD_CAPTURE_MODAL_ENABLED',
  LowCalHighProteinCollectionsEnabled = 'LOW_CAL_HIGH_PROTEIN_COLLECTIONS_ENABLED',
  LowCalHighProteinMacroThresholdEnabled = 'LOW_CAL_HIGH_PROTEIN_MACRO_THRESHOLD_ENABLED',
  LpDishStoriesEnabled = 'LP_DISH_STORIES_ENABLED',
  LpFactorCompEnabled = 'LP_FACTOR_COMP_ENABLED',
  LpFullBleedVideoEnabled = 'LP_FULL_BLEED_VIDEO_ENABLED',
  LpHowItWorksEnabled = 'LP_HOW_IT_WORKS_ENABLED',
  LpLocalDallasEnabled = 'LP_LOCAL_DALLAS_ENABLED',
  LpLocalHoustonEnabled = 'LP_LOCAL_HOUSTON_ENABLED',
  LpRefreshLongtailEnabled = 'LP_REFRESH_LONGTAIL_ENABLED',
  LpRefreshV3Enabled = 'LP_REFRESH_V3_ENABLED',
  LunchCategoriesEnabled = 'LUNCH_CATEGORIES_ENABLED',
  MarketplaceVariableServiceFeeEnabled = 'MARKETPLACE_VARIABLE_SERVICE_FEE_ENABLED',
  MealPlansAllergensEnabled = 'MEAL_PLANS_ALLERGENS_ENABLED',
  MealPlansBrowseAsGuest = 'MEAL_PLANS_BROWSE_AS_GUEST',
  MealPlansEnabled = 'MEAL_PLANS_ENABLED',
  MealPlanAddOnsEnabled = 'MEAL_PLAN_ADD_ONS_ENABLED',
  MealPlanAvsValidationEnabled = 'MEAL_PLAN_AVS_VALIDATION_ENABLED',
  MealPlanCheckoutAddOnsEnabled = 'MEAL_PLAN_CHECKOUT_ADD_ONS_ENABLED',
  MealPlanCheckoutRevampV1Enabled = 'MEAL_PLAN_CHECKOUT_REVAMP_V1_ENABLED',
  MealPlanDeliveryDayStartOverride = 'MEAL_PLAN_DELIVERY_DAY_START_OVERRIDE',
  MealPlanDiscountFieldEnabled = 'MEAL_PLAN_DISCOUNT_FIELD_ENABLED',
  MealPlanGiftCardsEnabled = 'MEAL_PLAN_GIFT_CARDS_ENABLED',
  MealPlanHubBasedSupplyEnabled = 'MEAL_PLAN_HUB_BASED_SUPPLY_ENABLED',
  MealPlanPaymentElementOnAccountEnabled = 'MEAL_PLAN_PAYMENT_ELEMENT_ON_ACCOUNT_ENABLED',
  MealPlanPersonalizationWeights = 'MEAL_PLAN_PERSONALIZATION_WEIGHTS',
  MealPlanRecurringTipEnabled = 'MEAL_PLAN_RECURRING_TIP_ENABLED',
  MealPlanSearchEnabled = 'MEAL_PLAN_SEARCH_ENABLED',
  MealPlanSetupIntentEnabled = 'MEAL_PLAN_SETUP_INTENT_ENABLED',
  MealPlanTippingEnabled = 'MEAL_PLAN_TIPPING_ENABLED',
  MealPlanTipChargingEnabled = 'MEAL_PLAN_TIP_CHARGING_ENABLED',
  MerchandiseTagsEnabled = 'MERCHANDISE_TAGS_ENABLED',
  MultiOrderSameDayFreeShipping = 'MULTI_ORDER_SAME_DAY_FREE_SHIPPING',
  NativeShefApplicationQuestionnaire = 'NATIVE_SHEF_APPLICATION_QUESTIONNAIRE',
  NewExploreWssNonSubTabEnabled = 'NEW_EXPLORE_WSS_NON_SUB_TAB_ENABLED',
  NewReferralValuesEnabled = 'NEW_REFERRAL_VALUES_ENABLED',
  OrderDayOfEmailDd = 'ORDER_DAY_OF_EMAIL_DD',
  OrderDayOfEmailNotDd = 'ORDER_DAY_OF_EMAIL_NOT_DD',
  OrderDayOfEmailPickup = 'ORDER_DAY_OF_EMAIL_PICKUP',
  PhonesBannedFromUsingPromos = 'PHONES_BANNED_FROM_USING_PROMOS',
  PhoneBlacklist = 'PHONE_BLACKLIST',
  PickupAddressEnabled = 'PICKUP_ADDRESS_ENABLED',
  PricingExperimentEnabled = 'PRICING_EXPERIMENT_ENABLED',
  ProfileDeliveryAddressesEnabled = 'PROFILE_DELIVERY_ADDRESSES_ENABLED',
  ProfilePaymentMethodsEnabled = 'PROFILE_PAYMENT_METHODS_ENABLED',
  RateRecentOrderPopupEnabled = 'RATE_RECENT_ORDER_POPUP_ENABLED',
  RegionalCusineDenyLists = 'REGIONAL_CUSINE_DENY_LISTS',
  RequestAppReviewsEnabled = 'REQUEST_APP_REVIEWS_ENABLED',
  ReusablePackagingBayAreaEnabled = 'REUSABLE_PACKAGING_BAY_AREA_ENABLED',
  ReusablePackagingCleaningFeeEnabled = 'REUSABLE_PACKAGING_CLEANING_FEE_ENABLED',
  ReusablePackagingEnabled = 'REUSABLE_PACKAGING_ENABLED',
  ReusablePackagingLaEnabled = 'REUSABLE_PACKAGING_LA_ENABLED',
  ReusablePackagingNyEnabled = 'REUSABLE_PACKAGING_NY_ENABLED',
  ReusablePackagingSeaEnabled = 'REUSABLE_PACKAGING_SEA_ENABLED',
  S2CCodeUsesPerUser = 'S2C_CODE_USES_PER_USER',
  S2CCodeValue = 'S2C_CODE_VALUE',
  S2CRewardValue = 'S2C_REWARD_VALUE',
  SameDeliveryDayPromoId = 'SAME_DELIVERY_DAY_PROMO_ID',
  SameDeliveryDayRetainedUsersPromoId = 'SAME_DELIVERY_DAY_RETAINED_USERS_PROMO_ID',
  ShefApplicationAlwaysEnableContinueInformationSessionVideo = 'SHEF_APPLICATION_ALWAYS_ENABLE_CONTINUE_INFORMATION_SESSION_VIDEO',
  ShefApplicationReceivedEmail = 'SHEF_APPLICATION_RECEIVED_EMAIL',
  ShefChargeCollectionEnabled = 'SHEF_CHARGE_COLLECTION_ENABLED',
  ShefCompositeScoreEnabled = 'SHEF_COMPOSITE_SCORE_ENABLED',
  ShefDashboardBanner = 'SHEF_DASHBOARD_BANNER',
  ShefDashboardInsights = 'SHEF_DASHBOARD_INSIGHTS',
  ShefDishCreationUpdates = 'SHEF_DISH_CREATION_UPDATES',
  ShefExtraAvailabilityEnabled = 'SHEF_EXTRA_AVAILABILITY_ENABLED',
  ShefGrowYourBusinessEnabled = 'SHEF_GROW_YOUR_BUSINESS_ENABLED',
  ShefInsightsReportEnabled = 'SHEF_INSIGHTS_REPORT_ENABLED',
  ShefMenuChecklistEnabled = 'SHEF_MENU_CHECKLIST_ENABLED',
  ShefMerchLandingEnabled = 'SHEF_MERCH_LANDING_ENABLED',
  ShefOnboardingRedesign = 'SHEF_ONBOARDING_REDESIGN',
  ShefPayoutImprovementsEnabled = 'SHEF_PAYOUT_IMPROVEMENTS_ENABLED',
  ShefPayoutTiersEnabled = 'SHEF_PAYOUT_TIERS_ENABLED',
  ShefPlatformUsageQuestionnaire = 'SHEF_PLATFORM_USAGE_QUESTIONNAIRE',
  ShefPostsEnabled = 'SHEF_POSTS_ENABLED',
  ShefProfileRedesign = 'SHEF_PROFILE_REDESIGN',
  ShefPromoCodeCreation = 'SHEF_PROMO_CODE_CREATION',
  ShefRating = 'SHEF_RATING',
  ShefRosterEnabled = 'SHEF_ROSTER_ENABLED',
  ShefSeasonalToolingEnabled = 'SHEF_SEASONAL_TOOLING_ENABLED',
  ShefSideCustomizations = 'SHEF_SIDE_CUSTOMIZATIONS',
  ShefSocialDigestTemplateId = 'SHEF_SOCIAL_DIGEST_TEMPLATE_ID',
  ShefToConsumerReferralTask = 'SHEF_TO_CONSUMER_REFERRAL_TASK',
  ShefUpcomingOrders = 'SHEF_UPCOMING_ORDERS',
  ShefVarietyToolingEnabled = 'SHEF_VARIETY_TOOLING_ENABLED',
  ShefZendesk = 'SHEF_ZENDESK',
  ShowManageMealPlans = 'SHOW_MANAGE_MEAL_PLANS',
  SidesCategoryCarouselEnabled = 'SIDES_CATEGORY_CAROUSEL_ENABLED',
  SidesPageSearchEnabled = 'SIDES_PAGE_SEARCH_ENABLED',
  SidesPairingPageEnabled = 'SIDES_PAIRING_PAGE_ENABLED',
  SignupAfterSplashEnabled = 'SIGNUP_AFTER_SPLASH_ENABLED',
  SignUpGateRedesignEnabled = 'SIGN_UP_GATE_REDESIGN_ENABLED',
  SignUpModalGatingDsEnabled = 'SIGN_UP_MODAL_GATING_DS_ENABLED',
  SmsMessageTransactionTask = 'SMS_MESSAGE_TRANSACTION_TASK',
  SubscriptionOrdersEnabled = 'SUBSCRIPTION_ORDERS_ENABLED',
  SubscriptionSignupEnabled = 'SUBSCRIPTION_SIGNUP_ENABLED',
  TablerunEmailFromAddress = 'TABLERUN_EMAIL_FROM_ADDRESS',
  TablerunEmailReplyToAddress = 'TABLERUN_EMAIL_REPLY_TO_ADDRESS',
  TablerunEnabled = 'TABLERUN_ENABLED',
  TablerunStorefrontEnabled = 'TABLERUN_STOREFRONT_ENABLED',
  TaskPaymentCaptureEnabled = 'TASK_PAYMENT_CAPTURE_ENABLED',
  TaskShefPayoutEnabled = 'TASK_SHEF_PAYOUT_ENABLED',
  UpsellsEnabled = 'UPSELLS_ENABLED',
  VariableServiceFeeEnabled = 'VARIABLE_SERVICE_FEE_ENABLED',
  WssCuisineCarouselEnabled = 'WSS_CUISINE_CAROUSEL_ENABLED',
  WssCuisineCarouselEnabledInApp = 'WSS_CUISINE_CAROUSEL_ENABLED_IN_APP',
  WssCuisineCarouselV3Enabled = 'WSS_CUISINE_CAROUSEL_V3_ENABLED',
  WssDessertsEnabled = 'WSS_DESSERTS_ENABLED',
  WssDessertProposalsEnabled = 'WSS_DESSERT_PROPOSALS_ENABLED',
  WssDishImageZoomEnabled = 'WSS_DISH_IMAGE_ZOOM_ENABLED',
  WssFlexibleServingsEnabled = 'WSS_FLEXIBLE_SERVINGS_ENABLED',
  WssFlexibleServingsV2Enabled = 'WSS_FLEXIBLE_SERVINGS_V2_ENABLED',
  WssInfluencerReusableDepositWaivedByEmail = 'WSS_INFLUENCER_REUSABLE_DEPOSIT_WAIVED_BY_EMAIL',
  WssOrganicTagsEnabled = 'WSS_ORGANIC_TAGS_ENABLED',
  WssReassignOnShefUnavailable = 'WSS_REASSIGN_ON_SHEF_UNAVAILABLE',
  WssReusableOptInEnabled = 'WSS_REUSABLE_OPT_IN_ENABLED',
  WssSteelConsolidationEnabled = 'WSS_STEEL_CONSOLIDATION_ENABLED',
  ZendeskTextTask = 'ZENDESK_TEXT_TASK'
}

export type FilteredFoodItemResults = {
  __typename?: 'FilteredFoodItemResults';
  partialMatches: Array<FoodItem>;
  perfectMatches: Array<FoodItem>;
};

export enum FlaggableIngredient {
  Avocado = 'avocado',
  Beef = 'beef',
  BellPepper = 'bellPepper',
  Cilantro = 'cilantro',
  Dairy = 'dairy',
  Eggs = 'eggs',
  Garlic = 'garlic',
  Gluten = 'gluten',
  Mushrooms = 'mushrooms',
  Nuts = 'nuts',
  Onions = 'onions',
  Pork = 'pork',
  Sesame = 'sesame',
  Shellfish = 'shellfish',
  Soy = 'soy'
}

export type FlaggableIngredientStatus = {
  __typename?: 'FlaggableIngredientStatus';
  dismissedAt?: Maybe<Scalars['Date']['output']>;
  ingredient: FlaggableIngredient;
  isHiddenFromEaters: Scalars['Boolean']['output'];
};

export type FoodItem = {
  __typename?: 'FoodItem';
  allowMacroOverride?: Maybe<Scalars['Boolean']['output']>;
  availability: Array<FoodItemAvailability>;
  availableFriday: Scalars['Boolean']['output'];
  availableMonday: Scalars['Boolean']['output'];
  availableSaturday: Scalars['Boolean']['output'];
  availableSunday: Scalars['Boolean']['output'];
  availableThursday: Scalars['Boolean']['output'];
  availableTuesday: Scalars['Boolean']['output'];
  availableWednesday: Scalars['Boolean']['output'];
  averageRating: Scalars['Int']['output'];
  bundleFoodItemIds?: Maybe<Array<Scalars['Int']['output']>>;
  bundleFoodItems2?: Maybe<Array<BundleFoodItem>>;
  capacity?: Maybe<Scalars['Int']['output']>;
  childrenPrefabFoodItems: Array<FoodItem>;
  containers: Array<FoodItemContainer>;
  containsEggs: Scalars['Boolean']['output'];
  containsNuts: Scalars['Boolean']['output'];
  containsShellfish: Scalars['Boolean']['output'];
  containsSoy: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuisineCategories: Array<CuisineCategory>;
  cuisineCategoryIds: Array<Scalars['String']['output']>;
  customIngredientsFlagged: Array<Scalars['String']['output']>;
  customizations?: Maybe<Array<FoodItemCustomization>>;
  dairyFree: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountForTakeRateShiftExperiment: Scalars['Float']['output'];
  endDate: Scalars['String']['output'];
  findings?: Maybe<Array<FoodItemFinding>>;
  firstApprovedAt?: Maybe<Scalars['Date']['output']>;
  flexibleSidesMinServings?: Maybe<Scalars['Int']['output']>;
  foodItemPairIds: Array<Scalars['Int']['output']>;
  foodType?: Maybe<FoodType>;
  glutenFree: Scalars['Boolean']['output'];
  holiday?: Maybe<Holiday>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  ingredientsFlagged: Array<FlaggableIngredient>;
  isFavorited: Scalars['Boolean']['output'];
  isFlexibleSides?: Maybe<Scalars['Boolean']['output']>;
  isHalal: Scalars['Boolean']['output'];
  isMainsPlusSides?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  isOrganic: Scalars['Boolean']['output'];
  isPopular?: Maybe<Scalars['Boolean']['output']>;
  isSeedOilFree?: Maybe<Scalars['Boolean']['output']>;
  isSoldOut: Scalars['Boolean']['output'];
  keto?: Maybe<Scalars['Boolean']['output']>;
  kosher?: Maybe<Scalars['Boolean']['output']>;
  lastPurchasedAt?: Maybe<Scalars['Date']['output']>;
  lowFodmap?: Maybe<Scalars['Boolean']['output']>;
  lowSodium?: Maybe<Scalars['Boolean']['output']>;
  macroContext?: Maybe<Scalars['String']['output']>;
  macros?: Maybe<FoodItemMacros>;
  mealPlanFoodType?: Maybe<MealPlanFoodType>;
  menuAssignment?: Maybe<FoodItemMenuAssignment>;
  merchandisingTags: Array<MerchandisingTag>;
  mktpStatus?: Maybe<MktpStatus>;
  mostRecentOpenChangeRequest?: Maybe<FoodItemChangeRequest>;
  name?: Maybe<Scalars['String']['output']>;
  needsSide?: Maybe<Scalars['Boolean']['output']>;
  numDaysBeforeExpires: Scalars['Int']['output'];
  numLabels?: Maybe<Scalars['Int']['output']>;
  numServings?: Maybe<Scalars['Int']['output']>;
  orderRoute?: Maybe<Scalars['String']['output']>;
  packaging: Packaging;
  pairings: Array<FoodItem>;
  paleo?: Maybe<Scalars['Boolean']['output']>;
  parentPrefabFoodItem?: Maybe<FoodItem>;
  portion?: Maybe<Scalars['String']['output']>;
  prefabFoodItemId?: Maybe<Scalars['Int']['output']>;
  prefabStats?: Maybe<PrefabFoodItemStats>;
  prepInstructions?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  ratingCount: Scalars['Int']['output'];
  resizedImageUrl?: Maybe<Scalars['String']['output']>;
  servingSize?: Maybe<Scalars['String']['output']>;
  servingSizeCustomizations?: Maybe<Array<FoodItemCustomization>>;
  shef: PublicShef;
  sideCategories: Array<SideCategory>;
  sideCategoryIds: Array<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  spiceLevel: Scalars['Int']['output'];
  spiceLevelCustomizations?: Maybe<Array<FoodItemCustomization>>;
  startDate: Scalars['String']['output'];
  status: FoodItemStatus;
  tags?: Maybe<Array<DishTag>>;
  topPositiveTags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  upsell?: Maybe<Upsell>;
  /**
   * `upsellTierId` is included only for the purpose of editing a food item in the admin panel.
   * It is used to create a foodItemUpsellTier record in the database and not stored on the FoodItem model.
   */
  upsellTierId?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  whole30?: Maybe<Scalars['Boolean']['output']>;
  wssMenuStatus?: Maybe<WssMenuStatus>;
};


export type FoodItemAvailabilityArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};


export type FoodItemChildrenPrefabFoodItemsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FoodItemCustomIngredientsFlaggedArgs = {
  customAvoidedIngredients?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type FoodItemFindingsArgs = {
  filter?: InputMaybe<FoodItemFindingsFilterInput>;
};


export type FoodItemIngredientsFlaggedArgs = {
  replacementDietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type FoodItemIsSoldOutArgs = {
  filters: ExploreSegmentsFilterInput;
};


export type FoodItemMerchandisingTagsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  hasKids?: InputMaybe<Scalars['Boolean']['input']>;
  isOnCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type FoodItemResizedImageUrlArgs = {
  width: Scalars['Int']['input'];
};

export type FoodItemAvailability = {
  __typename?: 'FoodItemAvailability';
  availabilityDate: Scalars['DateTime']['output'];
  numAvailable?: Maybe<Scalars['Int']['output']>;
};

export type FoodItemCapacityForDeliveryDate = {
  __typename?: 'FoodItemCapacityForDeliveryDate';
  capacity: Scalars['Int']['output'];
  foodItemId: Scalars['Int']['output'];
};

export type FoodItemChangeRequest = {
  __typename?: 'FoodItemChangeRequest';
  changesets: Array<FoodItemChangeset>;
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  comments: Array<FoodItemChangeRequestComment>;
  context?: Maybe<OriginalContextView>;
  createdAt: Scalars['DateTime']['output'];
  foodItem: FoodItem;
  id: Scalars['Int']['output'];
  lastUpdatedBy: User;
  mergedContext?: Maybe<FoodItemChangeRequestContext>;
  photoEditCompleted: Scalars['Boolean']['output'];
  status: RequestStatus;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type FoodItemChangeRequestComment = {
  __typename?: 'FoodItemChangeRequestComment';
  changeRequest: FoodItemChangeRequest;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  user: User;
};

export type FoodItemChangeRequestContext = {
  __typename?: 'FoodItemChangeRequestContext';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  changesets: Array<FoodItemChangeRequestContextChangeset>;
  components?: Maybe<Scalars['String']['output']>;
  cookingMethod?: Maybe<Scalars['String']['output']>;
  flavorProfile?: Maybe<Scalars['String']['output']>;
  foodItemChangeRequestId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  reason?: Maybe<ProposedDishReason>;
};

export type FoodItemChangeRequestContextChangeset = {
  __typename?: 'FoodItemChangeRequestContextChangeset';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  components?: Maybe<Scalars['String']['output']>;
  cookingMethod?: Maybe<Scalars['String']['output']>;
  flavorProfile?: Maybe<Scalars['String']['output']>;
  foodItemChangeRequestContextId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  reason?: Maybe<ProposedDishReason>;
};

export type FoodItemChangeRequestContextInput = {
  additionalInfo?: InputMaybe<Scalars['String']['input']>;
  components?: InputMaybe<Scalars['String']['input']>;
  cookingMethod?: InputMaybe<Scalars['String']['input']>;
  flavorProfile?: InputMaybe<Scalars['String']['input']>;
  reason: ProposedDishReason;
};

export type FoodItemChangeRequestResults = {
  __typename?: 'FoodItemChangeRequestResults';
  changeRequests: Array<FoodItemChangeRequest>;
  pagination: Pagination;
};

export type FoodItemChangeset = {
  __typename?: 'FoodItemChangeset';
  allowMacroOverride?: Maybe<Scalars['Boolean']['output']>;
  availableFriday?: Maybe<Scalars['Boolean']['output']>;
  availableMonday?: Maybe<Scalars['Boolean']['output']>;
  availableSaturday?: Maybe<Scalars['Boolean']['output']>;
  availableSunday?: Maybe<Scalars['Boolean']['output']>;
  availableThursday?: Maybe<Scalars['Boolean']['output']>;
  availableTuesday?: Maybe<Scalars['Boolean']['output']>;
  availableWednesday?: Maybe<Scalars['Boolean']['output']>;
  bundleFoodItemIds?: Maybe<Array<Scalars['Int']['output']>>;
  calories?: Maybe<Scalars['Int']['output']>;
  capacity?: Maybe<Scalars['Int']['output']>;
  changeRequest: FoodItemChangeRequest;
  containsEggs?: Maybe<Scalars['Boolean']['output']>;
  containsNuts?: Maybe<Scalars['Boolean']['output']>;
  containsShellfish?: Maybe<Scalars['Boolean']['output']>;
  containsSoy?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customizations?: Maybe<Array<FoodItemCustomization>>;
  dairyFree?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dietaryFiber?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  flexibleSidesMinServings?: Maybe<Scalars['Int']['output']>;
  foodType?: Maybe<FoodType>;
  glutenFree?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  ingredients?: Maybe<Scalars['String']['output']>;
  isFlexibleSides?: Maybe<Scalars['Boolean']['output']>;
  isHalal?: Maybe<Scalars['Boolean']['output']>;
  isMarketplace?: Maybe<Scalars['Boolean']['output']>;
  isOrganic?: Maybe<Scalars['Boolean']['output']>;
  isSeedOilFree?: Maybe<Scalars['Boolean']['output']>;
  keto?: Maybe<Scalars['Boolean']['output']>;
  kosher?: Maybe<Scalars['Boolean']['output']>;
  lowFodmap?: Maybe<Scalars['Boolean']['output']>;
  lowSodium?: Maybe<Scalars['Boolean']['output']>;
  macroContext?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  needsSide?: Maybe<Scalars['Boolean']['output']>;
  numDaysBeforeExpires?: Maybe<Scalars['Int']['output']>;
  numLabels?: Maybe<Scalars['Int']['output']>;
  numServings?: Maybe<Scalars['Int']['output']>;
  packaging?: Maybe<Packaging>;
  paleo?: Maybe<Scalars['Boolean']['output']>;
  portion?: Maybe<Scalars['String']['output']>;
  prepInstructions?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  protein?: Maybe<Scalars['Int']['output']>;
  servingSize?: Maybe<Scalars['String']['output']>;
  servingSizeCustomizations?: Maybe<Array<FoodItemCustomization>>;
  sodium?: Maybe<Scalars['Int']['output']>;
  spiceLevel?: Maybe<Scalars['Int']['output']>;
  spiceLevelCustomizations?: Maybe<Array<FoodItemCustomization>>;
  startDate?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<DishTag>>;
  totalCarbohydrate?: Maybe<Scalars['Int']['output']>;
  totalFat?: Maybe<Scalars['Int']['output']>;
  totalSugars?: Maybe<Scalars['Int']['output']>;
  upsellTierId?: Maybe<Scalars['Int']['output']>;
  user: User;
  vegan?: Maybe<Scalars['Boolean']['output']>;
  vegetarian?: Maybe<Scalars['Boolean']['output']>;
  whole30?: Maybe<Scalars['Boolean']['output']>;
};

export type FoodItemChangesetCustomizationInput = {
  customizationTypeId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['String']['input']>;
  priceFactor: Scalars['Int']['input'];
  priceFactorType: PriceFactorType;
};

export type FoodItemChangesetInput = {
  allowMacroOverride?: InputMaybe<Scalars['Boolean']['input']>;
  availableFriday?: InputMaybe<Scalars['Boolean']['input']>;
  availableMonday?: InputMaybe<Scalars['Boolean']['input']>;
  availableSaturday?: InputMaybe<Scalars['Boolean']['input']>;
  availableSunday?: InputMaybe<Scalars['Boolean']['input']>;
  availableThursday?: InputMaybe<Scalars['Boolean']['input']>;
  availableTuesday?: InputMaybe<Scalars['Boolean']['input']>;
  availableWednesday?: InputMaybe<Scalars['Boolean']['input']>;
  calories?: InputMaybe<Scalars['Int']['input']>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  containsEggs?: InputMaybe<Scalars['Boolean']['input']>;
  containsNuts?: InputMaybe<Scalars['Boolean']['input']>;
  containsShellfish?: InputMaybe<Scalars['Boolean']['input']>;
  containsSoy?: InputMaybe<Scalars['Boolean']['input']>;
  cuisineCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customizations?: InputMaybe<Array<FoodItemChangesetCustomizationInput>>;
  dairyFree?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dietaryFiber?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  flexibleSidesMinServings?: InputMaybe<Scalars['Int']['input']>;
  foodItemPairIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  foodType?: InputMaybe<FoodType>;
  glutenFree?: InputMaybe<Scalars['Boolean']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isFlexibleSides?: InputMaybe<Scalars['Boolean']['input']>;
  isHalal?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganic?: InputMaybe<Scalars['Boolean']['input']>;
  isSeedOilFree?: InputMaybe<Scalars['Boolean']['input']>;
  keto?: InputMaybe<Scalars['Boolean']['input']>;
  kosher?: InputMaybe<Scalars['Boolean']['input']>;
  lowFodmap?: InputMaybe<Scalars['Boolean']['input']>;
  lowSodium?: InputMaybe<Scalars['Boolean']['input']>;
  macroContext?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  needsSide?: InputMaybe<Scalars['Boolean']['input']>;
  numDaysBeforeExpires?: InputMaybe<Scalars['Int']['input']>;
  numLabels?: InputMaybe<Scalars['Int']['input']>;
  numServings?: InputMaybe<Scalars['Int']['input']>;
  packaging?: InputMaybe<Packaging>;
  paleo?: InputMaybe<Scalars['Boolean']['input']>;
  portion?: InputMaybe<Scalars['String']['input']>;
  prefabFoodItemId?: InputMaybe<Scalars['Int']['input']>;
  prepInstructions?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  protein?: InputMaybe<Scalars['Float']['input']>;
  servingSize?: InputMaybe<Scalars['String']['input']>;
  sideCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sodium?: InputMaybe<Scalars['Int']['input']>;
  spiceLevel?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<DishTag>>;
  totalCarbohydrate?: InputMaybe<Scalars['Float']['input']>;
  totalFat?: InputMaybe<Scalars['Float']['input']>;
  totalSugars?: InputMaybe<Scalars['Float']['input']>;
  upsellTierId?: InputMaybe<Scalars['Int']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  whole30?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FoodItemContainer = {
  __typename?: 'FoodItemContainer';
  containerType: FoodItemContainerType;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export enum FoodItemContainerShape {
  Clamshell = 'CLAMSHELL',
  Other = 'OTHER',
  Rectangular = 'RECTANGULAR',
  Round = 'ROUND',
  Square = 'SQUARE'
}

export type FoodItemContainerType = {
  __typename?: 'FoodItemContainerType';
  capacityOz: Scalars['Float']['output'];
  displayName: Scalars['String']['output'];
  heightInches: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  lengthInches: Scalars['Float']['output'];
  shape: FoodItemContainerShape;
  widthInches: Scalars['Float']['output'];
};

export type FoodItemCustomization = {
  __typename?: 'FoodItemCustomization';
  customizationType: FoodItemCustomizationType;
  customizationTypeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  portion?: Maybe<Scalars['String']['output']>;
  priceFactor: Scalars['Int']['output'];
  priceFactorType: PriceFactorType;
};

export type FoodItemCustomizationType = {
  __typename?: 'FoodItemCustomizationType';
  category: CustomizationCategory;
  dataType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FoodItemDraftValidation = {
  __typename?: 'FoodItemDraftValidation';
  arePersisted: Scalars['Boolean']['output'];
  drafts: Array<FoodItemFindingDraft>;
  erroredRuleIds: Array<Scalars['String']['output']>;
  findings: Array<FoodItemFinding>;
  foodItemId: Scalars['Int']['output'];
  ranRuleIds: Array<Scalars['String']['output']>;
};

export type FoodItemFavoriteMutationResponse = MutationResponse & {
  __typename?: 'FoodItemFavoriteMutationResponse';
  foodItem?: Maybe<FoodItem>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FoodItemFinding = {
  __typename?: 'FoodItemFinding';
  cause: Scalars['String']['output'];
  confidence: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  dismissalCta?: Maybe<Scalars['String']['output']>;
  dismissedAt?: Maybe<Scalars['Date']['output']>;
  errorMessage: Scalars['String']['output'];
  foodItem: FoodItem;
  foodItemField: Scalars['String']['output'];
  foodItemId: Scalars['Int']['output'];
  hiddenFromUI: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  primaryCta: Scalars['String']['output'];
  replacementValue?: Maybe<Scalars['JSON']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  ruleId: Scalars['String']['output'];
  ruleName: FoodItemFindingRuleName;
  secondaryCta?: Maybe<Scalars['String']['output']>;
  severity: Scalars['Int']['output'];
  version: Scalars['Int']['output'];
};

export type FoodItemFindingDraft = {
  __typename?: 'FoodItemFindingDraft';
  cause: Scalars['String']['output'];
  confidence: Scalars['Int']['output'];
  dismissalCta?: Maybe<Scalars['String']['output']>;
  errorMessage: Scalars['String']['output'];
  foodItemField: Scalars['String']['output'];
  hiddenFromUI: Scalars['Boolean']['output'];
  primaryCta: Scalars['String']['output'];
  replacementValue?: Maybe<Scalars['JSON']['output']>;
  ruleId: Scalars['String']['output'];
  ruleName: FoodItemFindingRuleName;
  secondaryCta?: Maybe<Scalars['String']['output']>;
  severity: Scalars['Int']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type FoodItemFindingRuleCount = {
  __typename?: 'FoodItemFindingRuleCount';
  count: Scalars['Int']['output'];
  ruleId: Scalars['String']['output'];
  ruleName: FoodItemFindingRuleName;
};

export enum FoodItemFindingRuleName {
  DisallowedText = 'DISALLOWED_TEXT',
  IncorrectAllergenFlag = 'INCORRECT_ALLERGEN_FLAG',
  IncorrectDietTag = 'INCORRECT_DIET_TAG',
  MissingAllergenFlag = 'MISSING_ALLERGEN_FLAG',
  MissingCuisineTag = 'MISSING_CUISINE_TAG',
  MissingDietTag = 'MISSING_DIET_TAG',
  MissingIngredients = 'MISSING_INGREDIENTS',
  MissingProtein = 'MISSING_PROTEIN',
  ShortDescription = 'SHORT_DESCRIPTION',
  VeganImpliesVegetarian = 'VEGAN_IMPLIES_VEGETARIAN'
}

export type FoodItemFindingsFilterInput = {
  confidences?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDraftFoodItems?: InputMaybe<Scalars['Boolean']['input']>;
  minConfidence?: InputMaybe<Scalars['Int']['input']>;
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  severities?: InputMaybe<Array<Scalars['Int']['input']>>;
  shefSearch?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ShefFindingStatus>;
};

export type FoodItemFindingsPreview = {
  __typename?: 'FoodItemFindingsPreview';
  erroredRuleIds: Array<Scalars['String']['output']>;
  findings: Array<FoodItemFindingDraft>;
  flaggableIngredients: Array<FlaggableIngredientStatus>;
  foodItemId: Scalars['Int']['output'];
  ranRuleIds: Array<Scalars['String']['output']>;
};

export type FoodItemFindingsResults = {
  __typename?: 'FoodItemFindingsResults';
  findings: Array<FoodItemFinding>;
  pagination: Pagination;
  ruleCounts: Array<FoodItemFindingRuleCount>;
};

export type FoodItemMacros = {
  __typename?: 'FoodItemMacros';
  calories: MacroValue;
  protein: MacroValue;
  sodium: MacroValue;
  totalCarbohydrate: MacroValue;
  totalFat: MacroValue;
};

export type FoodItemMenuAssignment = {
  __typename?: 'FoodItemMenuAssignment';
  assignmentType: MenuAssignmentType;
  effectiveFrom?: Maybe<Scalars['Date']['output']>;
  effectiveUntil?: Maybe<Scalars['Date']['output']>;
  foodItem?: Maybe<FoodItem>;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  season?: Maybe<Scalars['String']['output']>;
  seasonalWindowEnd?: Maybe<Scalars['String']['output']>;
  seasonalWindowStart?: Maybe<Scalars['String']['output']>;
  shefId: Scalars['String']['output'];
  windowEnd?: Maybe<Scalars['Date']['output']>;
  windowStart?: Maybe<Scalars['Date']['output']>;
};

export type FoodItemPopularity = {
  __typename?: 'FoodItemPopularity';
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numThumbsDown: Scalars['Int']['output'];
  numThumbsNeutral: Scalars['Int']['output'];
  numThumbsUp: Scalars['Int']['output'];
  tags?: Maybe<Array<FoodItemTagFrequency>>;
};

export type FoodItemPopularityResult = {
  __typename?: 'FoodItemPopularityResult';
  results: Array<FoodItemPopularity>;
};

export type FoodItemPriceRecommendationInput = {
  dishName: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  foodType: FoodType;
  servingSize: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
};

export type FoodItemPriceRecommendationResult = {
  __typename?: 'FoodItemPriceRecommendationResult';
  lowerPriceRange: Scalars['Int']['output'];
  recommendedPrice: Scalars['Int']['output'];
  upperPriceRange: Scalars['Int']['output'];
};

export type FoodItemQuantity = {
  __typename?: 'FoodItemQuantity';
  id: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type FoodItemRating = {
  __typename?: 'FoodItemRating';
  comment?: Maybe<Scalars['String']['output']>;
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  ratingPercent?: Maybe<Scalars['Int']['output']>;
  shefId: Scalars['String']['output'];
  tags?: Maybe<Array<FoodItemRatingTag>>;
  userId: Scalars['String']['output'];
};

export type FoodItemRatingInput = {
  foodItemId: Scalars['Int']['input'];
  ratingPercent?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type FoodItemRatingTag = {
  __typename?: 'FoodItemRatingTag';
  foodItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  shefId: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type FoodItemResults = {
  __typename?: 'FoodItemResults';
  foodItems: Array<FoodItem>;
  pagination: Pagination;
};

export enum FoodItemStatus {
  Approved = 'APPROVED',
  Deleted = 'DELETED',
  Draft = 'DRAFT'
}

export type FoodItemTagFrequency = {
  __typename?: 'FoodItemTagFrequency';
  count: Scalars['Int']['output'];
  isPositive: Scalars['Boolean']['output'];
  tag: Scalars['String']['output'];
};

export type FoodItemTags = {
  foodItemId: Scalars['Int']['input'];
  score: Scalars['Int']['input'];
  tagId: Scalars['String']['input'];
};

export type FoodItemValidationDraftInput = {
  containsEggs?: InputMaybe<Scalars['Boolean']['input']>;
  containsNuts?: InputMaybe<Scalars['Boolean']['input']>;
  containsShellfish?: InputMaybe<Scalars['Boolean']['input']>;
  containsSoy?: InputMaybe<Scalars['Boolean']['input']>;
  cuisineCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dairyFree?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  foodType?: InputMaybe<FoodType>;
  glutenFree?: InputMaybe<Scalars['Boolean']['input']>;
  ingredients?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['String']['input']>;
  prepInstructions?: InputMaybe<Scalars['String']['input']>;
  servingSize?: InputMaybe<Scalars['String']['input']>;
  vegan?: InputMaybe<Scalars['Boolean']['input']>;
  vegetarian?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum FoodType {
  Appetizer = 'appetizer',
  Beverage = 'beverage',
  Dessert = 'dessert',
  DessertMulti = 'dessertMulti',
  Drink = 'drink',
  Kids = 'kids',
  KidsMain = 'kidsMain',
  KidsSnack = 'kidsSnack',
  Lunch = 'lunch',
  Main = 'main',
  Side = 'side',
  Snack = 'snack',
  Staple = 'staple'
}

export enum FoodTypeCoalesced {
  Dessert = 'DESSERT',
  Main = 'MAIN',
  Side = 'SIDE'
}

export type FreeDeliveryModal = {
  __typename?: 'FreeDeliveryModal';
  enabled: Scalars['Boolean']['output'];
  isNashShef: Scalars['Boolean']['output'];
};

export type FulfillmentInput = {
  addressInput?: InputMaybe<AddressInput>;
  fulfillmentOption?: InputMaybe<Scalars['String']['input']>;
  timeWindowsSelectedByShef: Array<Scalars['Int']['input']>;
};

export type GeoConfigInput = {
  fridayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  mondayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  saturdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  sundayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  type: GeoInputType;
  wednesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GeoInputType {
  Hub = 'HUB',
  Region = 'REGION',
  Zip = 'ZIP'
}

export type GetForYouMealPlanCollectionsResponse = QueryResponse & {
  __typename?: 'GetForYouMealPlanCollectionsResponse';
  collections: Array<MealPlanCollection>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetMealPlanAddOnCollectionsResponse = QueryResponse & {
  __typename?: 'GetMealPlanAddOnCollectionsResponse';
  collections: Array<MealPlanCategory>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetMealPlanDeliveryDaysOfWeekInput = {
  zipCode: Scalars['String']['input'];
};

export type GetMealPlanDeliveryDaysOfWeekResponse = QueryResponse & {
  __typename?: 'GetMealPlanDeliveryDaysOfWeekResponse';
  deliveryDOWs: Array<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetMealPlanShefsResults = {
  __typename?: 'GetMealPlanShefsResults';
  message: Scalars['String']['output'];
  shefs: Array<PublicShef>;
  success: Scalars['Boolean']['output'];
};

export type GetMealPlanTypeOptionsResponse = {
  __typename?: 'GetMealPlanTypeOptionsResponse';
  isInPricingExperimentTreatment: Scalars['Boolean']['output'];
  mealPlanPricingExperimentName?: Maybe<Scalars['String']['output']>;
  options: Array<MealPlanTypeOption>;
};

export type GetMealPlanUpcomingOrderInput = {
  userId: Scalars['String']['input'];
};

export type GetMealPlanUpcomingOrderResponse = QueryResponse & {
  __typename?: 'GetMealPlanUpcomingOrderResponse';
  mealPlanUpcomingOrder?: Maybe<MealPlanUpcomingOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetRemainingGiftCardBalanceForGroupOrderInput = {
  groupOrderId: Scalars['String']['input'];
};

export type GetRemainingGiftCardBalanceForGroupOrderResponse = QueryResponse & {
  __typename?: 'GetRemainingGiftCardBalanceForGroupOrderResponse';
  message: Scalars['String']['output'];
  remainingBalance: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetShefRosterResponse = QueryResponse & {
  __typename?: 'GetShefRosterResponse';
  message: Scalars['String']['output'];
  shefs: Array<PublicShef>;
  success: Scalars['Boolean']['output'];
};

export type GetTasteProfileInput = {
  userId: Scalars['String']['input'];
};

export type GetTasteProfileResponse = QueryResponse & {
  __typename?: 'GetTasteProfileResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tasteProfile?: Maybe<TasteProfile>;
};

export type GetUpcomingMealPlanGroupOrdersInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type GetUpcomingMealPlanGroupOrdersResponse = QueryResponse & {
  __typename?: 'GetUpcomingMealPlanGroupOrdersResponse';
  groupOrders?: Maybe<Array<GroupOrder>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GetValidCartForUserInput = {
  cartFoodItems?: InputMaybe<Array<MealPlanItem>>;
  deliveryDate: Scalars['String']['input'];
  dietType: DietType;
  isFlexServings?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanTypeId: Scalars['Int']['input'];
  menuDietaryRestrictions?: InputMaybe<Array<DietaryRestriction>>;
  zipCode: Scalars['String']['input'];
};

export type GetValidCartForUserResponse = QueryResponse & {
  __typename?: 'GetValidCartForUserResponse';
  cartFoodItems?: Maybe<Array<CartFoodItem>>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type GroupOrder = {
  __typename?: 'GroupOrder';
  addOnItems: Array<OrderAddOnItem>;
  canReviewOrder: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dayOfEmailScheduledTaskId?: Maybe<Scalars['Int']['output']>;
  delivery?: Maybe<Delivery>;
  deliveryAddress: Address;
  deliveryAddressId: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  deliveryId?: Maybe<Scalars['String']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  deliveryType: Scalars['String']['output'];
  formattedId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isCancelled: Scalars['Boolean']['output'];
  /**
   * True when refunded orders in the group only have placeholder refunds (no money exchanged).
   * Applies to fully-refunded and mixed HELD+REFUNDED groups. Still editable before cutoff.
   */
  isEditableAfterRefund: Scalars['Boolean']['output'];
  isFullyRefunded: Scalars['Boolean']['output'];
  isPartiallyRefunded: Scalars['Boolean']['output'];
  isSkipped: Scalars['Boolean']['output'];
  mealPlanId?: Maybe<Scalars['String']['output']>;
  mealPlanPromoCodeApplied?: Maybe<PromoCode>;
  mealPlanType?: Maybe<MealPlanType>;
  mealPlanTypeId?: Maybe<Scalars['String']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  orderTotals: ConsumerOrderTotal;
  orderType: OrderType;
  orders: Array<Order>;
  phone: Scalars['String']['output'];
  pickupAddress?: Maybe<Address>;
  pickupAddressId?: Maybe<Scalars['Int']['output']>;
  pickupDeliveryId?: Maybe<Scalars['Int']['output']>;
  promoCodes: Array<PromoCode>;
  refunds: Array<Refund>;
  regionId?: Maybe<Scalars['Int']['output']>;
  review: GroupOrderReview;
  skippedAt?: Maybe<Scalars['DateTime']['output']>;
  subscriptionInvoiceId?: Maybe<Scalars['String']['output']>;
  timeWindow: OrderTimeWindow;
  timeWindowId?: Maybe<Scalars['Int']['output']>;
  transactions: Array<Transaction>;
  user: User;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type GroupOrderConnection = {
  __typename?: 'GroupOrderConnection';
  edges: Array<GroupOrderEdge>;
  pageInfo: PageInfo;
};

export enum GroupOrderCustomerRefundReason {
  CustomerCancelBeforeCutoff = 'CustomerCancelBeforeCutoff',
  /** @deprecated Use CustomerCancelBeforeCutoff instead */
  CustomerCanceledMealPlan = 'CustomerCanceledMealPlan',
  CustomerDidNotSpecify = 'CustomerDidNotSpecify',
  CustomerInitiatedForOneTime = 'CustomerInitiatedForOneTime',
  CustomerInitiatedForSubscription = 'CustomerInitiatedForSubscription',
  CustomerOrderError = 'CustomerOrderError',
  /** @deprecated Use PaymentErrorAtCutoff instead */
  CustomerPaymentFailed = 'CustomerPaymentFailed',
  CustomerScheduleConflict = 'CustomerScheduleConflict',
  CustomerUnappyWithPriorOrder = 'CustomerUnappyWithPriorOrder',
  Other = 'Other',
  PaymentErrorAtCutoff = 'PaymentErrorAtCutoff'
}

export enum GroupOrderDeliveryPartnerRefundReason {
  DoorDash = 'DoorDash',
  Dropoff = 'Dropoff',
  Fulflld = 'Fulflld',
  Nash = 'Nash',
  Other = 'Other',
  Vamo = 'Vamo'
}

export type GroupOrderEdge = {
  __typename?: 'GroupOrderEdge';
  cursor: Scalars['ID']['output'];
  node: GroupOrder;
};

export type GroupOrderInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  expectedAdditionalDeliveryDateSpend?: InputMaybe<Scalars['Int']['input']>;
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  perShefOrders: Array<PerShefOrderInput>;
  phone: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringNotes?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  shefTip: Scalars['Int']['input'];
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subtotal: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export enum GroupOrderInternalRefundReason {
  CustomerCourtesy = 'CustomerCourtesy',
  FoodQuality = 'FoodQuality',
  FoodSafety = 'FoodSafety',
  HubError = 'HubError',
  Other = 'Other',
  SupportError = 'SupportError',
  TechnicalIssueOrBug = 'TechnicalIssueOrBug'
}

export type GroupOrderLevelRefundInput = {
  groupOrderId: Scalars['String']['input'];
  orderLevelRefunds?: InputMaybe<Array<OrderLevelRefundInput>>;
  refundDetails?: InputMaybe<Scalars['String']['input']>;
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundReason?: InputMaybe<RefundGroupOrderReasonInput>;
  refundType?: InputMaybe<GroupOrderRefundType>;
};

export type GroupOrderRatingInput = {
  groupOrderId: Scalars['String']['input'];
  ratings: Array<OrderRatingInput>;
};

export type GroupOrderRatingOutput = {
  __typename?: 'GroupOrderRatingOutput';
  customerMessage?: Maybe<Scalars['String']['output']>;
  groupOrder: GroupOrder;
  promo?: Maybe<PromoCode>;
};

export enum GroupOrderRefundType {
  Customer = 'Customer',
  DeliveryPartner = 'DeliveryPartner',
  Internal = 'Internal',
  Shef = 'Shef',
  System = 'System'
}

export type GroupOrderResult = {
  __typename?: 'GroupOrderResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  groupOrder: GroupOrder;
};

export type GroupOrderResults = {
  __typename?: 'GroupOrderResults';
  groupOrders: Array<GroupOrder>;
  pagination: Pagination;
};

export type GroupOrderReview = {
  __typename?: 'GroupOrderReview';
  status: GroupOrderReviewStatus;
};

export enum GroupOrderReviewStatus {
  Completed = 'Completed',
  Started = 'Started',
  Unreviewable = 'Unreviewable',
  Unstarted = 'Unstarted'
}

export enum GroupOrderShefRefundReason {
  FoodSafety = 'FoodSafety',
  NoNoticeNoShow = 'NoNoticeNoShow',
  OrderValueOrCountTooLow = 'OrderValueOrCountTooLow',
  Other = 'Other',
  ShefDidNotSpecify = 'ShefDidNotSpecify',
  ShefEmergency = 'ShefEmergency',
  ShefErrorForFullOrder = 'ShefErrorForFullOrder',
  ShefErrorForItem = 'ShefErrorForItem',
  ShefRescheduleRefusedByCustomer = 'ShefRescheduleRefusedByCustomer',
  ShefUnavailable = 'ShefUnavailable',
  Weather = 'Weather'
}

export enum GroupOrderSystemRefundReason {
  CustomerModification = 'CustomerModification',
  FeesAndTaxes = 'FeesAndTaxes',
  RefundWindowExpired = 'RefundWindowExpired'
}

export type GroupOrderTotalsInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  addOnItemsSubtotal: Scalars['Int']['input'];
  /** Required at checkout for non-pickup orders */
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  expectedAdditionalDeliveryDateSpend?: InputMaybe<Scalars['Int']['input']>;
  lineItemsSubtotal: Scalars['Int']['input'];
  orderType?: InputMaybe<OrderType>;
  perShefOrders: Array<PerShefOrderInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  shefTip: Scalars['Int']['input'];
  shefTipPercent?: InputMaybe<Scalars['Float']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Required if deliveryAddress is not provided for non-pickup orders.
   * Should only be used for estimations; always use `deliveryAddress`
   * when available for more accurate calculations.
   */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum Holiday {
  Christmas = 'CHRISTMAS',
  Diwali = 'DIWALI',
  Easter = 'EASTER',
  EidAlFitr = 'EID_AL_FITR',
  Hanukkah = 'HANUKKAH',
  Holi = 'HOLI',
  Kwanzaa = 'KWANZAA',
  LunarNewYear = 'LUNAR_NEW_YEAR',
  NewYear = 'NEW_YEAR',
  Nowruz = 'NOWRUZ',
  Ramadan = 'RAMADAN',
  Thanksgiving = 'THANKSGIVING',
  Valentines = 'VALENTINES',
  Vesak = 'VESAK'
}

export enum HouseholdGoals {
  GlobalFlavors = 'globalFlavors',
  HighProtein = 'highProtein',
  KidApproved = 'kidApproved',
  LowCalorie = 'lowCalorie',
  OrganicIngredients = 'organicIngredients',
  PremiumProteins = 'premiumProteins',
  SeasonalProduce = 'seasonalProduce',
  SeedOilFree = 'seedOilFree'
}

export type HouseholdInput = {
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  numBigEaters?: InputMaybe<Scalars['Int']['input']>;
  numLittleEaters?: InputMaybe<Scalars['Int']['input']>;
};

export enum IngredientPriority {
  GrassFed = 'GRASS_FED',
  None = 'NONE',
  Organic = 'ORGANIC',
  PastureRaised = 'PASTURE_RAISED',
  PremiumMeat = 'PREMIUM_MEAT',
  SeedOilFree = 'SEED_OIL_FREE',
  WildCaught = 'WILD_CAUGHT'
}

export type InitializeMealPlanInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  giftCardCode?: InputMaybe<Scalars['String']['input']>;
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isFlexServings?: InputMaybe<Scalars['Boolean']['input']>;
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  isReusablePackaging: Scalars['Boolean']['input'];
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  mealsPerWeek: Scalars['Int']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  numServings: Scalars['Int']['input'];
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  selectedDishes: Array<MealPlanItem>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  timeWindowId: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type InitializeMealPlanResponse = MutationResponse & {
  __typename?: 'InitializeMealPlanResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum LeadCaptureStep {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export enum LeadCaptureTrigger {
  ExitIntent = 'EXIT_INTENT',
  Scroll = 'SCROLL',
  Time = 'TIME'
}

export type LimitedTimeAdditionInput = {
  foodItemId: Scalars['Int']['input'];
  windowEnd: Scalars['Date']['input'];
  windowStart: Scalars['Date']['input'];
};

export type LineDrive = {
  __typename?: 'LineDrive';
  enabledDaysOfWeek: Array<Scalars['Int']['output']>;
  endHub: DeliveryHub;
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startHub: DeliveryHub;
  startTime: Scalars['String']['output'];
};

export type LineDriveFilterInput = {
  endHubId?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
  startHubId?: InputMaybe<Scalars['Int']['input']>;
};

export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type MacroSubField = {
  __typename?: 'MacroSubField';
  name: Scalars['String']['output'];
  value: MacroValue;
};

export type MacroValue = {
  __typename?: 'MacroValue';
  subMacros?: Maybe<Array<MacroSubField>>;
  unit: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MakeItAMealDishSuggestion = {
  __typename?: 'MakeItAMealDishSuggestion';
  affinityScore: Scalars['Float']['output'];
  foodItem: FoodItem;
  id: Scalars['Int']['output'];
  ranking: Scalars['Int']['output'];
};

export type MakeItAMealDishSuggestions = {
  __typename?: 'MakeItAMealDishSuggestions';
  id: Scalars['Int']['output'];
  suggestions: Array<MakeItAMealDishSuggestion>;
};

export type MealPlan = {
  __typename?: 'MealPlan';
  address: Address;
  addressId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  fridayDelivery: Scalars['Boolean']['output'];
  hasActiveReusableContainerEnrollment: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isFlexServings: Scalars['Boolean']['output'];
  isReusablePackagingPlan: Scalars['Boolean']['output'];
  isVariableServiceFeeTreatment: Scalars['Boolean']['output'];
  latestReusableContainerEnrollment?: Maybe<ReusableContainerEnrollment>;
  mealPlanType: MealPlanType;
  mealPlanTypeId: Scalars['Int']['output'];
  mondayDelivery: Scalars['Boolean']['output'];
  nextDeliveryDate: Scalars['DateTime']['output'];
  nextHeldGroupOrder?: Maybe<GroupOrder>;
  pauseEndDate?: Maybe<Scalars['DateTime']['output']>;
  paymentMethod: SavedCreditCard;
  paymentMethodId: Scalars['String']['output'];
  regionId: Scalars['Int']['output'];
  reusableEnrollment?: Maybe<ReusableEnrollment>;
  saturdayDelivery: Scalars['Boolean']['output'];
  status: MealPlanStatus;
  sundayDelivery: Scalars['Boolean']['output'];
  thursdayDelivery: Scalars['Boolean']['output'];
  tuesdayDelivery: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  wednesdayDelivery: Scalars['Boolean']['output'];
  /** Whether the plan's delivery region lists WSS desserts. Order Status shows its desserts banner on it. */
  wssDessertsEnabled: Scalars['Boolean']['output'];
  zipCode?: Maybe<ZipCode>;
};

export type MealPlanCategory = {
  __typename?: 'MealPlanCategory';
  dishes: Array<FoodItem>;
  id: Scalars['String']['output'];
  layout: MealPlanCollectionCategoryLayout;
  title: Scalars['String']['output'];
};

export type MealPlanCollection = {
  __typename?: 'MealPlanCollection';
  categories: Array<MealPlanCategory>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum MealPlanCollectionCategoryLayout {
  DoubleRowCarousel = 'DoubleRowCarousel',
  SingleRowCarousel = 'SingleRowCarousel'
}

export enum MealPlanFoodType {
  Dessert = 'dessert',
  DessertMulti = 'dessertMulti',
  Drink = 'drink',
  KidsMain = 'kidsMain',
  KidsSnack = 'kidsSnack',
  Lunch = 'lunch',
  Main = 'main',
  Side = 'side',
  Snack = 'snack',
  Staple = 'staple'
}

export enum MealPlanFormat {
  FlexibleSides = 'FLEXIBLE_SIDES',
  MainsPlusSides = 'MAINS_PLUS_SIDES'
}

export type MealPlanGroupOrder = {
  __typename?: 'MealPlanGroupOrder';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<Subscription>;
};

export type MealPlanItem = {
  foodItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  shefId?: InputMaybe<Scalars['String']['input']>;
};

export type MealPlanOrderSalesTax = {
  __typename?: 'MealPlanOrderSalesTax';
  salesTax: Scalars['Int']['output'];
};

export type MealPlanOrderSalesTaxInput = {
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  mealPlanOrderSubtotal: Scalars['Int']['input'];
  referenceShefId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum MealPlanOrderStatus {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Skipped = 'SKIPPED'
}

export enum MealPlanPersonalizationGoal {
  GlobalAndAuthentic = 'GLOBAL_AND_AUTHENTIC',
  HighProtein = 'HIGH_PROTEIN',
  KidApproved = 'KID_APPROVED',
  LowCalorie = 'LOW_CALORIE',
  Organic = 'ORGANIC',
  PremiumProteins = 'PREMIUM_PROTEINS',
  Seasonal = 'SEASONAL',
  SeedOilFree = 'SEED_OIL_FREE'
}

export type MealPlanPreferences = {
  __typename?: 'MealPlanPreferences';
  addressId: Scalars['Int']['output'];
  adventureLevelPct: Scalars['Int']['output'];
  allergens?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  cuisinePreferences: Array<Scalars['String']['output']>;
  dietaryPreferences?: Maybe<Array<Scalars['String']['output']>>;
  format?: Maybe<MealPlanFormat>;
  id: Scalars['String']['output'];
  isReusablePackagingPlan: Scalars['Boolean']['output'];
  isVegan: Scalars['Boolean']['output'];
  isVegetarian: Scalars['Boolean']['output'];
  nextDeliveryDate: Scalars['DateTime']['output'];
  numMeals: Scalars['Int']['output'];
  numServings: Scalars['Int']['output'];
  oilinessPreferencePct?: Maybe<Scalars['Int']['output']>;
  paymentMethodId: Scalars['String']['output'];
  preferredProteins?: Maybe<Array<Protein>>;
  price: Scalars['Int']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  recurringPeriodDays?: Maybe<Scalars['Int']['output']>;
  spiceLevels?: Maybe<Array<Scalars['Int']['output']>>;
  status: MealPlanStatus;
  userId?: Maybe<Scalars['String']['output']>;
};

export type MealPlanShefPayoutOverride = {
  __typename?: 'MealPlanShefPayoutOverride';
  createdAt: Scalars['DateTime']['output'];
  foodItemId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  payoutAmount: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MealPlanShefPayoutOverrideInput = {
  foodItemId: Scalars['Int']['input'];
  payoutAmount: Scalars['Int']['input'];
  shefId: Scalars['String']['input'];
};

export enum MealPlanStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Hold = 'HOLD'
}

export type MealPlanSubscriptionInput = {
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences: Array<CuisineRegion>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  fridayDelivery: Scalars['Boolean']['input'];
  mealsPerWeek: Scalars['Int']['input'];
  mondayDelivery: Scalars['Boolean']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  oilinessPreferencePct: Scalars['Int']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  recurringPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  saturdayDelivery: Scalars['Boolean']['input'];
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  servingsPerMeal: Scalars['Int']['input'];
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  sundayDelivery: Scalars['Boolean']['input'];
  thursdayDelivery: Scalars['Boolean']['input'];
  tuesdayDelivery: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
  wednesdayDelivery: Scalars['Boolean']['input'];
};

export type MealPlanType = {
  __typename?: 'MealPlanType';
  displayName: Scalars['String']['output'];
  format?: Maybe<MealPlanFormat>;
  id: Scalars['Int']['output'];
  numServings: Scalars['Int']['output'];
  /** Price of a single serving, in cents. */
  pricePerServing: Scalars['Int']['output'];
  pricePerUnit: Scalars['Int']['output'];
  regionId?: Maybe<Scalars['Int']['output']>;
  unit: Scalars['Int']['output'];
  weeklyCost: Scalars['Int']['output'];
  weeklyServings?: Maybe<Scalars['Int']['output']>;
};

export type MealPlanTypeOption = {
  __typename?: 'MealPlanTypeOption';
  isDisabled: Scalars['Boolean']['output'];
  isPopularUnit?: Maybe<Scalars['Boolean']['output']>;
  isRecommended?: Maybe<Scalars['Boolean']['output']>;
  mealPlanType: MealPlanType;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MealPlanUpcomingOrder = {
  __typename?: 'MealPlanUpcomingOrder';
  cartLineItemUnits?: Maybe<Array<FoodItemQuantity>>;
  foodItemCapacityForDeliveryDate?: Maybe<Array<FoodItemCapacityForDeliveryDate>>;
  mainDishes?: Maybe<Array<FoodItem>>;
  mealPlan: MealPlan;
  mealPlanGroupOrder: GroupOrder;
  mealPlanGroupOrderId?: Maybe<Scalars['String']['output']>;
  mealPlanOrderStatus?: Maybe<MealPlanOrderStatus>;
  nextDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  promoCodeApplied?: Maybe<PromoCode>;
  sideDishes?: Maybe<Array<FoodItem>>;
  sidesPerWeek: Scalars['Int']['output'];
};

export type MealPlanningMenu = {
  __typename?: 'MealPlanningMenu';
  isDynamicShefSortingExposed: Scalars['Boolean']['output'];
  mains: Array<ShefSegment>;
  shefSegments: Array<ShefSegment>;
  sides: Array<ShefSegment>;
  userPrefs?: Maybe<TasteProfile>;
};

export type MealPlanningSubscriptionInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences: Array<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  isAcceptingTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  isOptingIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  mealsPerWeek: Scalars['Int']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oilinessPreferencePct: Scalars['Int']['input'];
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  phone: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringNotes?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  selectedDishes: Array<MealPlanItem>;
  servingsPerMeal: Scalars['Int']['input'];
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subtotal: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type MealPlanningSubscriptionUpdateInput = {
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences: Array<CuisineRegion>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  mealsPerWeek: Scalars['Int']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  oilinessPreferencePct: Scalars['Int']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  servingsPerMeal: Scalars['Int']['input'];
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type Menu = {
  __typename?: 'Menu';
  dateRange: DateRange;
  holiday?: Maybe<Holiday>;
  id: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};

export enum MenuAssignmentType {
  Core = 'CORE',
  LimitedTime = 'LIMITED_TIME',
  Rotation = 'ROTATION',
  Seasonal = 'SEASONAL'
}

export type MerchandisePageTagSlugFilterInput = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  pageId: Scalars['String']['input'];
  tagSlug: Scalars['String']['input'];
};

export enum MerchandisingTag {
  CulinaryPicks = 'culinaryPicks',
  FallFavorites = 'fallFavorites',
  FamilyFriendly = 'familyFriendly',
  HighProtein = 'highProtein',
  LimitedTime = 'limitedTime',
  LowCalorie = 'lowCalorie',
  NewFresh = 'newFresh',
  OrderAgain = 'orderAgain',
  OrganicAndMore = 'organicAndMore',
  SpringFavorites = 'springFavorites',
  SummerFavorites = 'summerFavorites',
  WinterFavorites = 'winterFavorites'
}

export enum MktpStatus {
  Draft = 'DRAFT',
  Live = 'LIVE',
  NotLive = 'NOT_LIVE'
}

export type ModifyHeldGroupOrderInput = {
  id: Scalars['String']['input'];
  perShefOrders: Array<PerShefHeldOrderModifyInput>;
};

export type ModifyHeldGroupOrderResponse = MutationResponse & {
  __typename?: 'ModifyHeldGroupOrderResponse';
  message: Scalars['String']['output'];
  orders: Array<Order>;
  success: Scalars['Boolean']['output'];
};

export type ModifyInvoiceInput = {
  id: Scalars['String']['input'];
  orderInputs?: InputMaybe<Array<SubscriptionBuildOrderInput>>;
  timeWindows?: InputMaybe<Array<ModifyTimeWindow>>;
};

export type ModifyLineItemInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  addOnItemsTotal: Scalars['Int']['input'];
  lineItems: Array<OrderLineItemInput>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shefTip: Scalars['Int']['input'];
  subtotal: Scalars['Int']['input'];
};

export type ModifyMealPlanAddressIdInput = {
  addressId: Scalars['Int']['input'];
  mealPlanId: Scalars['String']['input'];
};

export type ModifyMealPlanAddressIdResponse = MutationResponse & {
  __typename?: 'ModifyMealPlanAddressIdResponse';
  mealPlan?: Maybe<MealPlan>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ModifyMealPlanGroupOrderAddressIdInput = {
  addressId: Scalars['Int']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  mealPlanId?: InputMaybe<Scalars['String']['input']>;
};

export type ModifyMealPlanGroupOrderAddressIdResponse = MutationResponse & {
  __typename?: 'ModifyMealPlanGroupOrderAddressIdResponse';
  groupOrder?: Maybe<GroupOrder>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ModifyMealPlanInput = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  pauseEndDate?: InputMaybe<Scalars['String']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifyMealPlanPaymentMethodInput = {
  mealPlanId: Scalars['String']['input'];
  paymentMethodId: Scalars['String']['input'];
};

export type ModifyMealPlanPaymentMethodResponse = MutationResponse & {
  __typename?: 'ModifyMealPlanPaymentMethodResponse';
  mealPlan?: Maybe<MealPlan>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ModifyMealPlanResponse = MutationResponse & {
  __typename?: 'ModifyMealPlanResponse';
  mealPlan?: Maybe<MealPlan>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ModifyMealPlanReusablePackagingInput = {
  isReusablePackaging: Scalars['Boolean']['input'];
  mealPlanId: Scalars['String']['input'];
};

export type ModifyTimeWindow = {
  deliveryDate: Scalars['String']['input'];
  timeWindowId: Scalars['Int']['input'];
};

export enum MultiResponse {
  Medium = 'MEDIUM',
  Mixed = 'MIXED',
  Strict = 'STRICT'
}

export type Mutation = {
  __typename?: 'Mutation';
  addAdminUser: Scalars['Boolean']['output'];
  addBecomeAShefPhoneNumber: Scalars['Boolean']['output'];
  addExploreMerchandisePage: ExploreMerchandisePage;
  addFoodItem: FoodItem;
  addGroupOrder2: GroupOrderResult;
  addGroupOrderRating: GroupOrderRatingOutput;
  addLineDrive: LineDrive;
  addShefApplication: ShefApplicationResult;
  addShefPromoCode: PromoCode;
  addTasteProfile: TasteProfileMutationResponse;
  addUserToHubs: Scalars['Boolean']['output'];
  adminAddDeliveryEvent: DeliveryEvent;
  adminAddDeliveryEventType: DeliveryEventType;
  adminAddGroupOrder: AdminAddGroupOrderResult;
  adminAddPromoCodeTagType: PromoCodeTagType;
  adminApplyTimeWindowMigration: ApplyTimeWindowMigrationResponse;
  adminBanUser: Scalars['Boolean']['output'];
  adminBulkAddEmployeeGiftCards: Array<PromoCode>;
  adminBulkAddPartnerGiftCards: Array<PromoCode>;
  adminBulkAddPromoCodes: Array<PromoCode>;
  adminBulkAddShefGiftCards: Array<PromoCode>;
  adminBulkAddZipCodes: Array<ZipCode>;
  adminBulkCreateShefCharges: Array<BulkCreateShefChargeResult>;
  adminBulkImportPromoCodes: Array<BulkPromoCodeRowResult>;
  adminBulkRechargeGiftCards: Scalars['Boolean']['output'];
  adminBulkUpdateApplication: Scalars['Boolean']['output'];
  adminBulkUpdateFoodItemChangeRequests: Array<FoodItemChangeRequest>;
  adminBulkUpdatePromoCodes: Array<BulkPromoCodeRowResult>;
  adminBulkUpdateZipCodes: Array<ZipCode>;
  adminCancelHeldMealPlanGroupOrder: GroupOrder;
  adminCreateEventConfig: Scalars['Boolean']['output'];
  adminCreateReportsZipUpload: ReportsZipUpload;
  adminCreateShefCharge: CreateShefChargeResult;
  adminDeleteAllDeliveryEventsByOrder: Array<DeliveryEvent>;
  adminDeleteDeliveryEvent: DeliveryEvent;
  adminDeleteEventConfig: Scalars['Boolean']['output'];
  adminDeleteUser: User;
  adminDeleteZipCode: Scalars['Boolean']['output'];
  adminDisconnectShefStripe: Scalars['Boolean']['output'];
  adminDuplicateFoodItems: Array<DuplicateFoodItemResult>;
  adminEditDeliveryEventType: DeliveryEventType;
  adminEditPromoCodeTagType: PromoCodeTagType;
  adminImpersonateUser: AuthResult;
  adminModifyGroupOrder: GroupOrder;
  adminPreviewTimeWindowMigration: Array<TimeWindowMigrationPreviewRow>;
  adminPublishShefInsightsReportsZip: ShefInsightsReportsZipPublishResult;
  adminResetPassword: User;
  adminSaveRegionShefRankings: Array<RegionShefRanking>;
  adminSetUserRoles: Array<UserRoleResult>;
  adminSkipMealPlanGroupOrder: AdminSkipMealPlanGroupOrderResponse;
  adminUnbanUser: Scalars['Boolean']['output'];
  adminUpdateApplication: Scalars['Boolean']['output'];
  adminUpdateEventConfig: Scalars['Boolean']['output'];
  adminUpdatePromoCodeTags: Array<PromoCodeTag>;
  adminVoidShefCharge: ShefCharge;
  approveFoodHandlerCertificate: Scalars['Boolean']['output'];
  archiveDeliveryAddress?: Maybe<Scalars['Boolean']['output']>;
  assignPhotoEditRequest: PhotoEditRequest;
  attemptMealPlanningPurchase: Scalars['Boolean']['output'];
  becomeATaster: User;
  bulkCreateMerchandisePageTagFiltersByTagId?: Maybe<Scalars['Boolean']['output']>;
  bulkCreateMerchandisePageTagFiltersByTagSlug?: Maybe<Scalars['Boolean']['output']>;
  bulkCreateNamsorDataForUsers?: Maybe<Scalars['Boolean']['output']>;
  bulkDeleteMerchandisePageTagFilterByTagFilterIds?: Maybe<Scalars['Boolean']['output']>;
  bulkDeleteMerchandisePageTagFilterByTagSlug?: Maybe<Scalars['Boolean']['output']>;
  bulkMakeFoodItemDraftStatus: Scalars['Boolean']['output'];
  bulkModifyShefProfile: Array<ShefProfile>;
  bulkReindexFoodItems?: Maybe<Scalars['Boolean']['output']>;
  bulkSetShefPlatformPercents: Scalars['Boolean']['output'];
  bulkTagFoodItemsByIds: Scalars['Boolean']['output'];
  bulkTagShefsByIds: Scalars['Boolean']['output'];
  bulkTagShefsByTagIds: Scalars['Boolean']['output'];
  bulkTagShefsByTagSlugs: Scalars['Boolean']['output'];
  bulkUntagShefsBySlugs: Scalars['Boolean']['output'];
  bulkUntagShefsByTagIds: Scalars['Boolean']['output'];
  bulkUpdateFoodItemMealPlanData: Array<UpdateFoodItemMealPlanDataResponse>;
  bulkUpdateGroupOrderOrderRoutes: Array<UpdateGroupOrderOrderRouteResponse>;
  cancelGroupOrder: GroupOrder;
  cancelGroupOrderDelivery: Scalars['Boolean']['output'];
  cancelMealPlan: CancelMealPlanResponse;
  cancelMyTableRunMealPlan: CancelMyTableRunMealPlanResult;
  cancelTableRunMembership: TableRunMembershipCancellationResult;
  cartClearItems: CartResults;
  cartSetLineItems: CartResults;
  claimPhotoEditRequest: PhotoEditRequest;
  clearCartItems?: Maybe<Scalars['Boolean']['output']>;
  closeMyTableRunStorefront: CloseTableRunStorefrontResult;
  consumerModifyGroupOrder: GroupOrder;
  createAddOnItem: AddOnItem;
  createFoodItemChangeRequest: FoodItemChangeRequest;
  createMealPlanSetupIntent: CreateMealPlanSetupIntentResponse;
  createMyTableRunStorefront: TableRunStorefront;
  createOrUpdateDeliveryHub?: Maybe<UpdateDeliveryHubResult>;
  createOrUpdateRegion?: Maybe<RegionInfo>;
  createSetupIntentForPaymentMethod: CreateSetupIntentForPaymentMethodResult;
  createSetupIntentForTableRunCheckout: CreateSetupIntentForTableRunCheckoutResult;
  createSetupIntentForWssFinalize: CreateSetupIntentForWssFinalizeResult;
  createShefAvailabilityNotification: Scalars['Boolean']['output'];
  createShefPost: Scalars['Boolean']['output'];
  createShefTag: ShefTagType;
  createStripeConnect: ShefStripeConnect;
  createTableRunMealPlan: TableRunMealPlan;
  createTableRunStorefront: TableRunStorefront;
  deleteExploreMerchandisePage: Scalars['Boolean']['output'];
  deleteFoodItem: Scalars['Boolean']['output'];
  deleteMealPlanShefPayoutOverride: DeleteMealPlanShefPayoutOverrideResponse;
  deleteMerchandisePageTagFilter: Scalars['Boolean']['output'];
  deleteShefPost: Scalars['Boolean']['output'];
  deleteShefTag: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableFringe: Scalars['Boolean']['output'];
  disablePromoCode: PromoCode;
  dismissFoodItemFinding: FoodItemFinding;
  duplicateOrderToCart: DuplicateOrderToCartResponse;
  editShefApplication: Scalars['Boolean']['output'];
  editShefApplicationCancelOnboardingCall: Scalars['Boolean']['output'];
  editShefApplicationCancelOrientationCall: Scalars['Boolean']['output'];
  editShefApplicationCancelTasting: Scalars['Boolean']['output'];
  editShefApplicationCompleteInformationSession: Scalars['Boolean']['output'];
  editShefApplicationConfirmTasting: Scalars['Boolean']['output'];
  editShefApplicationMenuWebinarCompletedAt: Scalars['Boolean']['output'];
  editShefApplicationMenuWebinarScheduledAt: Scalars['Boolean']['output'];
  /** One-shot: evaluate, persist, and run Green side-effects when applicable */
  evaluateAndPersistShefApplicationQuestionnaire: ShefApplicationEvaluationResult;
  /**
   * Evaluate using the user's previously saved questionnaire draft merged with the provided input,
   * but DO NOT persist the result. Useful for pre-submit eligibility checks and feedback loops.
   */
  evaluateSavedShefApplicationQuestionnaire: ShefApplicationEvaluationResult;
  /** Evaluate the native questionnaire answers and return outcome + factors */
  evaluateShefApplicationQuestionnaire: ShefApplicationEvaluationResult;
  favoriteFoodItem: FoodItemFavoriteMutationResponse;
  flagRatingForReview?: Maybe<Scalars['Boolean']['output']>;
  followShef: PublicShef;
  getSignedUrl: SignedUrl;
  incrementShefPostClickCount: Scalars['Boolean']['output'];
  incrementShefPostViewCount: Scalars['Boolean']['output'];
  indexShefs: Scalars['Boolean']['output'];
  ingestAnalyticsEvent: Scalars['Boolean']['output'];
  ingestFacebookEvent: Scalars['Boolean']['output'];
  initializeMealPlan: InitializeMealPlanResponse;
  likeShefPost: Scalars['Boolean']['output'];
  login2: AuthResult;
  loginWithOAuth2: OAuthResult;
  makeFoodItemDraftStatus: Scalars['Boolean']['output'];
  markUserVisitedPreferencesPage: User;
  modifyDeliveryAddress: Address;
  modifyDeliveryDays: Scalars['Boolean']['output'];
  modifyFoodItemHolidayMenu: Scalars['Boolean']['output'];
  modifyGeoConfig: Scalars['Boolean']['output'];
  modifyHeldGroupOrder: ModifyHeldGroupOrderResponse;
  modifyMealPlan: ModifyMealPlanResponse;
  modifyMealPlanAddressId: ModifyMealPlanAddressIdResponse;
  modifyMealPlanGroupOrderAddressId: ModifyMealPlanGroupOrderAddressIdResponse;
  modifyMealPlanPaymentMethod: ModifyMealPlanPaymentMethodResponse;
  modifyMealPlanReusablePackaging: ModifyMealPlanResponse;
  modifyShefAvailabilityRules?: Maybe<Scalars['Boolean']['output']>;
  modifyShefFulfillmentInfo: Scalars['Boolean']['output'];
  modifyShefPost: Scalars['Boolean']['output'];
  modifyShefProfile: ShefProfile;
  modifySubscription: SubscriptionModifyResult;
  modifyUser: User;
  modifyUserPhone: User;
  placeTableRunOneTimeOrder: GroupOrder;
  recordConsentDecision: Scalars['Boolean']['output'];
  refundGroupOrder2: GroupOrder;
  refundReusableContainerDeposit: RefundReusableContainerDepositResponse;
  register2: AuthResult;
  registerPushToken?: Maybe<Scalars['Boolean']['output']>;
  reindexFoodItem?: Maybe<Scalars['Boolean']['output']>;
  removeAdminUser: Scalars['Boolean']['output'];
  removeBackgroundFromPhoto: PhotoBackgroundRemovalsResult;
  removeCreditCard?: Maybe<Scalars['Boolean']['output']>;
  removeSeasonalAssignment: FoodItemMenuAssignment;
  removeUserFromHubs: Scalars['Boolean']['output'];
  requestBulkGroupOrderDelivery?: Maybe<Scalars['Boolean']['output']>;
  requestGroupOrderDeliveries: RequestGroupOrderDeliveriesResults;
  resetChangePassword?: Maybe<Scalars['Boolean']['output']>;
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  resumeTableRunMembership: TableRunMembershipCancellationResult;
  saveCreditCard?: Maybe<SavedCreditCard>;
  saveCreditCardFromPaymentMethod: SavedCreditCard;
  saveDeliveryAddress: Address;
  /** Persist the questionnaire answers and (optionally) evaluation to the application record */
  saveShefApplicationQuestionnaire: Scalars['Boolean']['output'];
  scanDropOffOrder: Order;
  setCartItem?: Maybe<CartLineItem>;
  setCartItems: Array<Maybe<CartLineItem>>;
  setSeasonalCoreHandoff: Array<FoodItemMenuAssignment>;
  setTableRunDeliveryAddress: SetTableRunDeliveryAddressResult;
  shefApplicationQuestionsCompleted: Scalars['Boolean']['output'];
  signUpAsTableRunShef: SignUpAsTableRunShefResult;
  skipMealPlanGroupOrder: SkipMealPlanGroupOrderResponse;
  startTableRunTrial: StartTableRunTrialResult;
  submitLeadCapture: SubmitLeadCaptureResult;
  subscribeToTableRunPlan: SubscribeToTableRunPlanResult;
  tagShefByTagId: Scalars['Boolean']['output'];
  tagShefByTagSlug: Scalars['Boolean']['output'];
  unclaimPhotoEditRequest: PhotoEditRequest;
  undoSeasonalAssignmentRemoval: FoodItemMenuAssignment;
  unfavoriteFoodItem: FoodItemFavoriteMutationResponse;
  unfollowShef: Scalars['Boolean']['output'];
  unscanDropOffOrder: Order;
  unskipMealPlanGroupOrder: UnskipMealPlanGroupOrderResponse;
  updateAddOnItemStatus: Scalars['Boolean']['output'];
  updateConfig?: Maybe<Config>;
  updateCoreMenu: Array<FoodItemMenuAssignment>;
  updateExploreMerchandisePage: ExploreMerchandisePage;
  updateExplorePagePromoCode?: Maybe<Array<Maybe<PromoCode>>>;
  updateFoodItemChangeRequest: FoodItemChangeRequest;
  updateLimitedTimeMenu: Array<FoodItemMenuAssignment>;
  updateMerchandisePageTagFilter: ExploreMerchandisePageTagFilter;
  updateMyTableRunStorefront: TableRunStorefront;
  updatePhotoEditRequest: PhotoEditRequest;
  updatePhotoEditStatus: PhotoEditRequest;
  updateShefApplicationProfileImages: Scalars['Boolean']['output'];
  updateShefOrderRatingCategory: Scalars['Boolean']['output'];
  updateShefTag: ShefTagType;
  updateShefZipCode: Scalars['Boolean']['output'];
  updateTableRunMembershipPaymentMethod: UpdateTableRunMembershipPaymentMethodResult;
  updateTableRunStorefront: TableRunStorefront;
  updateTasteProfile: TasteProfileMutationResponse;
  updateUserNotificationSettings: Array<UserNotificationSetting>;
  upsertFoodItemChangeRequestContext: FoodItemChangeRequest;
  upsertMealPlanShefPayoutOverride: UpsertMealPlanShefPayoutOverrideResponse;
  upsertSeasonalAssignments: Array<FoodItemMenuAssignment>;
  validateFoodItemDraft: FoodItemDraftValidation;
  validateMealPlanPaymentMethod: ValidateMealPlanPaymentMethodResponse;
};


export type MutationAddAdminUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAddBecomeAShefPhoneNumberArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationAddExploreMerchandisePageArgs = {
  page: ExploreMerchandisePageInput;
};


export type MutationAddFoodItemArgs = {
  isWSSFoodItem?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type MutationAddGroupOrder2Args = {
  input: GroupOrderInput;
};


export type MutationAddGroupOrderRatingArgs = {
  input: GroupOrderRatingInput;
};


export type MutationAddLineDriveArgs = {
  input: AddLineDriveInput;
};


export type MutationAddShefApplicationArgs = {
  promoCode?: InputMaybe<Scalars['String']['input']>;
  shefApplicationInput: ShefApplicationInput;
};


export type MutationAddShefPromoCodeArgs = {
  promoCodeInput: ShefPromoCodeInput;
};


export type MutationAddTasteProfileArgs = {
  input: TasteProfileMutationInput;
};


export type MutationAddUserToHubsArgs = {
  input: AddUserFromHubInput;
};


export type MutationAdminAddDeliveryEventArgs = {
  input: AddDeliveryEventInput;
};


export type MutationAdminAddDeliveryEventTypeArgs = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminAddGroupOrderArgs = {
  input: GroupOrderInput;
};


export type MutationAdminAddPromoCodeTagTypeArgs = {
  tag: Scalars['String']['input'];
};


export type MutationAdminApplyTimeWindowMigrationArgs = {
  input: Array<TimeWindowMigrationPairInput>;
};


export type MutationAdminBanUserArgs = {
  reason: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminBulkAddEmployeeGiftCardsArgs = {
  input: AdminBulkGiftCardsInput;
};


export type MutationAdminBulkAddPartnerGiftCardsArgs = {
  input: AdminBulkPartnerGiftCardsInput;
};


export type MutationAdminBulkAddPromoCodesArgs = {
  input: Array<PromoCodeInput>;
};


export type MutationAdminBulkAddShefGiftCardsArgs = {
  input: AdminBulkShefGiftCardsInput;
};


export type MutationAdminBulkAddZipCodesArgs = {
  input: Array<ZipCodeInput>;
};


export type MutationAdminBulkCreateShefChargesArgs = {
  input: Array<BulkCreateShefChargeInput>;
};


export type MutationAdminBulkImportPromoCodesArgs = {
  input: Array<PromoCodeInput>;
};


export type MutationAdminBulkRechargeGiftCardsArgs = {
  input: AdminBulkRechargeGiftCardsInput;
};


export type MutationAdminBulkUpdateApplicationArgs = {
  input: Array<BulkAdminShefApplicationUpdateInput>;
};


export type MutationAdminBulkUpdateFoodItemChangeRequestsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemChangeRequestIds: Array<Scalars['Int']['input']>;
  status?: InputMaybe<RequestStatus>;
};


export type MutationAdminBulkUpdatePromoCodesArgs = {
  input: Array<UpdatePromoCodeInput>;
};


export type MutationAdminBulkUpdateZipCodesArgs = {
  input: Array<ZipCodeInput>;
};


export type MutationAdminCancelHeldMealPlanGroupOrderArgs = {
  groupOrderId: Scalars['String']['input'];
};


export type MutationAdminCreateEventConfigArgs = {
  input: AdminCreateEventConfig;
};


export type MutationAdminCreateReportsZipUploadArgs = {
  fileName: Scalars['String']['input'];
};


export type MutationAdminCreateShefChargeArgs = {
  input: CreateShefChargeInput;
};


export type MutationAdminDeleteAllDeliveryEventsByOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationAdminDeleteDeliveryEventArgs = {
  input: DeleteDeliveryEventInput;
};


export type MutationAdminDeleteEventConfigArgs = {
  destination?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
};


export type MutationAdminDeleteUserArgs = {
  confirmationCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminDeleteZipCodeArgs = {
  zipCode: Scalars['String']['input'];
};


export type MutationAdminDisconnectShefStripeArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminDuplicateFoodItemsArgs = {
  inputs: Array<DuplicateFoodItemInput>;
};


export type MutationAdminEditDeliveryEventTypeArgs = {
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  typeId: Scalars['String']['input'];
};


export type MutationAdminEditPromoCodeTagTypeArgs = {
  tag: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};


export type MutationAdminImpersonateUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminModifyGroupOrderArgs = {
  input: AdminModifyGroupOrderInput;
};


export type MutationAdminPreviewTimeWindowMigrationArgs = {
  input: Array<TimeWindowMigrationPairInput>;
};


export type MutationAdminPublishShefInsightsReportsZipArgs = {
  reportsZipKey: Scalars['String']['input'];
};


export type MutationAdminResetPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAdminSaveRegionShefRankingsArgs = {
  rankings: Array<AdminRegionShefRankingInput>;
  regionId: Scalars['Int']['input'];
};


export type MutationAdminSetUserRolesArgs = {
  userId: Scalars['String']['input'];
  userRoles: Array<UserRoleInput>;
};


export type MutationAdminSkipMealPlanGroupOrderArgs = {
  input: AdminSkipMealPlanGroupOrderInput;
};


export type MutationAdminUnbanUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationAdminUpdateApplicationArgs = {
  input: AdminShefApplicationUpdateInput;
  shefId: Scalars['String']['input'];
};


export type MutationAdminUpdateEventConfigArgs = {
  input: AdminUpdateEventConfig;
};


export type MutationAdminUpdatePromoCodeTagsArgs = {
  codeId: Scalars['Int']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationAdminVoidShefChargeArgs = {
  chargeId: Scalars['ID']['input'];
};


export type MutationApproveFoodHandlerCertificateArgs = {
  userId: Scalars['String']['input'];
};


export type MutationArchiveDeliveryAddressArgs = {
  addressId: Scalars['Int']['input'];
};


export type MutationAssignPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
  editorUserId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAttemptMealPlanningPurchaseArgs = {
  promoCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkCreateMerchandisePageTagFiltersByTagIdArgs = {
  tagFilters: Array<CreateMerchandisePageTagFilterInput>;
};


export type MutationBulkCreateMerchandisePageTagFiltersByTagSlugArgs = {
  tagFilters: Array<MerchandisePageTagSlugFilterInput>;
};


export type MutationBulkCreateNamsorDataForUsersArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type MutationBulkDeleteMerchandisePageTagFilterByTagFilterIdsArgs = {
  tagFilterIds: Array<Scalars['String']['input']>;
};


export type MutationBulkDeleteMerchandisePageTagFilterByTagSlugArgs = {
  pageId: Scalars['String']['input'];
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationBulkMakeFoodItemDraftStatusArgs = {
  foodItemIds: Array<Scalars['Int']['input']>;
};


export type MutationBulkModifyShefProfileArgs = {
  shefProfileInputs: Array<ShefProfileInput>;
};


export type MutationBulkReindexFoodItemsArgs = {
  foodItemIds: Array<Scalars['Int']['input']>;
};


export type MutationBulkSetShefPlatformPercentsArgs = {
  deliveryType?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  platformPercent?: InputMaybe<Scalars['Int']['input']>;
  shefIds: Array<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationBulkTagFoodItemsByIdsArgs = {
  foodItemTags: Array<FoodItemTags>;
};


export type MutationBulkTagShefsByIdsArgs = {
  shefTags: Array<ShefTags>;
};


export type MutationBulkTagShefsByTagIdsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationBulkTagShefsByTagSlugsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationBulkUntagShefsBySlugsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationBulkUntagShefsByTagIdsArgs = {
  shefIds: Array<Scalars['String']['input']>;
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationBulkUpdateFoodItemMealPlanDataArgs = {
  updates: Array<UpdateFoodItemMealPlanDataInput>;
};


export type MutationBulkUpdateGroupOrderOrderRoutesArgs = {
  updates: Array<UpdateGroupOrderOrderRouteInput>;
};


export type MutationCancelGroupOrderArgs = {
  groupOrderId: Scalars['String']['input'];
};


export type MutationCancelGroupOrderDeliveryArgs = {
  groupOrderId: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};


export type MutationCancelMealPlanArgs = {
  input: CancelMealPlanInput;
};


export type MutationCancelMyTableRunMealPlanArgs = {
  input: CancelMyTableRunMealPlanInput;
};


export type MutationCartClearItemsArgs = {
  shefIds: Array<Scalars['String']['input']>;
};


export type MutationCartSetLineItemsArgs = {
  cartLineItemInputs: Array<CartLineItemInput>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationClaimPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
};


export type MutationClearCartItemsArgs = {
  shefIds: Array<Scalars['String']['input']>;
};


export type MutationConsumerModifyGroupOrderArgs = {
  input: ConsumerModifyGroupOrderInput;
};


export type MutationCreateAddOnItemArgs = {
  createAddOnItemInput: CreateAddOnItemInput;
};


export type MutationCreateFoodItemChangeRequestArgs = {
  autoApproveIfPossible?: InputMaybe<Scalars['Boolean']['input']>;
  changeset: FoodItemChangesetInput;
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemId: Scalars['Int']['input'];
  isProposal?: InputMaybe<Scalars['Boolean']['input']>;
  makeLive?: InputMaybe<Scalars['Boolean']['input']>;
  photoEditingNotes?: InputMaybe<Scalars['String']['input']>;
  photoEditorUserId?: InputMaybe<Scalars['String']['input']>;
  proposedDishReason?: InputMaybe<ProposedDishReason>;
};


export type MutationCreateMyTableRunStorefrontArgs = {
  input: CreateMyTableRunStorefrontInput;
};


export type MutationCreateOrUpdateDeliveryHubArgs = {
  deliveryHubInput: UpdateDeliveryHubInput;
};


export type MutationCreateOrUpdateRegionArgs = {
  regionInfo: UpdateRegionInput;
};


export type MutationCreateShefAvailabilityNotificationArgs = {
  shefId: Scalars['String']['input'];
};


export type MutationCreateShefPostArgs = {
  input: ShefPostInput;
};


export type MutationCreateShefTagArgs = {
  tag: ShefTagInput;
};


export type MutationCreateStripeConnectArgs = {
  code: Scalars['String']['input'];
  stripeAccountType?: InputMaybe<StripeAccountType>;
  userId: Scalars['String']['input'];
};


export type MutationCreateTableRunMealPlanArgs = {
  input: CreateTableRunMealPlanInput;
};


export type MutationCreateTableRunStorefrontArgs = {
  input: CreateTableRunStorefrontInput;
};


export type MutationDeleteExploreMerchandisePageArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationDeleteMealPlanShefPayoutOverrideArgs = {
  input: DeleteMealPlanShefPayoutOverrideInput;
};


export type MutationDeleteMerchandisePageTagFilterArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteShefPostArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteShefTagArgs = {
  tagId: Scalars['String']['input'];
};


export type MutationDisablePromoCodeArgs = {
  promoCodeId: Scalars['Int']['input'];
};


export type MutationDismissFoodItemFindingArgs = {
  findingId: Scalars['ID']['input'];
};


export type MutationDuplicateOrderToCartArgs = {
  orderId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationArgs = {
  applicationId: Scalars['Int']['input'];
  shefApplicationInput: ShefApplicationInputStep2;
};


export type MutationEditShefApplicationCancelOnboardingCallArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationCancelOrientationCallArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationCancelTastingArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationCompleteInformationSessionArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationConfirmTastingArgs = {
  applicationId: Scalars['Int']['input'];
};


export type MutationEditShefApplicationMenuWebinarCompletedAtArgs = {
  applicationId: Scalars['Int']['input'];
  dateInput?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationEditShefApplicationMenuWebinarScheduledAtArgs = {
  applicationId: Scalars['Int']['input'];
  dateInput?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationEvaluateAndPersistShefApplicationQuestionnaireArgs = {
  input: ShefApplicationQuestionnaireInput;
};


export type MutationEvaluateSavedShefApplicationQuestionnaireArgs = {
  input: ShefApplicationQuestionnaireInput;
};


export type MutationEvaluateShefApplicationQuestionnaireArgs = {
  input: ShefApplicationQuestionnaireInput;
};


export type MutationFavoriteFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationFlagRatingForReviewArgs = {
  ratingId: Scalars['Int']['input'];
};


export type MutationFollowShefArgs = {
  canRefollow?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type MutationGetSignedUrlArgs = {
  input: SignedUrlInput;
};


export type MutationIncrementShefPostClickCountArgs = {
  id: Scalars['String']['input'];
};


export type MutationIncrementShefPostViewCountArgs = {
  id: Scalars['String']['input'];
};


export type MutationIngestAnalyticsEventArgs = {
  data?: InputMaybe<Scalars['String']['input']>;
  eventName: Scalars['String']['input'];
};


export type MutationIngestFacebookEventArgs = {
  event: FacebookEvent;
  eventName: Scalars['String']['input'];
};


export type MutationInitializeMealPlanArgs = {
  input: InitializeMealPlanInput;
};


export type MutationLikeShefPostArgs = {
  id: Scalars['String']['input'];
};


export type MutationLogin2Args = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationLoginWithOAuth2Args = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oAuthLoginType: OAuthLoginType;
  phone?: InputMaybe<Scalars['String']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  requireZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  signUpEntryPoint?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  utm?: InputMaybe<UtmInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMakeFoodItemDraftStatusArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationModifyDeliveryAddressArgs = {
  addressId: Scalars['Int']['input'];
  addressInput?: InputMaybe<AddressInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationModifyDeliveryDaysArgs = {
  deliveryDaysInput: DeliveryDaysInput;
};


export type MutationModifyFoodItemHolidayMenuArgs = {
  foodItemId: Scalars['Int']['input'];
  holiday?: InputMaybe<Holiday>;
};


export type MutationModifyGeoConfigArgs = {
  input: GeoConfigInput;
};


export type MutationModifyHeldGroupOrderArgs = {
  input: ModifyHeldGroupOrderInput;
};


export type MutationModifyMealPlanArgs = {
  input: ModifyMealPlanInput;
};


export type MutationModifyMealPlanAddressIdArgs = {
  input: ModifyMealPlanAddressIdInput;
};


export type MutationModifyMealPlanGroupOrderAddressIdArgs = {
  input: ModifyMealPlanGroupOrderAddressIdInput;
};


export type MutationModifyMealPlanPaymentMethodArgs = {
  input: ModifyMealPlanPaymentMethodInput;
};


export type MutationModifyMealPlanReusablePackagingArgs = {
  input: ModifyMealPlanReusablePackagingInput;
};


export type MutationModifyShefAvailabilityRulesArgs = {
  add?: InputMaybe<Array<ShefAvailabilityRuleInput>>;
  availableDates?: InputMaybe<Array<Scalars['String']['input']>>;
  daysOfWeek?: InputMaybe<ShefAvailabilityRuleDaysOfWeekInput>;
  end?: InputMaybe<Array<Scalars['String']['input']>>;
  shefId: Scalars['String']['input'];
  unavailableDates?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationModifyShefFulfillmentInfoArgs = {
  input: FulfillmentInput;
};


export type MutationModifyShefPostArgs = {
  id: Scalars['String']['input'];
  input: ShefPostInput;
};


export type MutationModifyShefProfileArgs = {
  shefProfileInput: ShefProfileInput;
};


export type MutationModifySubscriptionArgs = {
  input: SubscriptionModifyInput;
};


export type MutationModifyUserArgs = {
  userInput: UserInput;
};


export type MutationModifyUserPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type MutationPlaceTableRunOneTimeOrderArgs = {
  input: PlaceTableRunOneTimeOrderInput;
};


export type MutationRecordConsentDecisionArgs = {
  consentType: Scalars['String']['input'];
  decision: Scalars['String']['input'];
};


export type MutationRefundGroupOrder2Args = {
  input: GroupOrderLevelRefundInput;
};


export type MutationRefundReusableContainerDepositArgs = {
  input: RefundReusableContainerDepositInput;
};


export type MutationRegister2Args = {
  platform?: InputMaybe<Platform>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  signUpEntryPoint?: InputMaybe<Scalars['String']['input']>;
  userInput: UserInput;
  utm?: InputMaybe<UtmInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRegisterPushTokenArgs = {
  input: PushNotificationTokenInput;
};


export type MutationReindexFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationRemoveAdminUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationRemoveBackgroundFromPhotoArgs = {
  input: PhotoBackgroundRemovalsInput;
};


export type MutationRemoveCreditCardArgs = {
  cardId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveSeasonalAssignmentArgs = {
  assignmentId: Scalars['Int']['input'];
};


export type MutationRemoveUserFromHubsArgs = {
  input: AddUserFromHubInput;
};


export type MutationRequestBulkGroupOrderDeliveryArgs = {
  deliveryHubId?: InputMaybe<Scalars['Int']['input']>;
  forceRequest?: InputMaybe<Scalars['Boolean']['input']>;
  groupOrderIds: Array<Scalars['String']['input']>;
  tipOverride?: InputMaybe<Scalars['Int']['input']>;
  useTimeWindows?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRequestGroupOrderDeliveriesArgs = {
  forceRequest?: InputMaybe<Scalars['Boolean']['input']>;
  groupOrderIds: Array<Scalars['String']['input']>;
  hyperBatched?: InputMaybe<Scalars['Boolean']['input']>;
  tipOverride?: InputMaybe<Scalars['Int']['input']>;
  useTimeWindows?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationResetChangePasswordArgs = {
  password: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSaveCreditCardArgs = {
  creditCardInput?: InputMaybe<SavedCreditCardInput>;
};


export type MutationSaveCreditCardFromPaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationSaveDeliveryAddressArgs = {
  addressInput: AddressInput;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSaveShefApplicationQuestionnaireArgs = {
  input: ShefApplicationQuestionnaireInput;
};


export type MutationScanDropOffOrderArgs = {
  input: DropOffScanInput;
};


export type MutationSetCartItemArgs = {
  cartLineItemInput: CartLineItemInput;
};


export type MutationSetCartItemsArgs = {
  cartLineItemInputs: Array<CartLineItemInput>;
};


export type MutationSetSeasonalCoreHandoffArgs = {
  assignmentId: Scalars['Int']['input'];
  keepOnCore: Scalars['Boolean']['input'];
};


export type MutationSetTableRunDeliveryAddressArgs = {
  input: SetTableRunDeliveryAddressInput;
};


export type MutationSignUpAsTableRunShefArgs = {
  input: SignUpAsTableRunShefInput;
};


export type MutationSkipMealPlanGroupOrderArgs = {
  input: SkipMealPlanGroupOrderInput;
};


export type MutationStartTableRunTrialArgs = {
  input: StartTableRunTrialInput;
};


export type MutationSubmitLeadCaptureArgs = {
  input: SubmitLeadCaptureInput;
};


export type MutationSubscribeToTableRunPlanArgs = {
  input: SubscribeToTableRunPlanInput;
};


export type MutationTagShefByTagIdArgs = {
  shefId: Scalars['String']['input'];
  tagIds: Array<Scalars['String']['input']>;
};


export type MutationTagShefByTagSlugArgs = {
  shefId: Scalars['String']['input'];
  tagSlugs: Array<Scalars['String']['input']>;
};


export type MutationUnclaimPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
  unclaimReason: Scalars['String']['input'];
};


export type MutationUndoSeasonalAssignmentRemovalArgs = {
  assignmentId: Scalars['Int']['input'];
};


export type MutationUnfavoriteFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type MutationUnfollowShefArgs = {
  shefId: Scalars['String']['input'];
};


export type MutationUnscanDropOffOrderArgs = {
  input: UnscanInput;
};


export type MutationUnskipMealPlanGroupOrderArgs = {
  input: UnskipMealPlanGroupOrderInput;
};


export type MutationUpdateAddOnItemStatusArgs = {
  active: Scalars['Boolean']['input'];
  addOnItemId: Scalars['Int']['input'];
  regionId: Scalars['Int']['input'];
};


export type MutationUpdateConfigArgs = {
  name: FeatureName;
  overrides: Array<ConfigOverrideInput>;
  value: Scalars['String']['input'];
};


export type MutationUpdateCoreMenuArgs = {
  additions: Array<CoreMenuAdditionInput>;
  removals: Array<CoreMenuRemovalInput>;
  restorations: Array<Scalars['Int']['input']>;
};


export type MutationUpdateExploreMerchandisePageArgs = {
  id: Scalars['String']['input'];
  page: ExploreMerchandisePageInput;
};


export type MutationUpdateExplorePagePromoCodeArgs = {
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type MutationUpdateFoodItemChangeRequestArgs = {
  autoApproveIfPossible?: InputMaybe<Scalars['Boolean']['input']>;
  changeset?: InputMaybe<FoodItemChangesetInput>;
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemChangeRequestId: Scalars['Int']['input'];
  photoEditRequestNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RequestStatus>;
};


export type MutationUpdateLimitedTimeMenuArgs = {
  assignmentIdsToRemove: Array<Scalars['Int']['input']>;
  assignmentIdsToUndoRemoval: Array<Scalars['Int']['input']>;
  assignmentsToAdd: Array<LimitedTimeAdditionInput>;
};


export type MutationUpdateMerchandisePageTagFilterArgs = {
  tagFilter: UpdateMerchandisePageTagFilterInput;
};


export type MutationUpdateMyTableRunStorefrontArgs = {
  input: UpdateMyTableRunStorefrontInput;
};


export type MutationUpdatePhotoEditRequestArgs = {
  id: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
};


export type MutationUpdatePhotoEditStatusArgs = {
  changeRequestId: Scalars['Int']['input'];
  status: RequestStatus;
};


export type MutationUpdateShefApplicationProfileImagesArgs = {
  profileImageInput?: InputMaybe<ShefApplicationProfileInput>;
  shefId: Scalars['String']['input'];
};


export type MutationUpdateShefOrderRatingCategoryArgs = {
  category: OrderRatingCategory;
  ratingId: Scalars['Int']['input'];
};


export type MutationUpdateShefTagArgs = {
  tag: ShefTagInput;
  tagId: Scalars['String']['input'];
};


export type MutationUpdateShefZipCodeArgs = {
  newZipCode: Scalars['String']['input'];
};


export type MutationUpdateTableRunMembershipPaymentMethodArgs = {
  input: UpdateTableRunMembershipPaymentMethodInput;
};


export type MutationUpdateTableRunStorefrontArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTableRunStorefrontInput;
};


export type MutationUpdateTasteProfileArgs = {
  input: TasteProfileMutationInput;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  input: UserNotificationSettingUpdate;
};


export type MutationUpsertFoodItemChangeRequestContextArgs = {
  foodItemChangeRequestId: Scalars['Int']['input'];
  input: FoodItemChangeRequestContextInput;
};


export type MutationUpsertMealPlanShefPayoutOverrideArgs = {
  input: UpsertMealPlanShefPayoutOverrideInput;
};


export type MutationUpsertSeasonalAssignmentsArgs = {
  assignments: Array<SeasonalAdditionInput>;
};


export type MutationValidateFoodItemDraftArgs = {
  draft: FoodItemValidationDraftInput;
  foodItemId: Scalars['Int']['input'];
};


export type MutationValidateMealPlanPaymentMethodArgs = {
  input: ValidateMealPlanPaymentMethodInput;
};

export type MutationResponse = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum NewOrderNotificationFrequency {
  AllOrders = 'ALL_ORDERS',
  FirstOrderPerDeliveryDay = 'FIRST_ORDER_PER_DELIVERY_DAY',
  NeverNotify = 'NEVER_NOTIFY'
}

export enum NotificationCategory {
  Delivery = 'DELIVERY',
  Marketing = 'MARKETING'
}

export type NumberAvailableDishesResult = {
  __typename?: 'NumberAvailableDishesResult';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type NumberAvailableShefsResult = {
  __typename?: 'NumberAvailableShefsResult';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export enum OAuthLoginType {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  GoogleAndroid = 'GOOGLE_ANDROID',
  GoogleIos = 'GOOGLE_IOS',
  GoogleWeb = 'GOOGLE_WEB'
}

export type OAuthMissingFieldsResult = {
  __typename?: 'OAuthMissingFieldsResult';
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameIsMissing?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameIsMissing?: Maybe<Scalars['Boolean']['output']>;
  needsToAcceptTermsOfService?: Maybe<Scalars['Boolean']['output']>;
  phoneNumberIsMissing?: Maybe<Scalars['Boolean']['output']>;
  zipCodeIsMissing?: Maybe<Scalars['Boolean']['output']>;
};

export type OAuthResult = AuthResult | OAuthMissingFieldsResult;

export type Order = {
  __typename?: 'Order';
  addOnItems: Array<OrderAddOnItem>;
  addOnItemsTotal: Scalars['Int']['output'];
  address: Address;
  availableAddOnItems: Array<AddOnItem>;
  bagCount?: Maybe<Scalars['Int']['output']>;
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  consumerOrderStatus: ConsumerOrderStatus;
  correctedRefundReason?: Maybe<Scalars['String']['output']>;
  correctedRefundType?: Maybe<RefundType>;
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  delivery?: Maybe<Delivery>;
  deliveryAddressId: Scalars['Int']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  deliveryDiscount?: Maybe<Scalars['Int']['output']>;
  deliveryEditableCutoff?: Maybe<Scalars['DateTime']['output']>;
  deliveryFee: Scalars['Int']['output'];
  deliveryId?: Maybe<Scalars['String']['output']>;
  deliveryNotes?: Maybe<Scalars['String']['output']>;
  deliveryOrderNumber?: Maybe<Scalars['Int']['output']>;
  deliveryType: Scalars['String']['output'];
  discountApplied: Scalars['Int']['output'];
  droppedOffAt?: Maybe<Scalars['DateTime']['output']>;
  droppedOffWithinWindow?: Maybe<Scalars['Boolean']['output']>;
  foodRating?: Maybe<ShefOrderRating>;
  fulfillmentDate: Scalars['DateTime']['output'];
  grandTotal: Scalars['Int']['output'];
  groupOrderId: Scalars['String']['output'];
  groupOrderItemCount: Scalars['Int']['output'];
  groupOrderRoute?: Maybe<Scalars['String']['output']>;
  groupOrderSize: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isBackToBackOrder: Scalars['Boolean']['output'];
  isCancelable: Scalars['Boolean']['output'];
  isDeliveryEditable: Scalars['Boolean']['output'];
  /**
   * True when user is on orders 1-4 of a meal plan subscription (positions 0-3).
   * Used for special F4 labeling on order labels.
   */
  isF4User: Scalars['Boolean']['output'];
  isFirstOrder: Scalars['Boolean']['output'];
  isFollower: Scalars['Boolean']['output'];
  isLineItemsEditable: Scalars['Boolean']['output'];
  isReusablePackaging: Scalars['Boolean']['output'];
  isTasteTest: Scalars['Boolean']['output'];
  /**
   * True when this order is REFUNDED but no money was exchanged for it
   * (i.e., the order was cancelled before payment).
   */
  isUnpaidRefund: Scalars['Boolean']['output'];
  lineItems: Array<OrderLineItem>;
  lineItemsEditableCutoff?: Maybe<Scalars['DateTime']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numOrdersFromShef: Scalars['Int']['output'];
  orderStatus: OrderStatus;
  orderType: OrderType;
  orderVisibility: OrderVisibility;
  paymentProcessor: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  pickupAddress?: Maybe<Address>;
  pickupAddressId?: Maybe<Scalars['Int']['output']>;
  pickupDeliveryHub?: Maybe<DeliveryHub>;
  platformFee: Scalars['Int']['output'];
  platformPayment: Scalars['Int']['output'];
  possibleDeliveryDates: Array<PossibleDeliveryDate>;
  promoCode?: Maybe<PromoCode>;
  publicShef: PublicShef;
  qaCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  qaPhotoUrl?: Maybe<Scalars['String']['output']>;
  readyForPickupTimetamp?: Maybe<Scalars['DateTime']['output']>;
  recurringNotes?: Maybe<Scalars['String']['output']>;
  refundAmount?: Maybe<Scalars['Int']['output']>;
  refundId?: Maybe<Scalars['String']['output']>;
  refundMessage?: Maybe<Scalars['String']['output']>;
  refundNotes?: Maybe<Scalars['String']['output']>;
  refundReason?: Maybe<Scalars['String']['output']>;
  refundTimestamp?: Maybe<Scalars['DateTime']['output']>;
  refundType?: Maybe<RefundType>;
  region: RegionInfo;
  reversedShefPaymentAmount: Scalars['Int']['output'];
  salesTax: Scalars['Int']['output'];
  scannedAtHubId?: Maybe<Scalars['Int']['output']>;
  scannedById?: Maybe<Scalars['Int']['output']>;
  serviceFee: Scalars['Int']['output'];
  shef: User;
  /**
   * Null on an order placed before its brand captured a delivery window, and on any order whose
   * window could not be resolved. Nullable rather than throwing because this sits in a non-null list:
   * one order without a window used to empty the cook's whole day, their other brand's orders
   * included.
   */
  shefFulfillmentTimeWindow?: Maybe<OrderTimeWindow>;
  shefFulfillmentTimeWindowId?: Maybe<Scalars['Int']['output']>;
  shefId: Scalars['String']['output'];
  shefPayment: Scalars['Int']['output'];
  shefPlatformPercent: Scalars['Int']['output'];
  shefProfile: ShefProfile;
  shefTip?: Maybe<Scalars['Int']['output']>;
  smallOrderFee: Scalars['Int']['output'];
  subscription?: Maybe<Subscription>;
  subscriptionInvoiceId?: Maybe<Scalars['String']['output']>;
  subtotal: Scalars['Int']['output'];
  timeWindow: OrderTimeWindow;
  timeWindowId?: Maybe<Scalars['Int']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type OrderAddOnItem = {
  __typename?: 'OrderAddOnItem';
  addOnItem: AddOnItem;
  addOnItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  transactionLineItemId?: Maybe<Scalars['String']['output']>;
};

export type OrderAddOnItemInput = {
  addOnItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderInput = {
  addOnItems: Array<OrderAddOnItemInput>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate: Scalars['DateTime']['input'];
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  expectedAdditionalDeliveryDateSpend?: InputMaybe<Scalars['Int']['input']>;
  lineItems: Array<OrderLineItemInput>;
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  phone: Scalars['String']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  recurringNotes?: InputMaybe<Scalars['String']['input']>;
  recurringPeriod?: InputMaybe<RecurringPeriod>;
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
  shefTip?: InputMaybe<Scalars['Int']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subtotal: Scalars['Int']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderLevelRefundInput = {
  orderId: Scalars['Int']['input'];
  orderLineItemIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  refundDetails?: InputMaybe<Scalars['String']['input']>;
  refundReason: RefundGroupOrderReasonInput;
  refundType: GroupOrderRefundType;
};

export type OrderLineItem = {
  __typename?: 'OrderLineItem';
  customizationIds?: Maybe<Array<Scalars['String']['output']>>;
  customizations?: Maybe<Array<FoodItemCustomization>>;
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  foodItemSnapshot?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['Int']['output'];
  imageUrl: Scalars['String']['output'];
  isRefunded: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderId: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  rating?: Maybe<FoodItemRating>;
  slug: Scalars['String']['output'];
  upsellTierSnapshot?: Maybe<Scalars['JSONObject']['output']>;
  userId: Scalars['String']['output'];
};

export type OrderLineItemInput = {
  customizationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  foodItemId: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type OrderModifyInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  discountApplied?: InputMaybe<Scalars['Int']['input']>;
  grandTotal?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  paymentProcessor?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformFee?: InputMaybe<Scalars['Int']['input']>;
  platformPayment?: InputMaybe<Scalars['Int']['input']>;
  readyForPickupTimetamp?: InputMaybe<Scalars['DateTime']['input']>;
  refundAmount?: InputMaybe<Scalars['Int']['input']>;
  refundId?: InputMaybe<Scalars['String']['input']>;
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundNotes?: InputMaybe<Scalars['String']['input']>;
  refundReason?: InputMaybe<Scalars['String']['input']>;
  refundTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  refundType?: InputMaybe<RefundType>;
  serviceFee?: InputMaybe<Scalars['Int']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
  shefPayment?: InputMaybe<Scalars['Int']['input']>;
  shefTip?: InputMaybe<Scalars['Int']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderRatingCategory {
  Delivery = 'DELIVERY',
  Food = 'FOOD'
}

export type OrderRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemRatings?: InputMaybe<Array<FoodItemRatingInput>>;
  orderId: Scalars['Int']['input'];
  privateComment?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
};

export type OrderRatingTags = {
  __typename?: 'OrderRatingTags';
  ignoreFoodTags?: Maybe<Array<Scalars['String']['output']>>;
  negativeFoodTags: Array<Scalars['String']['output']>;
  neutralFoodTags: Array<Scalars['String']['output']>;
  positiveFoodTags: Array<Scalars['String']['output']>;
};

export type OrderRefundInput = {
  groupOrderId: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  refundAmount: Scalars['Int']['input'];
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundNotes?: InputMaybe<Scalars['String']['input']>;
  refundReason: Scalars['String']['input'];
  refundType: RefundType;
};

export type OrderResult = {
  __typename?: 'OrderResult';
  clientSecret?: Maybe<Scalars['String']['output']>;
  order: Order;
};

export type OrderResults = {
  __typename?: 'OrderResults';
  orders: Array<Order>;
  pagination: Pagination;
};

export enum OrderStatus {
  AwaitingPickup = 'AWAITING_PICKUP',
  Completed = 'COMPLETED',
  Held = 'HELD',
  InTransit = 'IN_TRANSIT',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Preparing = 'PREPARING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Refunded = 'REFUNDED',
  RequestingPickup = 'REQUESTING_PICKUP',
  Skipped = 'SKIPPED'
}

export type OrderTimeWindow = {
  __typename?: 'OrderTimeWindow';
  endMsAfterMidnight: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startMsAfterMidnight: Scalars['Int']['output'];
};

export type OrderTotals = {
  __typename?: 'OrderTotals';
  deliveryFee: Scalars['Int']['output'];
  /** Deprecated: Use `promoApplied`. This value will equal `promoApplied` for now */
  discountApplied: Scalars['Int']['output'];
  /** Amount deducted from order using a gift card (only applicable for meal plan orders) */
  giftCardApplied?: Maybe<Scalars['Int']['output']>;
  grandTotal: Scalars['Int']['output'];
  /** Temporary property to hold amount deducted via discounts */
  nonPromoDiscountApplied: Scalars['Int']['output'];
  /** Amount deducted from order using a promo code */
  promoApplied: Scalars['Int']['output'];
  remainingToRemoveSmallOrderFee: Scalars['Int']['output'];
  reusablePackagingCleaningFee?: Maybe<Scalars['Int']['output']>;
  salesTax: Scalars['Int']['output'];
  serviceFee: Scalars['Int']['output'];
  shefTip: Scalars['Int']['output'];
  shefTipOptions: Array<TipOption>;
  smallOrderFee: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
};

export type OrderTotalsAddressInput2 = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  province: Scalars['String']['input'];
  street: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export enum OrderType {
  MealPlan = 'MEAL_PLAN',
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export enum OrderVisibility {
  Full = 'FULL',
  SummaryOnly = 'SUMMARY_ONLY'
}

export type Organization = {
  __typename?: 'Organization';
  address?: Maybe<Address>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  slug: Scalars['String']['output'];
};

/**
 * Snapshot of the original proposal context (first changeset only).
 * Separate type to avoid Apollo cache collisions with FoodItemChangeRequestContext.
 */
export type OriginalContextView = {
  __typename?: 'OriginalContextView';
  additionalInfo?: Maybe<Scalars['String']['output']>;
  components?: Maybe<Scalars['String']['output']>;
  cookingMethod?: Maybe<Scalars['String']['output']>;
  flavorProfile?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<ProposedDishReason>;
};

export enum Packaging {
  Compostable = 'COMPOSTABLE',
  Recylable = 'RECYLABLE',
  Reusable = 'REUSABLE',
  Unknown = 'UNKNOWN'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['ID']['output']>;
};

export type PaginatedPromoCodes = {
  __typename?: 'PaginatedPromoCodes';
  pagination: Pagination;
  promoCodes: Array<PromoCode>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  resultsPerPage: Scalars['Int']['output'];
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PerShefHeldOrderModifyInput = {
  lineItems: Array<OrderLineItemInput>;
  shefId: Scalars['String']['input'];
};

export type PerShefOrderInput = {
  lineItems: Array<OrderLineItemInput>;
  lineItemsSubtotal?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};

export type PerShefOrderModifyInput = {
  lineItems: Array<OrderLineItemInput>;
  lineItemsSubtotal: Scalars['Int']['input'];
  shefId: Scalars['String']['input'];
};

export type PhotoBackgroundRemovals = {
  __typename?: 'PhotoBackgroundRemovals';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  newImageUrl: Scalars['String']['output'];
  oldImageUrl: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  uploaderId: Scalars['String']['output'];
};

export type PhotoBackgroundRemovalsInput = {
  oldImageUrl: Scalars['String']['input'];
};

export type PhotoBackgroundRemovalsResult = {
  __typename?: 'PhotoBackgroundRemovalsResult';
  newImageUrl: Scalars['String']['output'];
};

export type PhotoEditRequest = {
  __typename?: 'PhotoEditRequest';
  editedImageUrl?: Maybe<Scalars['String']['output']>;
  editor?: Maybe<User>;
  editorUserId?: Maybe<Scalars['String']['output']>;
  foodItem: FoodItem;
  foodItemChangeRequest: FoodItemChangeRequest;
  foodItemChangeRequestId: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  status: PhotoEditRequestStatus;
};

export type PhotoEditRequestResults = {
  __typename?: 'PhotoEditRequestResults';
  pagination: Pagination;
  photoEditRequests: Array<PhotoEditRequest>;
};

export enum PhotoEditRequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Rejected = 'REJECTED'
}

export type PlaceTableRunOneTimeOrderInput = {
  /** A saved address. Supply exactly one of `addressId` or `deliveryAddress`. */
  addressId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A new address, for a customer with none saved. Created as part of the same transaction that
   * places the order, so a shef who cannot deliver there leaves no address behind.
   */
  deliveryAddress?: InputMaybe<AddressInput>;
  /**
   * The delivery window the customer chose, from `TableRunStorefront.deliveryTimeWindows`. Required
   * once the storefront has windows to offer: it is what tells the courier when to collect and when
   * to hand over, and an order without one cannot be dispatched.
   */
  deliveryTimeWindowId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * One entry per dish. `customizationIds` takes at most one serving size and one spice level, each
   * from the dish's own customizations.
   */
  lineItems: Array<OrderLineItemInput>;
  paymentMethodId: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type PossibleDeliveryDate = {
  __typename?: 'PossibleDeliveryDate';
  date: Scalars['String']['output'];
  possible: DeliveryDateChangePossible;
  reason?: Maybe<Scalars['String']['output']>;
  unavailableItems: Array<UnavailableFoodItem>;
};

export type PossibleDeliveryHubsForShefInput = {
  shefId: Scalars['String']['input'];
};

export type PostCheckOutUpsellRecommendations = {
  __typename?: 'PostCheckOutUpsellRecommendations';
  foodItems: Array<FoodItem>;
  shefs: Array<PublicShef>;
};

export type PrefabFoodItemStats = {
  __typename?: 'PrefabFoodItemStats';
  copyCount: Scalars['Int']['output'];
  imageCopyCount: Scalars['Int']['output'];
  isDuplicatedInSameRegion: Scalars['Boolean']['output'];
  isImageDuplicatedInSameRegion: Scalars['Boolean']['output'];
  regionalCopyInfo: Array<PrefabRegionalCopyInfo>;
  sameRegionCopyCount: Scalars['Int']['output'];
  sameRegionImageCopyCount: Scalars['Int']['output'];
};

export type PrefabRegionalCopyInfo = {
  __typename?: 'PrefabRegionalCopyInfo';
  copyCount: Scalars['Int']['output'];
  imageCopyCount: Scalars['Int']['output'];
  regionId: Scalars['Int']['output'];
};

export enum PriceFactorType {
  Nominal = 'NOMINAL',
  Percentage = 'PERCENTAGE'
}

export enum PriceLevel {
  FourDollarSign = 'FOUR_DOLLAR_SIGN',
  OneDollarSign = 'ONE_DOLLAR_SIGN',
  ThreeDollarSign = 'THREE_DOLLAR_SIGN',
  TwoDollarSign = 'TWO_DOLLAR_SIGN'
}

export enum Printer {
  Dymo = 'DYMO',
  LaserOrInkjet = 'LASER_OR_INKJET'
}

export type ProfessionalExperienceInput = {
  establishment: Scalars['String']['input'];
  establishmentType: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export enum ProfilePhotoSubmissionStatus {
  Accepted = 'ACCEPTED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED',
  Unsubmitted = 'UNSUBMITTED'
}

export type PromoCode = {
  __typename?: 'PromoCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator: User;
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  doesBalanceCarryOver: Scalars['Boolean']['output'];
  endTimestamp?: Maybe<Scalars['DateTime']['output']>;
  firstPromoOnly: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isExplorePagePromo: Scalars['Boolean']['output'];
  isFreeDelivery: Scalars['Boolean']['output'];
  isMealPlanEnabled: Scalars['Boolean']['output'];
  isMealPlanExclusive: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  isShefToConsumerPromo: Scalars['Boolean']['output'];
  isUsed: Scalars['Boolean']['output'];
  maxUses?: Maybe<Scalars['Int']['output']>;
  maxUsesPerUser?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Int']['output']>;
  minOrderValue?: Maybe<Scalars['Int']['output']>;
  onlyUsableOnDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  promoCodeType: PromoCodeType;
  referee?: Maybe<User>;
  referrer?: Maybe<User>;
  remainingBalance?: Maybe<Scalars['Int']['output']>;
  restrictedToCuisineRegions?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToRegionIds?: Maybe<Array<Scalars['Int']['output']>>;
  restrictedToShefId?: Maybe<Scalars['String']['output']>;
  restrictedToShefIds?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToUserEmails?: Maybe<Array<Scalars['String']['output']>>;
  restrictedToUserIds?: Maybe<Array<Scalars['String']['output']>>;
  showsPersistentBanner?: Maybe<Scalars['Boolean']['output']>;
  startTimestamp?: Maybe<Scalars['DateTime']['output']>;
  uses: Scalars['Int']['output'];
  usesRemainingForUser?: Maybe<Scalars['Int']['output']>;
  value: Scalars['Int']['output'];
};

export type PromoCodeInput = {
  codeBase?: InputMaybe<Scalars['String']['input']>;
  doesBalanceCarryOver?: InputMaybe<Scalars['Boolean']['input']>;
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  firstPromoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isFreeDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  isUsableByShefsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  maxUsesPerUser?: InputMaybe<Scalars['Int']['input']>;
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  promoCodeType: PromoCodeType;
  referrerUserId?: InputMaybe<Scalars['String']['input']>;
  restrictedToCuisineRegions?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToRegionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  restrictedToShefIds?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  restrictedToUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['Int']['input'];
};

export type PromoCodeResult = {
  __typename?: 'PromoCodeResult';
  code?: Maybe<PromoCode>;
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  promoCodeString: Scalars['String']['output'];
  remainingUses?: Maybe<Scalars['Int']['output']>;
};


export type PromoCodeResultRemainingUsesArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type PromoCodeTag = {
  __typename?: 'PromoCodeTag';
  codeId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  tag?: Maybe<PromoCodeTagType>;
  tagId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromoCodeTagType = {
  __typename?: 'PromoCodeTagType';
  createdAt: Scalars['DateTime']['output'];
  creator?: Maybe<User>;
  creatorUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tag: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PromoCodeTagTypesResult = {
  __typename?: 'PromoCodeTagTypesResult';
  pagination: Pagination;
  promoCodeTagTypes: Array<PromoCodeTagType>;
};

export enum PromoCodeType {
  CustomerHappiness = 'CUSTOMER_HAPPINESS',
  GiftCard = 'GIFT_CARD',
  OrganizationInternal = 'ORGANIZATION_INTERNAL',
  Promotional = 'PROMOTIONAL',
  Recruiting = 'RECRUITING',
  Referral = 'REFERRAL',
  ReferralReward = 'REFERRAL_REWARD',
  ShefPromotional = 'SHEF_PROMOTIONAL',
  TasterReward = 'TASTER_REWARD'
}

export type PromoCodeUsage = {
  __typename?: 'PromoCodeUsage';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isVoid: Scalars['Boolean']['output'];
  orderId?: Maybe<Scalars['Int']['output']>;
  promoCode?: Maybe<PromoCode>;
  promoCodeId: Scalars['Int']['output'];
  referee?: Maybe<User>;
  referrerRewardPromoCodeId?: Maybe<Scalars['Int']['output']>;
  referrerUserId?: Maybe<Scalars['String']['output']>;
  referrerValue: Scalars['Int']['output'];
  stripeFingerprint?: Maybe<Scalars['String']['output']>;
  transactionLineItemId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

/**
 * Union of WssNewDishProposalReason and WssEditProposalReason.
 * Keep in sync with those enums when adding/removing values.
 */
export enum ProposedDishReason {
  Cost = 'COST',
  DataIssue = 'DATA_ISSUE',
  DishAvailability = 'DISH_AVAILABILITY',
  ExpandMenu = 'EXPAND_MENU',
  LimitedTimeDishes = 'LIMITED_TIME_DISHES',
  MacrosUpdate = 'MACROS_UPDATE',
  MajorIngredient = 'MAJOR_INGREDIENT',
  MinorAdjustment = 'MINOR_ADJUSTMENT',
  MinorIngredient = 'MINOR_INGREDIENT',
  OrganicAndMore = 'ORGANIC_AND_MORE',
  Performance = 'PERFORMANCE',
  PortionSize = 'PORTION_SIZE',
  RotatingMenuGroups = 'ROTATING_MENU_GROUPS',
  SeasonalRefresh = 'SEASONAL_REFRESH',
  TierAdjustment = 'TIER_ADJUSTMENT'
}

export enum Protein {
  BeansLentils = 'BEANS_LENTILS',
  Beef = 'BEEF',
  Chicken = 'CHICKEN',
  Dairy = 'DAIRY',
  Egg = 'EGG',
  Fish = 'FISH',
  Lamb = 'LAMB',
  NutsGrains = 'NUTS_GRAINS',
  Plant = 'PLANT',
  Pork = 'PORK',
  Shellfish = 'SHELLFISH',
  Tofu = 'TOFU',
  Turkey = 'TURKEY'
}

export type PublicOrder = {
  __typename?: 'PublicOrder';
  addOnItems: Array<OrderAddOnItem>;
  createdAt: Scalars['DateTime']['output'];
  deliveryDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  lineItems: Array<OrderLineItem>;
  user: User;
  userId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type PublicReviewResult = {
  __typename?: 'PublicReviewResult';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deliveryDate: Scalars['Date']['output'];
  dishes: Array<OrderLineItem>;
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  privateComment?: Maybe<Scalars['String']['output']>;
  user: ReviewUser;
};

export type PublicReviewResults = {
  __typename?: 'PublicReviewResults';
  reviews: Array<PublicReviewResult>;
  total: Scalars['Int']['output'];
};

export type PublicShef = {
  __typename?: 'PublicShef';
  activeFoodItems: Array<FoodItem>;
  activeHolidayFoodItems: Array<FoodItem>;
  allowedToChat: Scalars['Boolean']['output'];
  availability: Array<ShefAvailability>;
  availabilityForDate?: Maybe<Scalars['Int']['output']>;
  celebrityEventType?: Maybe<CelebrityEventType>;
  cuisineCategories: Array<CuisineCategory>;
  deliveryPrice?: Maybe<DeliveryPrice>;
  firstName?: Maybe<Scalars['String']['output']>;
  flakeId: Scalars['String']['output'];
  hasEcoFriendlyPackaging: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isSoldOut: Scalars['Boolean']['output'];
  isTopShef: Scalars['Boolean']['output'];
  isTrialShef: Scalars['Boolean']['output'];
  mealPlanFoodItems: Array<FoodItem>;
  newDishCount: Scalars['Int']['output'];
  orderCountByUser: Scalars['Int']['output'];
  publicName: Scalars['String']['output'];
  rating?: Maybe<ShefRating>;
  regionalCuisineCategories: Array<CuisineCategory>;
  resizedImageUrl?: Maybe<Scalars['String']['output']>;
  shefProfile: ShefProfile;
  shefRosterStatus?: Maybe<ShefRosterStatus>;
  timeZone: Scalars['String']['output'];
  totalOrders: Scalars['Int']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type PublicShefActiveFoodItemsArgs = {
  dishFilters?: InputMaybe<ExploreFoodItemsFilterInput>;
  filters?: InputMaybe<ExploreSegmentsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type PublicShefActiveHolidayFoodItemsArgs = {
  filters?: InputMaybe<ExploreSegmentsFilterInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefAvailabilityArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefAvailabilityForDateArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefDeliveryPriceArgs = {
  destZipCode?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefIsSoldOutArgs = {
  filters: ExploreSegmentsFilterInput;
};


export type PublicShefMealPlanFoodItemsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  includeSoldOutDishes?: InputMaybe<Scalars['Boolean']['input']>;
  tasteProfile?: InputMaybe<TasteProfileInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type PublicShefResizedImageUrlArgs = {
  width: Scalars['Int']['input'];
};


export type PublicShefShefRosterStatusArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  tasteProfile?: InputMaybe<TasteProfileInput>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum PublishReportsZipOutcome {
  Published = 'PUBLISHED',
  Rejected = 'REJECTED'
}

export type PushNotificationToken = {
  __typename?: 'PushNotificationToken';
  platform: PushPlatform;
  token: Scalars['String']['output'];
  tokenType: PushTokenType;
  userId: Scalars['String']['output'];
};

export type PushNotificationTokenInput = {
  platform: PushPlatform;
  token: Scalars['String']['input'];
  tokenType: PushTokenType;
  userId: Scalars['String']['input'];
};

export enum PushPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export enum PushTokenType {
  Apn = 'APN',
  Fcm = 'FCM'
}

export type Query = {
  __typename?: 'Query';
  activeSubscriptions: SubscriptionConnection;
  adminDeliveryEventTypes: Array<DeliveryEventType>;
  adminDeliveryEventsByOrder: Array<DeliveryEvent>;
  adminFoodItems: FoodItemResults;
  adminGroupOrders: GroupOrderResults;
  adminLatestShefInsightsReportsZipPublish?: Maybe<ShefInsightsReportsZipPublish>;
  adminMealPlanGroupOrderByDeliveryDate?: Maybe<GroupOrder>;
  adminMealPlanGroupOrdersByUserId: Array<GroupOrder>;
  adminOpenFoodItemFindingsCsv: Scalars['String']['output'];
  adminOrderMetrics: Array<Maybe<DayStats>>;
  adminOrders: OrderResults;
  adminOrganizations?: Maybe<AdminOrganizationsResults>;
  adminOutstandingDepositRefunds: Array<ReusableDepositRefundPending>;
  adminOutstandingShefCharges: AdminOutstandingShefChargesResults;
  adminPreviewFoodItemFindings: FoodItemFindingsPreview;
  adminPromoCodeTagTypeAll: Array<PromoCodeTagType>;
  adminPromoCodeTagTypes: PromoCodeTagTypesResult;
  adminPromoCodes: AdminPromoCodeResults;
  adminRegionShefRankings: Array<RegionShefRanking>;
  adminShefCharges: Array<ShefCharge>;
  adminShefChargesPage: AdminShefChargesPageResults;
  adminShefFoodhandlers?: Maybe<AdminShefFoodhandlersResults>;
  adminShefs?: Maybe<AdminShefResults>;
  adminTablerunStorefrontById?: Maybe<TableRunStorefront>;
  adminTablerunStorefronts: AdminTableRunStorefrontResults;
  adminUsers?: Maybe<AdminUserResults>;
  adminValidateShefIds: Array<Scalars['String']['output']>;
  allOverrideSegments: Array<Scalars['String']['output']>;
  availableAddOnItems: Array<AddOnItem>;
  availableDeliveryDays: Array<Scalars['String']['output']>;
  cart: Array<CartLineItem>;
  carts: CartResults;
  categoricalRatings2: CategoricalRatingsResults;
  categoryPageRecentReviews?: Maybe<CategoryPageRecentReviewResult>;
  celebrityEventPopularShefs: Array<ExploreSegmentShef>;
  chatToken: Scalars['String']['output'];
  cityPageCities: Array<CityPageCity>;
  cityPageContent: CityPageContent;
  cityPageContent2: CityPageContent;
  cityPageRegionContent: CityPageContent;
  combinedSearch: CombinedSearchResults;
  configs: Array<Config>;
  consumerFoodItems: Array<FoodItem>;
  cuisineCategories: Array<CuisineCategory>;
  cuisineCategory: CuisineCategory;
  cuisineRegions: Array<CuisineRegion>;
  deliveryHubs: Array<DeliveryHub>;
  deliveryPrice?: Maybe<DeliveryPrice>;
  deliveryStatus?: Maybe<Scalars['String']['output']>;
  dietaryAnalysis?: Maybe<DietaryAnalysis>;
  dietaryDetailsForShef: Array<DietaryDetails>;
  exploreCuisine: ExploreCuisineResults;
  exploreFilterOptions?: Maybe<ExploreFilterOptionsResults>;
  exploreFoodItems: Array<ExploreFoodItemsSegment>;
  exploreFoodItemsFilterOptions?: Maybe<ExploreFoodItemsFilterOptionsResults>;
  exploreMerchandise: ExploreMerchandiseResults;
  exploreMerchandisePage: ExploreMerchandisePage;
  exploreSegments2: Array<ExploreSegment>;
  filtersForDeliveryHub: Array<CityPageFilter>;
  filtersForZip: Array<CityPageFilter>;
  followingPosts: Array<ShefPost>;
  foodItem: FoodItem;
  foodItemChangeRequest: FoodItemChangeRequest;
  foodItemChangeRequests: FoodItemChangeRequestResults;
  foodItemCustomizationTypes: Array<FoodItemCustomizationType>;
  foodItemFinding: FoodItemFinding;
  foodItemFindings: FoodItemFindingsResults;
  foodItemOrderReviews: PublicReviewResults;
  foodItemPopularity: FoodItemPopularityResult;
  foodItemPriceRecommendations: FoodItemPriceRecommendationResult;
  foodItemQuantityAvailability: Scalars['Int']['output'];
  foodItemSuggestions: Array<FoodItem>;
  foodItems: Array<FoodItem>;
  fullUrl: ShortUrl;
  getActiveMealPlanForUser?: Maybe<MealPlan>;
  getAvailablePromoCodesForUser: Array<PromoCode>;
  getConfigValue?: Maybe<Scalars['String']['output']>;
  getForYouMealPlanCollections?: Maybe<GetForYouMealPlanCollectionsResponse>;
  getMealPlanAddOnCollections?: Maybe<GetMealPlanAddOnCollectionsResponse>;
  getMealPlanDeliveryDaysOfWeek?: Maybe<GetMealPlanDeliveryDaysOfWeekResponse>;
  getMealPlanForUser?: Maybe<UserMealPlan>;
  getMealPlanShefPayoutOverrides: Array<MealPlanShefPayoutOverride>;
  /** @deprecated Use getMealPlanShefsForZipCode. Kept for in-flight bundles. */
  getMealPlanShefsForRegionId?: Maybe<GetMealPlanShefsResults>;
  getMealPlanShefsForZipCode?: Maybe<GetMealPlanShefsResults>;
  getMealPlanType: MealPlanType;
  getMealPlanTypeOptions: GetMealPlanTypeOptionsResponse;
  getMealPlanUpcomingOrder?: Maybe<GetMealPlanUpcomingOrderResponse>;
  getMealPlanningMenu?: Maybe<MealPlanningMenu>;
  getOrCreateShortUrl: ShortUrl;
  getRegisteredEmail?: Maybe<Scalars['String']['output']>;
  getRemainingGiftCardBalanceBeforeGroupOrder: GetRemainingGiftCardBalanceForGroupOrderResponse;
  getSearchResults: SearchResults;
  getShefEarningsDashboardUrl: Scalars['String']['output'];
  getShefInsightsDashboardUrl: Scalars['String']['output'];
  getShefInsightsReportPage?: Maybe<Scalars['String']['output']>;
  getShefRatingsDashboardUrl: Scalars['String']['output'];
  getShefRoster?: Maybe<GetShefRosterResponse>;
  getTasteProfile: GetTasteProfileResponse;
  getTasteProfileForUser?: Maybe<TasteProfile>;
  getTrendingSearches: Array<Scalars['String']['output']>;
  getUpcomingMealPlanGroupOrders?: Maybe<GetUpcomingMealPlanGroupOrdersResponse>;
  getValidCartForUser: GetValidCartForUserResponse;
  groupOrderById: GroupOrder;
  groupOrderTotals: OrderTotals;
  groupOrdersByDeliveryDate: Array<GroupOrder>;
  groupOrdersByIds: Array<GroupOrder>;
  hello?: Maybe<Scalars['String']['output']>;
  helloAdmin?: Maybe<Scalars['String']['output']>;
  intercomUserJwt: Scalars['String']['output'];
  isFeatureOn: Scalars['Boolean']['output'];
  latestCelebrityEventForZipCode?: Maybe<ZipCodeCelebrityEventMetadata>;
  lineDrives: Array<LineDrive>;
  listChangesets: Array<FoodItemChangeset>;
  makeItAMealSuggestions: Array<MakeItAMealDishSuggestions>;
  me?: Maybe<User>;
  mealPlan: MealPlan;
  mealPlanDeliveryDateDishCounts: Array<NumberAvailableDishesResult>;
  mealPlanOrderSalesTax: MealPlanOrderSalesTax;
  modifiedGroupOrderTotals: OrderTotals;
  /** @deprecated Use myActiveTablerunMealPlanWithShef. Kept for in-flight bundles. */
  myActiveTablerunMealPlan?: Maybe<TableRunMealPlan>;
  /**
   * The caller's active TableRun subscription with one storefront, if any.
   *
   * Keyed by slug rather than shef so a storefront the consumer cannot load — paused, or belonging
   * to a shef whose TableRun is inactive — can still identify its own subscribers.
   */
  myActiveTablerunMealPlanForSlug?: Maybe<TableRunMealPlan>;
  /** The caller's active TableRun subscription with one shef, if any. */
  myActiveTablerunMealPlanWithShef?: Maybe<TableRunMealPlan>;
  /** Every active TableRun subscription the caller holds, across storefronts. */
  myActiveTablerunMealPlans: Array<TableRunMealPlan>;
  myTableRunEligibility: TableRunEligibility;
  myTableRunStorefront?: Maybe<TableRunStorefront>;
  order?: Maybe<Order>;
  orders: ConsumerOrderResults;
  ordersByDateString: Array<Order>;
  ordersByDeliveryDate: Array<Order>;
  ordersById: Array<Order>;
  organization?: Maybe<Organization>;
  peopleAlsoOrderedRecommendations: Array<FoodItem>;
  photoEditRequest?: Maybe<PhotoEditRequest>;
  photoEditRequests: PhotoEditRequestResults;
  photoEditors: Array<User>;
  possibleDeliveryHubsForShef: Array<DeliveryHub>;
  postCheckoutOrderUpsellRecommendations: PostCheckOutUpsellRecommendations;
  preCheckoutOrderUpsellRecommendations: Array<FoodItem>;
  previousGroupOrders: GroupOrderConnection;
  printers?: Maybe<Array<Printer>>;
  promoCodeValue?: Maybe<PromoCodeResult>;
  promoCodeValues?: Maybe<Array<PromoCodeResult>>;
  publicOrderByUser?: Maybe<PublicOrder>;
  publicReviews: PublicReviewResults;
  recurringSubscriptionAvailability: RecurringSubscriptionAvailability;
  region: RegionInfo;
  regionAvailabilityForDeliveryDate: Array<Maybe<RegionAvailability>>;
  regionFromZip: RegionInfo;
  regionalShefCuisineCategories: Array<ShefCuisineCategory>;
  regions: Array<RegionInfo>;
  shef: PublicShef;
  shefApplication?: Maybe<ShefApplication>;
  shefApplicationTracker?: Maybe<ShefApplicationTracker>;
  shefAvailability: Array<Maybe<ShefAvailability>>;
  shefAvailabilityRules: Array<ShefAvailabilityRule>;
  shefDaysOfWeekAvailabilityRule?: Maybe<ShefAvailabilityRule>;
  shefFoodItems: FoodItemResults;
  shefLiveWssMenuFoodItems: Array<FoodItem>;
  shefMenuAssignments: Array<FoodItemMenuAssignment>;
  shefMenuChecklist: Array<ShefMenuChecklistAction>;
  shefMenuFilteredItems: FilteredFoodItemResults;
  shefMenuSegments: Array<ExploreFoodItemsSegment>;
  shefPosts: Array<ShefPost>;
  shefProfile?: Maybe<ShefProfile>;
  shefProfileByConsumerReferral?: Maybe<ShefProfile>;
  shefTag?: Maybe<ShefTagType>;
  shefTags: Array<ShefTagType>;
  shefTransferForDate?: Maybe<ShefTransferForDate>;
  shefs: Array<PublicShef>;
  sideCategories: Array<SideCategory>;
  sluggedFoodItem?: Maybe<FoodItem>;
  stripeId?: Maybe<Scalars['String']['output']>;
  suggestedItemsFromMenu: Array<SuggestedItem>;
  tableRunStorefrontByShefId?: Maybe<TableRunStorefront>;
  tablerunStorefrontBySlug?: Maybe<TableRunStorefront>;
  tablerunStorefrontEnabled: Scalars['Boolean']['output'];
  tablerunStorefrontForShef?: Maybe<TableRunStorefront>;
  tablerunStorefrontVisibility: TableRunStorefrontVisibility;
  tablerunStorefronts: TableRunStorefrontResults;
  taggedShefs: Array<ShefProfile>;
  tagsForConsumer: OrderRatingTags;
  tagsForShef: OrderRatingTags;
  timeWindowsForGroupOrder: Array<TimeWindow>;
  timeWindowsForOrder: Array<TimeWindow>;
  upcomingGroupOrders: GroupOrderConnection;
  upcomingOrders: Array<Order>;
  upsellPromo?: Maybe<PromoCode>;
  upsellTiers: Array<Upsell>;
  user?: Maybe<User>;
  userNotificationSettings: Array<UserNotificationSetting>;
  userSuggestions?: Maybe<Array<FoodItem>>;
  validDaysOfWeek: Array<Scalars['Int']['output']>;
  vamoGroupOrdersByDeliveryDateAndRegion: Array<VamoGroupOrder>;
  variant?: Maybe<Variant>;
  waitlistRanks: Array<WaitlistRank>;
  zipCode?: Maybe<ZipCode>;
  zipCodeCelebrityEventDetails: ZipCodeCelebrityEventMetadata;
  zipCodes: Array<Maybe<ZipCode>>;
};


export type QueryActiveSubscriptionsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
};


export type QueryAdminDeliveryEventsByOrderArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryAdminFoodItemsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchString: Scalars['String']['input'];
};


export type QueryAdminGroupOrdersArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryHubIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminMealPlanGroupOrderByDeliveryDateArgs = {
  deliveryDate: Scalars['String']['input'];
  mealPlanId: Scalars['String']['input'];
};


export type QueryAdminMealPlanGroupOrdersByUserIdArgs = {
  userId: Scalars['String']['input'];
};


export type QueryAdminOpenFoodItemFindingsCsvArgs = {
  filter?: InputMaybe<FoodItemFindingsFilterInput>;
};


export type QueryAdminOrderMetricsArgs = {
  timeZoneOffset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOrdersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminOrganizationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminOutstandingShefChargesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminPreviewFoodItemFindingsArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type QueryAdminPromoCodeTagTypesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  tagSearch?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminPromoCodesArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PromoCodeType>;
};


export type QueryAdminRegionShefRankingsArgs = {
  regionId: Scalars['Int']['input'];
};


export type QueryAdminShefChargesArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryAdminShefChargesPageArgs = {
  filter?: InputMaybe<ShefChargesFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminShefFoodhandlersArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  idFilter?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAdminShefsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  findingFilter?: InputMaybe<FoodItemFindingsFilterInput>;
  minOpenFindings?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  shefStatus?: InputMaybe<ShefStatus>;
};


export type QueryAdminTablerunStorefrontByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAdminTablerunStorefrontsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<TableRunStorefrontStatus>;
};


export type QueryAdminUsersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminValidateShefIdsArgs = {
  shefIds: Array<Scalars['String']['input']>;
};


export type QueryAvailableAddOnItemsArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailableDeliveryDaysArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryCartArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCartsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoricalRatings2Args = {
  limit: Scalars['Int']['input'];
  sqlLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryPageRecentReviewsArgs = {
  regionId: Scalars['Int']['input'];
};


export type QueryCelebrityEventPopularShefsArgs = {
  filters: ExploreFoodItemsFilterInput;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCityPageContentArgs = {
  deliveryHubId: Scalars['Int']['input'];
  filter?: InputMaybe<CityPageFilterInput>;
};


export type QueryCityPageContent2Args = {
  filter?: InputMaybe<CityPageFilterInput>;
  zipCode: Scalars['String']['input'];
};


export type QueryCityPageRegionContentArgs = {
  filter?: InputMaybe<CityPageFilterInput>;
  regionId: Scalars['Int']['input'];
};


export type QueryCombinedSearchArgs = {
  searchInput: SearchInput;
};


export type QueryConsumerFoodItemsArgs = {
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  shefId: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCuisineCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryDeliveryPriceArgs = {
  destZipCode: Scalars['String']['input'];
};


export type QueryDeliveryStatusArgs = {
  orderId: Scalars['Int']['input'];
};


export type QueryDietaryAnalysisArgs = {
  ingredients: Scalars['String']['input'];
};


export type QueryDietaryDetailsForShefArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryExploreCuisineArgs = {
  cuisineTitle: Scalars['String']['input'];
  filters: ExploreSegmentsFilterInput;
  seed: Scalars['String']['input'];
};


export type QueryExploreFilterOptionsArgs = {
  filters?: InputMaybe<ExploreSegmentsFilterInput>;
  zipCode: Scalars['String']['input'];
};


export type QueryExploreFoodItemsArgs = {
  availableDeliveryDays?: InputMaybe<Array<Scalars['String']['input']>>;
  filters: ExploreFoodItemsFilterInput;
  isLilyPad?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  numVisiblePerSegment: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  useDynamicPreviewImage?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryExploreFoodItemsFilterOptionsArgs = {
  filters: ExploreFoodItemsFilterInput;
  query?: InputMaybe<Scalars['String']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryExploreMerchandiseArgs = {
  filters: ExploreSegmentsFilterInput;
  seed: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryExploreMerchandisePageArgs = {
  slug: Scalars['String']['input'];
};


export type QueryExploreSegments2Args = {
  expectedPaginationInfo?: InputMaybe<ExpectedPaginationInfoInput>;
  filters: ExploreSegmentsFilterInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  seed: Scalars['String']['input'];
};


export type QueryFiltersForDeliveryHubArgs = {
  deliveryHubId: Scalars['Int']['input'];
};


export type QueryFiltersForZipArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryFollowingPostsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryFoodItemArgs = {
  foodItemId: Scalars['Int']['input'];
};


export type QueryFoodItemChangeRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFoodItemChangeRequestsArgs = {
  excludeProposals?: InputMaybe<Scalars['Boolean']['input']>;
  filterChangeType?: InputMaybe<ChangeRequestChangeTypeFilter>;
  filterFoodType?: InputMaybe<ChangeRequestFoodTypeFilter>;
  filterOrigin?: InputMaybe<ChangeRequestOriginFilter>;
  filterPhotoStatus?: InputMaybe<ChangeRequestPhotoStatusFilter>;
  filterReason?: InputMaybe<ProposedDishReason>;
  filterReviewStatus?: InputMaybe<ChangeRequestReviewStatusFilter>;
  filterSearch?: InputMaybe<Scalars['String']['input']>;
  filterShefType?: InputMaybe<ChangeRequestShefTypeFilter>;
  filterUserType?: InputMaybe<ChangeRequestUserTypeFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  proposalsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFoodItemFindingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFoodItemFindingsArgs = {
  filter?: InputMaybe<FoodItemFindingsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFoodItemOrderReviewsArgs = {
  foodItemId: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryFoodItemPopularityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sqlLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFoodItemPriceRecommendationsArgs = {
  foodItemInput: FoodItemPriceRecommendationInput;
};


export type QueryFoodItemQuantityAvailabilityArgs = {
  availableDate: Scalars['DateTime']['input'];
  foodItemId: Scalars['Int']['input'];
};


export type QueryFoodItemSuggestionsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryFoodItemsArgs = {
  foodItemIds: Array<Scalars['Int']['input']>;
};


export type QueryFullUrlArgs = {
  shortCode: Scalars['String']['input'];
};


export type QueryGetAvailablePromoCodesForUserArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetConfigValueArgs = {
  name: FeatureName;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetForYouMealPlanCollectionsArgs = {
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId: Scalars['Int']['input'];
  tasteProfile: TasteProfileInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetMealPlanAddOnCollectionsArgs = {
  deliveryDate: Scalars['String']['input'];
  hasLittleEaters?: InputMaybe<Scalars['Boolean']['input']>;
  isOnEditOrder?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanTypeId: Scalars['Int']['input'];
  tasteProfile: TasteProfileInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetMealPlanDeliveryDaysOfWeekArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryGetMealPlanForUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetMealPlanShefPayoutOverridesArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryGetMealPlanShefsForRegionIdArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  regionId: Scalars['Int']['input'];
};


export type QueryGetMealPlanShefsForZipCodeArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryGetMealPlanTypeArgs = {
  mealPlanTypeId: Scalars['Int']['input'];
};


export type QueryGetMealPlanTypeOptionsArgs = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  isInJanLaunch?: InputMaybe<Scalars['Boolean']['input']>;
  isInPricingExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  littleEaters?: InputMaybe<Scalars['Int']['input']>;
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetMealPlanUpcomingOrderArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetMealPlanningMenuArgs = {
  deliveryDate: Scalars['String']['input'];
  dietType?: InputMaybe<DietType>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  householdGoals?: InputMaybe<Array<HouseholdGoals>>;
  includeFullCapacityShefs?: InputMaybe<Scalars['Boolean']['input']>;
  ingredientPriorities?: InputMaybe<Array<IngredientPriority>>;
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  menuDietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  proteinFilters?: InputMaybe<Array<Protein>>;
  replacementDietaryRestrictions?: InputMaybe<Array<Scalars['String']['input']>>;
  sortPreferredProteins?: InputMaybe<Array<Protein>>;
  zipCode: Scalars['String']['input'];
};


export type QueryGetOrCreateShortUrlArgs = {
  fullUrl: Scalars['String']['input'];
};


export type QueryGetRegisteredEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetRemainingGiftCardBalanceBeforeGroupOrderArgs = {
  input: GetRemainingGiftCardBalanceForGroupOrderInput;
};


export type QueryGetSearchResultsArgs = {
  deliveryDate: Scalars['String']['input'];
  filters: ExploreFoodItemsFilterInput;
  isPartialQuery: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  searchState: SearchStateInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetShefInsightsReportPageArgs = {
  page: ShefInsightsReportPage;
};


export type QueryGetShefRosterArgs = {
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId: Scalars['Int']['input'];
  tasteProfile: TasteProfileInput;
  zipCode: Scalars['String']['input'];
};


export type QueryGetTasteProfileArgs = {
  input: GetTasteProfileInput;
};


export type QueryGetTrendingSearchesArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryGetUpcomingMealPlanGroupOrdersArgs = {
  input?: InputMaybe<GetUpcomingMealPlanGroupOrdersInput>;
};


export type QueryGetValidCartForUserArgs = {
  input: GetValidCartForUserInput;
};


export type QueryGroupOrderByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGroupOrderTotalsArgs = {
  groupOrderInput: GroupOrderTotalsInput;
};


export type QueryGroupOrdersByDeliveryDateArgs = {
  deliveryDate: Scalars['String']['input'];
  dropoffHubId?: InputMaybe<Scalars['Int']['input']>;
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGroupOrdersByIdsArgs = {
  groupOrderIds: Array<Scalars['String']['input']>;
};


export type QueryIsFeatureOnArgs = {
  name: FeatureName;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestCelebrityEventForZipCodeArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryLineDrivesArgs = {
  filters: LineDriveFilterInput;
};


export type QueryListChangesetsArgs = {
  foodItemChangeRequestId: Scalars['Int']['input'];
};


export type QueryMakeItAMealSuggestionsArgs = {
  deliveryDate: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  entreeIds: Array<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryMealPlanArgs = {
  mealPlanId: Scalars['String']['input'];
};


export type QueryMealPlanDeliveryDateDishCountsArgs = {
  includeFullCapacityShefs?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanFoodTypes?: InputMaybe<Array<MealPlanFoodType>>;
  useCurrentUserTasteProfile?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryMealPlanOrderSalesTaxArgs = {
  mealPlanOrderSalesTaxInput: MealPlanOrderSalesTaxInput;
};


export type QueryModifiedGroupOrderTotalsArgs = {
  input: ConsumerModifyGroupOrderInput;
};


export type QueryMyActiveTablerunMealPlanArgs = {
  shefId: Scalars['ID']['input'];
};


export type QueryMyActiveTablerunMealPlanForSlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryMyActiveTablerunMealPlanWithShefArgs = {
  shefId: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByDateStringArgs = {
  deliveryDate: Scalars['String']['input'];
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByDeliveryDateArgs = {
  deliveryDate: Scalars['String']['input'];
  includeRefunded?: InputMaybe<Scalars['Boolean']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrdersByIdArgs = {
  orderIds: Array<InputMaybe<Scalars['Int']['input']>>;
  orderUuids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type QueryOrganizationArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPeopleAlsoOrderedRecommendationsArgs = {
  cartFoodItemIds: Array<Scalars['Int']['input']>;
  deliveryDate: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode: Scalars['String']['input'];
};


export type QueryPhotoEditRequestArgs = {
  changeRequestId: Scalars['Int']['input'];
};


export type QueryPhotoEditRequestsArgs = {
  editorUserId?: InputMaybe<Scalars['String']['input']>;
  isWss?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPossibleDeliveryHubsForShefArgs = {
  input: PossibleDeliveryHubsForShefInput;
};


export type QueryPostCheckoutOrderUpsellRecommendationsArgs = {
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  groupOrderId: Scalars['String']['input'];
};


export type QueryPreCheckoutOrderUpsellRecommendationsArgs = {
  cartFoodItemIds: Array<Scalars['Int']['input']>;
  deliveryDate: Scalars['String']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode: Scalars['String']['input'];
};


export type QueryPreviousGroupOrdersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  brand?: Brand;
  first: Scalars['Int']['input'];
};


export type QueryPromoCodeValueArgs = {
  code: Scalars['String']['input'];
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  isGiftCardPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanCode: Scalars['Boolean']['input'];
  shefSubtotals?: InputMaybe<Array<ShefSubtotal>>;
};


export type QueryPromoCodeValuesArgs = {
  codes: Array<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  isGiftCardPromo?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanCode: Scalars['Boolean']['input'];
  shefSubtotals?: InputMaybe<Array<ShefSubtotal>>;
};


export type QueryPublicOrderByUserArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type QueryPublicReviewsArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  requireComments?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryRecurringSubscriptionAvailabilityArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryRegionArgs = {
  regionId: Scalars['Int']['input'];
};


export type QueryRegionAvailabilityForDeliveryDateArgs = {
  deliveryDate: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};


export type QueryRegionFromZipArgs = {
  zipCode: Scalars['String']['input'];
};


export type QueryShefArgs = {
  userId: Scalars['String']['input'];
};


export type QueryShefApplicationArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShefApplicationTrackerArgs = {
  userId: Scalars['String']['input'];
};


export type QueryShefAvailabilityArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefAvailabilityRulesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  unavailable?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryShefDaysOfWeekAvailabilityRuleArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryShefFoodItemsArgs = {
  availableOn?: InputMaybe<Scalars['String']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefLiveWssMenuFoodItemsArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuAssignmentsArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuChecklistArgs = {
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuFilteredItemsArgs = {
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters: ExploreFoodItemsFilterInput;
  shefId: Scalars['String']['input'];
};


export type QueryShefMenuSegmentsArgs = {
  availableDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<ExploreFoodItemsFilterInput>;
  loadFoodItemDescription?: InputMaybe<Scalars['Boolean']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefPostsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
};


export type QueryShefProfileArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShefProfileByConsumerReferralArgs = {
  code: Scalars['String']['input'];
};


export type QueryShefTagArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShefTransferForDateArgs = {
  deliveryDate: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
};


export type QueryShefsArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type QuerySluggedFoodItemArgs = {
  shefId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QuerySuggestedItemsFromMenuArgs = {
  deliveryDate: Scalars['DateTime']['input'];
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  foodItemId: Scalars['Int']['input'];
  numMains: Scalars['Int']['input'];
  shefTimeZone: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTableRunStorefrontByShefIdArgs = {
  shefId: Scalars['ID']['input'];
};


export type QueryTablerunStorefrontBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryTablerunStorefrontForShefArgs = {
  shefId: Scalars['ID']['input'];
};


export type QueryTablerunStorefrontVisibilityArgs = {
  slug: Scalars['String']['input'];
};


export type QueryTablerunStorefrontsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};


export type QueryTaggedShefsArgs = {
  excludeOp: TaggedShefOp;
  excludeSlugs: Array<Scalars['String']['input']>;
  includeOp: TaggedShefOp;
  includeSlugs: Array<Scalars['String']['input']>;
};


export type QueryTimeWindowsForGroupOrderArgs = {
  groupOrderId: Scalars['String']['input'];
};


export type QueryTimeWindowsForOrderArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUpcomingGroupOrdersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  brand?: Brand;
  first: Scalars['Int']['input'];
};


export type QueryUpsellPromoArgs = {
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUuid?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpsellTiersArgs = {
  regionId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserNotificationSettingsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUserSuggestionsArgs = {
  userId: Scalars['String']['input'];
};


export type QueryValidDaysOfWeekArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVamoGroupOrdersByDeliveryDateAndRegionArgs = {
  deliveryDate: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
};


export type QueryVariantArgs = {
  experimentName: Scalars['String']['input'];
  logExposure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryZipCodeArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZipCodeCelebrityEventDetailsArgs = {
  celebrityEventType: CelebrityEventType;
  zipCode: Scalars['String']['input'];
};

export type QueryResponse = {
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type RecentReview = {
  __typename?: 'RecentReview';
  review: PublicReviewResult;
  shef: PublicShef;
  user: User;
};

export type RecurringDeliveryPrefs = {
  __typename?: 'RecurringDeliveryPrefs';
  adventureLevelPct: Scalars['Int']['output'];
  allergens?: Maybe<Array<Scalars['String']['output']>>;
  cuisinePreferences?: Maybe<Array<Scalars['String']['output']>>;
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  dietaryPreferences?: Maybe<Array<Scalars['String']['output']>>;
  notes?: Maybe<Scalars['String']['output']>;
  oilinessPreferencePct?: Maybe<Scalars['Int']['output']>;
  preferredProteins?: Maybe<Array<Protein>>;
  spiceLevels?: Maybe<Array<Scalars['Int']['output']>>;
  userId?: Maybe<Scalars['String']['output']>;
  yafdinkAdditionalDietaryPrefs?: Maybe<Scalars['String']['output']>;
  yafdinkControlCalorieIntake?: Maybe<Scalars['Boolean']['output']>;
  yafdinkDinnersPerWeek?: Maybe<Scalars['Int']['output']>;
  yafdinkFoodGoals?: Maybe<Array<Scalars['String']['output']>>;
  yafdinkLunchesPerWeek?: Maybe<Scalars['Int']['output']>;
  yafdinkMealNeeds?: Maybe<Scalars['String']['output']>;
  yafdinkPrepareNutritionLabels?: Maybe<Scalars['Boolean']['output']>;
  yafdinkRequestedOrganicIngredients?: Maybe<Scalars['Boolean']['output']>;
  yafdinkTargetCalorieIntake?: Maybe<Scalars['String']['output']>;
  yafdinkTargetDiet?: Maybe<Scalars['String']['output']>;
  yafdinkTargetSpecificMacros?: Maybe<Scalars['Boolean']['output']>;
};

export type RecurringDeliveryPrefsInput = {
  adventureLevelPct: Scalars['Int']['input'];
  allergens?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisinePreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  dietaryPreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oilinessPreferencePct?: InputMaybe<Scalars['Int']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  spiceLevels?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  yafdinkAdditionalDietaryPrefs?: InputMaybe<Scalars['String']['input']>;
  yafdinkControlCalorieIntake?: InputMaybe<Scalars['Boolean']['input']>;
  yafdinkDinnersPerWeek?: InputMaybe<Scalars['Int']['input']>;
  yafdinkFoodGoals?: InputMaybe<Array<Scalars['String']['input']>>;
  yafdinkLunchesPerWeek?: InputMaybe<Scalars['Int']['input']>;
  yafdinkMealNeeds?: InputMaybe<Scalars['String']['input']>;
  yafdinkPrepareNutritionLabels?: InputMaybe<Scalars['Boolean']['input']>;
  yafdinkRequestedOrganicIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  yafdinkTargetCalorieIntake?: InputMaybe<Scalars['String']['input']>;
  yafdinkTargetDiet?: InputMaybe<Scalars['String']['input']>;
  yafdinkTargetSpecificMacros?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RecurringPeriod {
  FourteenDays = 'FOURTEEN_DAYS',
  None = 'NONE',
  SevenDays = 'SEVEN_DAYS'
}

export type RecurringSubscriptionAvailability = {
  __typename?: 'RecurringSubscriptionAvailability';
  subscriptionOptions: Array<SubscriptionOption>;
};

export type ReferralCode = {
  __typename?: 'ReferralCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  disabled: Scalars['Boolean']['output'];
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  getValue: Scalars['Int']['output'];
  giveValue: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isFreeDelivery: Scalars['Boolean']['output'];
  isPercentage: Scalars['Boolean']['output'];
  maxUsesPerUser?: Maybe<Scalars['Int']['output']>;
  minOrderValue?: Maybe<Scalars['Int']['output']>;
  uses: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export enum ReferralStripTextColor {
  Dark = 'dark',
  Light = 'light'
}

export type Refund = {
  __typename?: 'Refund';
  createdAt: Scalars['DateTime']['output'];
  groupOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['Int']['output']>;
  refundReason: Scalars['String']['output'];
  refundType: Scalars['String']['output'];
  refunderUserId?: Maybe<Scalars['String']['output']>;
};

export type RefundGroupOrderInput = {
  id: Scalars['String']['input'];
  refundAmount: Scalars['Int']['input'];
  refundDetails?: InputMaybe<Scalars['String']['input']>;
  refundMessage?: InputMaybe<Scalars['String']['input']>;
  refundReason: RefundGroupOrderReasonInput;
  refundType: GroupOrderRefundType;
  reverseShefTransferAmounts?: InputMaybe<Array<ReverseShefTransferInput>>;
};

export type RefundGroupOrderReasonInput = {
  customer?: InputMaybe<GroupOrderCustomerRefundReason>;
  deliveryPartner?: InputMaybe<GroupOrderDeliveryPartnerRefundReason>;
  internal?: InputMaybe<GroupOrderInternalRefundReason>;
  shef?: InputMaybe<GroupOrderShefRefundReason>;
  system?: InputMaybe<GroupOrderSystemRefundReason>;
};

export type RefundReusableContainerDepositInput = {
  enrollmentId: Scalars['String']['input'];
  refundAmount: Scalars['Int']['input'];
};

export type RefundReusableContainerDepositResponse = MutationResponse & {
  __typename?: 'RefundReusableContainerDepositResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum RefundType {
  Doordash = 'DOORDASH',
  Internal = 'INTERNAL',
  Shef = 'SHEF',
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  UserCancelled = 'USER_CANCELLED'
}

export type RegionAvailability = {
  __typename?: 'RegionAvailability';
  endDate: Scalars['DateTime']['output'];
  isAvailable: Scalars['Boolean']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type RegionInfo = {
  __typename?: 'RegionInfo';
  deliveryEnabledAt: Scalars['DateTime']['output'];
  displayName: Scalars['String']['output'];
  ecoPackagingEnabled: Scalars['Boolean']['output'];
  fridayDelivery: Scalars['Boolean']['output'];
  gsinEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isDeliveryByShefsEnabled: Scalars['Boolean']['output'];
  isDeliveryByThirdPartyEnabled: Scalars['Boolean']['output'];
  isHubless: Scalars['Boolean']['output'];
  isInWaitlist: Scalars['Boolean']['output'];
  isPickupEnabled: Scalars['Boolean']['output'];
  isVerifiedHalalEnabled: Scalars['Boolean']['output'];
  launchedAt: Scalars['DateTime']['output'];
  mondayDelivery: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  saturdayDelivery: Scalars['Boolean']['output'];
  sundayDelivery: Scalars['Boolean']['output'];
  thursdayDelivery: Scalars['Boolean']['output'];
  timeZone: Scalars['String']['output'];
  tuesdayDelivery: Scalars['Boolean']['output'];
  wednesdayDelivery: Scalars['Boolean']['output'];
};

export type RegionShefRanking = {
  __typename?: 'RegionShefRanking';
  id: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  regionId: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
  tier: Scalars['Int']['output'];
};

export type RemoveUserFromHubInput = {
  hubIds: Array<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
};

export type ReportsZipError = {
  __typename?: 'ReportsZipError';
  path: Scalars['String']['output'];
  type: ReportsZipErrorType;
};

export enum ReportsZipErrorType {
  MissingIndexPage = 'MISSING_INDEX_PAGE',
  NoShefFolders = 'NO_SHEF_FOLDERS',
  PathOutsideZip = 'PATH_OUTSIDE_ZIP',
  UnexpectedFile = 'UNEXPECTED_FILE',
  UnknownShef = 'UNKNOWN_SHEF'
}

export type ReportsZipUpload = {
  __typename?: 'ReportsZipUpload';
  contentType: Scalars['String']['output'];
  key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type RequestGroupOrderDeliveriesResults = {
  __typename?: 'RequestGroupOrderDeliveriesResults';
  fail: Array<Scalars['String']['output']>;
  success: Array<Scalars['String']['output']>;
};

export enum RequestStatus {
  ClosedAbandoned = 'CLOSED_ABANDONED',
  ClosedApprovedAuto = 'CLOSED_APPROVED_AUTO',
  ClosedApprovedManual = 'CLOSED_APPROVED_MANUAL',
  ClosedRejected = 'CLOSED_REJECTED',
  OpenPendingNewPhoto = 'OPEN_PENDING_NEW_PHOTO',
  OpenPendingPhotoDecision = 'OPEN_PENDING_PHOTO_DECISION',
  OpenPendingPhotoEdits = 'OPEN_PENDING_PHOTO_EDITS',
  OpenPendingPhotoEditsApproval = 'OPEN_PENDING_PHOTO_EDITS_APPROVAL',
  OpenPendingReview = 'OPEN_PENDING_REVIEW',
  OpenPendingShefReview = 'OPEN_PENDING_SHEF_REVIEW',
  OpenProposalPendingAdminReview = 'OPEN_PROPOSAL_PENDING_ADMIN_REVIEW',
  OpenProposalPendingShefReview = 'OPEN_PROPOSAL_PENDING_SHEF_REVIEW'
}

/**
 * The plan's most recent opt-in cycle, opted out or not. Non-null means the plan has enrolled at
 * least once — the signal for "has this customer already made a packaging choice".
 *
 * Distinct from `reusableEnrollment`, which is the *pricing* view and resolves only an ACTIVE
 * enrollment: that field is null both for plans that never enrolled and for plans that opted out,
 * so it cannot answer "ever enrolled".
 */
export type ReusableContainerEnrollment = {
  __typename?: 'ReusableContainerEnrollment';
  id: Scalars['String']['output'];
  optedInAt: Scalars['DateTime']['output'];
  optedOutAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ReusableDepositRefundPending = {
  __typename?: 'ReusableDepositRefundPending';
  containersReturnedAt?: Maybe<Scalars['DateTime']['output']>;
  depositAmount: Scalars['Int']['output'];
  enrollmentId: Scalars['String']['output'];
  isRefundEligible: Scalars['Boolean']['output'];
  mealPlanId: Scalars['String']['output'];
  mealPlanStatus: MealPlanStatus;
  optedOutAt: Scalars['DateTime']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

/**
 * A meal plan's reusable-packaging enrollment as the client needs it for pricing. Null when the plan
 * has never enrolled.
 */
export type ReusableEnrollment = {
  __typename?: 'ReusableEnrollment';
  /**
   * The upcoming group order that carries the refundable deposit (shown as a deposit line item instead
   * of the weekly cleaning fee). Null once the deposit has been collected.
   */
  firstReusableGroupOrderId?: Maybe<Scalars['String']['output']>;
  isReusable: Scalars['Boolean']['output'];
  /**
   * When the customer opted into reusable packaging. Grandfathered plans share this with the meal
   * plan's creation date, so it can drive the cleaning-fee cutoff across the board.
   */
  optedInAt: Scalars['DateTime']['output'];
};

export type ReverseShefTransferInput = {
  orderId: Scalars['Int']['input'];
  reverseShefPaymentAmount: Scalars['Int']['input'];
};

export type ReviewUser = {
  __typename?: 'ReviewUser';
  flakeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
};

export type SavedCreditCard = {
  __typename?: 'SavedCreditCard';
  accountEmail?: Maybe<Scalars['String']['output']>;
  accountHandle?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['Date']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['String']['output'];
  lastFourDigits?: Maybe<Scalars['Int']['output']>;
  lastUsedAt: Scalars['Date']['output'];
  linkedMealPlanId?: Maybe<Scalars['String']['output']>;
  linkedSubscriptionId?: Maybe<Scalars['String']['output']>;
  paymentMethodType: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type SavedCreditCardInput = {
  accountEmail?: InputMaybe<Scalars['String']['input']>;
  accountHandle?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  lastFourDigits?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodType?: InputMaybe<Scalars['String']['input']>;
  shouldSaveCard: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type SearchInput = {
  dishCursor?: InputMaybe<Scalars['String']['input']>;
  dishPageSize?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  shefCursor?: InputMaybe<Scalars['String']['input']>;
  shefPageSize?: InputMaybe<Scalars['Int']['input']>;
  zipCode: Scalars['String']['input'];
};

export type SearchResults = {
  __typename?: 'SearchResults';
  cuisineResults: Array<CuisineSearchResult>;
  dishResults: Array<Array<FoodItem>>;
  offset: Scalars['Int']['output'];
  searchStateResult: SearchStateResult;
  shefResults: Array<ExploreSegmentShef>;
};

export type SearchStateInput = {
  paginationState: AlgoliaPaginationState;
  seenRecordIds: Array<Array<Scalars['Int']['input']>>;
};

export type SearchStateResult = {
  __typename?: 'SearchStateResult';
  paginationState: AlgoliaPaginationResult;
  seenRecordIds: Array<Array<Scalars['Int']['output']>>;
};

export type SeasonalAdditionInput = {
  foodItemId: Scalars['Int']['input'];
  season: Scalars['String']['input'];
  seasonalWindowEnd?: InputMaybe<Scalars['String']['input']>;
  seasonalWindowStart?: InputMaybe<Scalars['String']['input']>;
};

export enum SegmentFilter {
  African = 'AFRICAN',
  All = 'ALL',
  American = 'AMERICAN',
  BakedGoods = 'BAKED_GOODS',
  Bangladeshi = 'BANGLADESHI',
  Caribbean = 'CARIBBEAN',
  Chinese = 'CHINESE',
  Diwali = 'DIWALI',
  Donations = 'DONATIONS',
  Easter = 'EASTER',
  EidAlFitr = 'EID_AL_FITR',
  Favorites = 'FAVORITES',
  French = 'FRENCH',
  Holi = 'HOLI',
  Hungarian = 'HUNGARIAN',
  Indian = 'INDIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Korean = 'KOREAN',
  LatinAmerican = 'LATIN_AMERICAN',
  LunarNewYear = 'LUNAR_NEW_YEAR',
  Mediterranean = 'MEDITERRANEAN',
  Mexican = 'MEXICAN',
  MiddleEastern = 'MIDDLE_EASTERN',
  More = 'MORE',
  Nepalese = 'NEPALESE',
  NewYear = 'NEW_YEAR',
  NextDay = 'NEXT_DAY',
  Nowruz = 'NOWRUZ',
  Pakistani = 'PAKISTANI',
  Promos = 'PROMOS',
  Ramadan = 'RAMADAN',
  Referral = 'REFERRAL',
  Russian = 'RUSSIAN',
  SearchCuisineDishes = 'SEARCH_CUISINE_DISHES',
  SearchCuisineShefs = 'SEARCH_CUISINE_SHEFS',
  SearchDishes = 'SEARCH_DISHES',
  SearchShefs = 'SEARCH_SHEFS',
  ShefsYouFollow = 'SHEFS_YOU_FOLLOW',
  SoutheastAsian = 'SOUTHEAST_ASIAN',
  Southern = 'SOUTHERN',
  Specialty = 'SPECIALTY',
  Thanksgiving = 'THANKSGIVING',
  Trial = 'TRIAL',
  Valentines = 'VALENTINES',
  Vesak = 'VESAK',
  WinterHoliday = 'WINTER_HOLIDAY'
}

export type SegmentFilterInput = {
  cuisineRegion?: InputMaybe<CuisineRegion>;
  deliveryDays?: InputMaybe<Array<Scalars['String']['input']>>;
  dietaryFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  excludePromoSegment?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSegments?: InputMaybe<Array<Scalars['String']['input']>>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  segmentFilters?: InputMaybe<Array<SegmentFilter>>;
  zipCode: Scalars['String']['input'];
};

export enum SegmentIcon {
  Placeholder = 'PLACEHOLDER'
}

export enum SegmentLayout {
  Generic = 'GENERIC',
  GenericNoPreview = 'GENERIC_NO_PREVIEW',
  HorizontalScroll = 'HORIZONTAL_SCROLL',
  RoundedScroll = 'ROUNDED_SCROLL'
}

export type SegmentPaginationInput = {
  excludeSegmentIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SetTableRunDeliveryAddressInput = {
  addressId: Scalars['Int']['input'];
  /** Admins only: the customer whose subscriptions to update. Defaults to the caller. */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SetTableRunDeliveryAddressResult = MutationResponse & {
  __typename?: 'SetTableRunDeliveryAddressResult';
  mealPlans: Array<TableRunMealPlan>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ShefApplication = {
  __typename?: 'ShefApplication';
  additionalNotes?: Maybe<Scalars['String']['output']>;
  aiEvaluationStatus?: Maybe<ShefApplicationEvaluationOutcome>;
  backgroundOpenField?: Maybe<Scalars['String']['output']>;
  bioCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  calendlyOrientationCallLink?: Maybe<Scalars['String']['output']>;
  capacityHighVolume?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use hasCapacityAtLeast15PerDay instead */
  capacityOverTen?: Maybe<Scalars['Boolean']['output']>;
  capacityReasoning?: Maybe<Scalars['String']['output']>;
  capacityScore?: Maybe<ShefApplicationFactorLevel>;
  completedQuestionnaire?: Maybe<Scalars['Boolean']['output']>;
  cookingExperience?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cuisineAndMenuReasoning?: Maybe<Scalars['String']['output']>;
  cuisineAndMenuScore?: Maybe<ShefApplicationFactorLevel>;
  cuisines?: Maybe<Scalars['String']['output']>;
  culinaryTraining?: Maybe<Scalars['String']['output']>;
  experienceReasoning?: Maybe<Scalars['String']['output']>;
  experienceScore?: Maybe<ShefApplicationFactorLevel>;
  foodHandlerCertificate?: Maybe<Scalars['String']['output']>;
  foodTastingAt?: Maybe<Scalars['DateTime']['output']>;
  foodTastingReceivedAt?: Maybe<Scalars['DateTime']['output']>;
  geographyAllowsCuisineType: Scalars['Boolean']['output'];
  geographyAllowsNewApplications: Scalars['Boolean']['output'];
  hasCapacityAtLeast15PerDay?: Maybe<Scalars['Boolean']['output']>;
  howDiscoveredShef?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  info?: Maybe<Scalars['String']['output']>;
  informationSessionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  informationWebinarAttendedAt?: Maybe<Scalars['DateTime']['output']>;
  initialQuestionsCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  isDcExperimentApplicant: Scalars['Boolean']['output'];
  isFlexShef?: Maybe<Scalars['Boolean']['output']>;
  isFoodTastingScheduled: Scalars['Boolean']['output'];
  isFoodTastingSchedulingEnabled: Scalars['Boolean']['output'];
  isInformationSessionApplicant: Scalars['Boolean']['output'];
  isPickupAddressEnabled: Scalars['Boolean']['output'];
  isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
  lengthOfInterestCooking?: Maybe<Scalars['String']['output']>;
  menuWebinarCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  menuWebinarScheduledFor?: Maybe<Scalars['DateTime']['output']>;
  offWaitlistAt?: Maybe<Scalars['Date']['output']>;
  onboardingCallAt?: Maybe<Scalars['DateTime']['output']>;
  orientationCallCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  orientationCallScheduledFor?: Maybe<Scalars['DateTime']['output']>;
  overallScore?: Maybe<ShefApplicationEvaluationOutcome>;
  phone?: Maybe<Scalars['String']['output']>;
  primaryCuisine?: Maybe<Scalars['String']['output']>;
  profilePhotoAcceptedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoOptionA?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionB?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionC?: Maybe<Scalars['String']['output']>;
  profilePhotoRejectedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoSubmissionStatus?: Maybe<ProfilePhotoSubmissionStatus>;
  profilePhotoSubmittedAt?: Maybe<Scalars['Date']['output']>;
  proposedMenuItems?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer written for new applications; historical values only. */
  recommendedTasteTestingDishes?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionInfo?: Maybe<RegionInfo>;
  rolesPreviouslyHeld?: Maybe<Scalars['String']['output']>;
  secondaryCuisine?: Maybe<Scalars['String']['output']>;
  status: ApplicationStatus;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  workAuthorization?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type ShefApplicationEvaluationFactor = {
  __typename?: 'ShefApplicationEvaluationFactor';
  level: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
};

export type ShefApplicationEvaluationMenuSignal = {
  __typename?: 'ShefApplicationEvaluationMenuSignal';
  level: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rationale: Scalars['String']['output'];
};

export enum ShefApplicationEvaluationOutcome {
  Green = 'GREEN',
  Incomplete = 'INCOMPLETE',
  Orange = 'ORANGE',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type ShefApplicationEvaluationResult = {
  __typename?: 'ShefApplicationEvaluationResult';
  factors: Array<ShefApplicationEvaluationFactor>;
  /** Rubric rules that fired, e.g. `market_less_desired`, `chain_only_experience`, `cert_pending`. */
  flags: Array<Scalars['String']['output']>;
  /** @deprecated The rubric no longer scores menu signals separately; always empty. */
  menuSignals: Array<ShefApplicationEvaluationMenuSignal>;
  outcome: ShefApplicationEvaluationOutcome;
  /** Which rubric the applicant was scored against: Professional Experience, Business or Home Cook. */
  profile?: Maybe<Scalars['String']['output']>;
  rationale: Scalars['String']['output'];
  /** @deprecated The rubric no longer recommends tasting dishes; always null. */
  recommendedTasteTestingDishes?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ShefApplicationFactorLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type ShefApplicationInput = {
  cuisines?: InputMaybe<Scalars['String']['input']>;
  deviceLanguage?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  referral?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type ShefApplicationInputStep2 = {
  howDiscoveredShef: Scalars['String']['input'];
};

export type ShefApplicationProfileInput = {
  profilePhotoOptionA?: InputMaybe<Scalars['String']['input']>;
  profilePhotoOptionB?: InputMaybe<Scalars['String']['input']>;
  profilePhotoOptionC?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Input for the native questionnaire. Fields are optional to allow draft saves.
 * Server merges partial inputs with previous drafts before evaluation.
 */
export type ShefApplicationQuestionnaireInput = {
  aboutYouAndExperience?: InputMaybe<Scalars['String']['input']>;
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  backgroundAdditional?: InputMaybe<Scalars['String']['input']>;
  cuisineSpecialties?: InputMaybe<Array<Scalars['String']['input']>>;
  culinaryTraining?: InputMaybe<Scalars['String']['input']>;
  dailyServingsCapacity?: InputMaybe<Scalars['Int']['input']>;
  desiredCookingDuration?: InputMaybe<Scalars['String']['input']>;
  earliestStart?: InputMaybe<Scalars['String']['input']>;
  foodHandlerCertificate?: InputMaybe<Scalars['String']['input']>;
  goalWithShef?: InputMaybe<Scalars['String']['input']>;
  hasCapacityAtLeast15PerDay?: InputMaybe<Scalars['Boolean']['input']>;
  howDidYouHear?: InputMaybe<Scalars['String']['input']>;
  isFlexShef?: InputMaybe<Scalars['Boolean']['input']>;
  menuText?: InputMaybe<Scalars['String']['input']>;
  operatesCulinaryBusinessAnd60Capable?: InputMaybe<Scalars['Boolean']['input']>;
  professionalCookingExperience?: InputMaybe<Scalars['String']['input']>;
  professionalExperience?: InputMaybe<Array<ProfessionalExperienceInput>>;
  proposedMenuItems?: InputMaybe<Array<Scalars['String']['input']>>;
  topDishes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ShefApplicationResult = {
  __typename?: 'ShefApplicationResult';
  isExistingUser: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type ShefApplicationTracker = {
  __typename?: 'ShefApplicationTracker';
  addAddress?: Maybe<ShefApplicationTrackerItemStatus>;
  availability: ShefApplicationTrackerItemStatus;
  bio: ShefApplicationTrackerItemStatus;
  cuisine: ShefApplicationTrackerItemStatus;
  cuisineCategories?: Maybe<ShefApplicationTrackerItemStatus>;
  dropOffHub?: Maybe<ShefApplicationTrackerItemStatus>;
  foodHandlersCertificate: ShefApplicationTrackerItemStatus;
  informationSession: ShefApplicationTrackerItemStatus;
  menuItems: ShefApplicationTrackerItemStatus;
  optionalMenuItems?: Maybe<ShefApplicationTrackerItemStatus>;
  passTasting?: Maybe<ShefApplicationTrackerItemStatus>;
  personalInfo?: Maybe<ShefApplicationTrackerItemStatus>;
  profileImage: ShefApplicationTrackerItemStatus;
  scheduleCall?: Maybe<ShefApplicationTrackerItemStatus>;
  scheduleTasting?: Maybe<ShefApplicationTrackerItemStatus>;
  stripeConnect: ShefApplicationTrackerItemStatus;
  tryShefPromo?: Maybe<ShefApplicationTrackerItemStatus>;
};

export enum ShefApplicationTrackerItemStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ShefAvailability = {
  __typename?: 'ShefAvailability';
  availabilityDate: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  isSoldOut: Scalars['Boolean']['output'];
  numDishesAvailable: Scalars['Int']['output'];
  numOrderedDishes: Scalars['Int']['output'];
  numOrdersAvailable: Scalars['Int']['output'];
  numOrdersPlaced: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};


export type ShefAvailabilityIsSoldOutArgs = {
  cacheOptions?: InputMaybe<CacheOptionsInput>;
};

export type ShefAvailabilityRule = {
  __typename?: 'ShefAvailabilityRule';
  dateRange: DateRange;
  daysOfWeek?: Maybe<ShefAvailabilityRuleDaysOfWeek>;
  durationInMs: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAvailable: Scalars['Boolean']['output'];
  isDaysOfWeek: Scalars['Boolean']['output'];
  isPast?: Maybe<Scalars['Boolean']['output']>;
  isUpcoming?: Maybe<Scalars['Boolean']['output']>;
  recurrenceRule: Scalars['String']['output'];
  shefId: Scalars['String']['output'];
};

export type ShefAvailabilityRuleDaysOfWeek = {
  __typename?: 'ShefAvailabilityRuleDaysOfWeek';
  friday: Scalars['Boolean']['output'];
  monday: Scalars['Boolean']['output'];
  saturday: Scalars['Boolean']['output'];
  sunday: Scalars['Boolean']['output'];
  thursday: Scalars['Boolean']['output'];
  tuesday: Scalars['Boolean']['output'];
  wednesday: Scalars['Boolean']['output'];
};

export type ShefAvailabilityRuleDaysOfWeekInput = {
  friday: Scalars['Boolean']['input'];
  monday: Scalars['Boolean']['input'];
  saturday: Scalars['Boolean']['input'];
  sunday: Scalars['Boolean']['input'];
  thursday: Scalars['Boolean']['input'];
  tuesday: Scalars['Boolean']['input'];
  wednesday: Scalars['Boolean']['input'];
};

export type ShefAvailabilityRuleInput = {
  endDate: Scalars['String']['input'];
  isAvailable: Scalars['Boolean']['input'];
  startDate: Scalars['String']['input'];
};

export type ShefCharge = {
  __typename?: 'ShefCharge';
  amountCents: Scalars['Int']['output'];
  collectedCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdByUserId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: ShefChargeReason;
  status: ShefChargeStatus;
  userId: Scalars['String']['output'];
};

export enum ShefChargeReason {
  Other = 'other',
  PickupProgram = 'pickup_program'
}

export enum ShefChargeStatus {
  Collected = 'collected',
  Outstanding = 'outstanding',
  PartiallyCollected = 'partially_collected',
  Voided = 'voided'
}

export type ShefChargesFilterInput = {
  shefUserId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ShefChargeStatus>>;
};

export type ShefCuisineCategory = {
  __typename?: 'ShefCuisineCategory';
  cuisineCategoryId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  shefId: Scalars['String']['output'];
};

export type ShefDebit = {
  __typename?: 'ShefDebit';
  amountCollectedCents: Scalars['Int']['output'];
  chargeAmountCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: ShefChargeReason;
};

export enum ShefFindingStatus {
  All = 'ALL',
  Dismissed = 'DISMISSED',
  Open = 'OPEN',
  Resolved = 'RESOLVED'
}

export type ShefFoodItemFindings = {
  __typename?: 'ShefFoodItemFindings';
  findings: Array<FoodItemFinding>;
  foodItem: FoodItem;
};

export enum ShefInsightsReportPage {
  DishAnalytics = 'DISH_ANALYTICS',
  Index = 'INDEX',
  List = 'LIST',
  Menu = 'MENU',
  Quality = 'QUALITY',
  Reliability = 'RELIABILITY'
}

export type ShefInsightsReportsZipPublish = {
  __typename?: 'ShefInsightsReportsZipPublish';
  publishedAt: Scalars['DateTime']['output'];
  publishedByUserId: Scalars['String']['output'];
  reportsZipFileName: Scalars['String']['output'];
};

export type ShefInsightsReportsZipPublishResult = {
  __typename?: 'ShefInsightsReportsZipPublishResult';
  deletedStalePageCount: Scalars['Int']['output'];
  errors: Array<ReportsZipError>;
  outcome: PublishReportsZipOutcome;
  publishedShefIds: Array<Scalars['String']['output']>;
  shefsMissingFromZip: Array<Scalars['String']['output']>;
  writtenPageCount: Scalars['Int']['output'];
};

export type ShefMenuChecklistAction = {
  __typename?: 'ShefMenuChecklistAction';
  completed: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export enum ShefMenuSegmentFilter {
  ShefPopular = 'SHEF_POPULAR'
}

export enum ShefOnboardingCookingExperience {
  CulinaryTraining = 'CULINARY_TRAINING',
  CurrentIndependentFoodBusiness = 'CURRENT_INDEPENDENT_FOOD_BUSINESS',
  NoExperience = 'NO_EXPERIENCE',
  PastIndependentFoodBusiness = 'PAST_INDEPENDENT_FOOD_BUSINESS'
}

export type ShefOrderRating = {
  __typename?: 'ShefOrderRating';
  category?: Maybe<OrderRatingCategory>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flaggedForReviewAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  orderId: Scalars['Int']['output'];
  privateComment?: Maybe<Scalars['String']['output']>;
  ratingPercent?: Maybe<Scalars['Int']['output']>;
  shefId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type ShefPerformanceDashboardInput = {
  endDate: Scalars['String']['input'];
  numberOfShefsToShow: Scalars['Int']['input'];
  startDate: Scalars['String']['input'];
};

export enum ShefPlatformDesiredEarnings {
  Above_1000 = 'ABOVE_1000',
  Below_100 = 'BELOW_100',
  Range_100_200 = 'RANGE_100_200',
  Range_200_300 = 'RANGE_200_300',
  Range_300_400 = 'RANGE_300_400',
  Range_400_500 = 'RANGE_400_500',
  Range_500_600 = 'RANGE_500_600',
  Range_600_700 = 'RANGE_600_700',
  Range_700_800 = 'RANGE_700_800',
  Range_800_900 = 'RANGE_800_900',
  Range_900_1000 = 'RANGE_900_1000'
}

export enum ShefPlatformNewDesiredEarnings {
  Day_50 = 'DAY_50',
  Day_100 = 'DAY_100',
  Day_150 = 'DAY_150',
  Day_200 = 'DAY_200',
  Day_250 = 'DAY_250',
  Day_300 = 'DAY_300',
  Day_400 = 'DAY_400',
  Day_500Plus = 'DAY_500_PLUS',
  Unimportant = 'UNIMPORTANT'
}

export enum ShefPlatformUsage {
  Evaluating = 'EVALUATING',
  FullTime = 'FULL_TIME',
  Hobby = 'HOBBY',
  PartTime = 'PART_TIME',
  PartTimeTurningFullTime = 'PART_TIME_TURNING_FULL_TIME'
}

export type ShefPost = {
  __typename?: 'ShefPost';
  clickCount: Scalars['Int']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  foodItemId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isLikedByUser?: Maybe<Scalars['Boolean']['output']>;
  mediaType?: Maybe<ShefPostMediaType>;
  mediaUrl?: Maybe<Scalars['String']['output']>;
  numLikes: Scalars['Int']['output'];
  promoCodeId?: Maybe<Scalars['Int']['output']>;
  promoCodeString?: Maybe<Scalars['String']['output']>;
  shefId: Scalars['String']['output'];
  viewCount: Scalars['Int']['output'];
};

export type ShefPostInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  foodItemId?: InputMaybe<Scalars['Int']['input']>;
  mediaType?: InputMaybe<ShefPostMediaType>;
  mediaUrl?: InputMaybe<Scalars['String']['input']>;
  promoCodeId?: InputMaybe<Scalars['Int']['input']>;
};

export enum ShefPostMediaType {
  Photo = 'PHOTO'
}

export type ShefProfile = {
  __typename?: 'ShefProfile';
  allowedToAcceptNextDay: Scalars['Boolean']['output'];
  allowedToChat: Scalars['Boolean']['output'];
  allowedToCreateSubscriptions?: Maybe<Scalars['Boolean']['output']>;
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approximateLocation?: Maybe<Location>;
  availableFulfillmentOptions: Array<Scalars['String']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  canOptInToFringe: Scalars['Boolean']['output'];
  canOptOutOfFringe: Scalars['Boolean']['output'];
  cancelOrderNotificationFrequency?: Maybe<CancelOrderNotificationFrequency>;
  consumerReferralInfo: ConsumerReferralInfo;
  coverPhotoUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  cuisineCategories: Array<CuisineCategory>;
  cuisineCategoryIds: Array<Scalars['String']['output']>;
  cuisineRegion?: Maybe<CuisineRegion>;
  cutoffMsBeforeDeliveryDate: Scalars['Int']['output'];
  defaultDropoffHub?: Maybe<DeliveryHub>;
  dishCapacity: Scalars['Int']['output'];
  dropOffHubFirstSetAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  explorePagePromoCode?: Maybe<PromoCode>;
  explorePagePromoCodeId?: Maybe<Scalars['String']['output']>;
  facebookHandle?: Maybe<Scalars['String']['output']>;
  featureShef?: Maybe<Scalars['Boolean']['output']>;
  fhcApprovedAt?: Maybe<Scalars['Date']['output']>;
  fhcExpiresAt?: Maybe<Scalars['Date']['output']>;
  fhcUploadRequiredBy?: Maybe<Scalars['Date']['output']>;
  fhcUploadedAt?: Maybe<Scalars['Date']['output']>;
  firstApprovedAt?: Maybe<Scalars['Date']['output']>;
  followerCount: Scalars['Int']['output'];
  followers: Array<User>;
  foodHandlersCertificate?: Maybe<Scalars['String']['output']>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  freeDeliveryModal: FreeDeliveryModal;
  fulfillmentOption?: Maybe<Scalars['String']['output']>;
  geographyAllowsCuisineType: Scalars['Boolean']['output'];
  highlightedQuote?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramHandle?: Maybe<Scalars['String']['output']>;
  isBlockedDueToMissingFHC: Scalars['Boolean']['output'];
  isHubless: Scalars['Boolean']['output'];
  isMealPlanShef: Scalars['Boolean']['output'];
  isMultiFulfillmentShef: Scalars['Boolean']['output'];
  isShefFollower: Scalars['Boolean']['output'];
  isTrialShef: Scalars['Boolean']['output'];
  linkedInHandle?: Maybe<Scalars['String']['output']>;
  maxDishCapacity: Scalars['Int']['output'];
  mehkoLicenseNumber?: Maybe<Scalars['String']['output']>;
  newOrderNotificationFrequency?: Maybe<NewOrderNotificationFrequency>;
  notes?: Maybe<Scalars['String']['output']>;
  onboardingCookingExperience?: Maybe<ShefOnboardingCookingExperience>;
  onboardingFormAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  onboardingPlatformUsage?: Maybe<ShefPlatformUsage>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupAddressId?: Maybe<Scalars['Int']['output']>;
  pickupTimeWindows: Array<TimeWindow>;
  platformDesiredEarnings?: Maybe<ShefPlatformDesiredEarnings>;
  platformFormAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  platformNewDesiredEarnings?: Maybe<ShefPlatformNewDesiredEarnings>;
  platformNewFormAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  platformNewUsage?: Maybe<ShefPlatformUsage>;
  platformPercent: Scalars['Int']['output'];
  platformRecommendationScore?: Maybe<Scalars['Int']['output']>;
  platformUsage?: Maybe<ShefPlatformUsage>;
  previewFoodItem?: Maybe<FoodItem>;
  previewFoodItemId?: Maybe<Scalars['Int']['output']>;
  primaryRegion?: Maybe<RegionInfo>;
  printers?: Maybe<Array<Printer>>;
  profilePhotoAcceptedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoOptionA?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionB?: Maybe<Scalars['String']['output']>;
  profilePhotoOptionC?: Maybe<Scalars['String']['output']>;
  profilePhotoRejectedAt?: Maybe<Scalars['Date']['output']>;
  profilePhotoSubmittedAt?: Maybe<Scalars['Date']['output']>;
  randomZip?: Maybe<Scalars['String']['output']>;
  recentDishRating: ShefRecentDishRating;
  resizedCoverPhotoUrl?: Maybe<Scalars['String']['output']>;
  s2cCodes: Array<PromoCode>;
  setBadQualityAt?: Maybe<Scalars['DateTime']['output']>;
  shef: PublicShef;
  shefAddress?: Maybe<Address>;
  shefAddressId?: Maybe<Scalars['Int']['output']>;
  specialty?: Maybe<Scalars['String']['output']>;
  tikTokHandle?: Maybe<Scalars['String']['output']>;
  timeWindowOptionsForShef: Array<TimeWindow>;
  timeWindowsSelectedByShef: Array<TimeWindow>;
  timeZone: Scalars['String']['output'];
  totalRatings: Scalars['Int']['output'];
  trialGradedAt?: Maybe<Scalars['DateTime']['output']>;
  trialStartedAt?: Maybe<Scalars['DateTime']['output']>;
  trialStatus?: Maybe<TrialStatus>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['String']['output'];
  videoUrl?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  youtubeHandle?: Maybe<Scalars['String']['output']>;
};


export type ShefProfileFollowersArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type ShefProfileResizedCoverPhotoUrlArgs = {
  width: Scalars['Int']['input'];
};

export type ShefProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  cancelOrderNotificationFrequency?: InputMaybe<CancelOrderNotificationFrequency>;
  coverPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  cuisineCategoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  cuisineRegion?: InputMaybe<CuisineRegion>;
  cutoffMsBeforeDeliveryDate?: InputMaybe<Scalars['Int']['input']>;
  defaultDropoffHubId?: InputMaybe<Scalars['Int']['input']>;
  dishCapacity?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookHandle?: InputMaybe<Scalars['String']['input']>;
  featureShef?: InputMaybe<Scalars['Boolean']['input']>;
  fhcExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foodHandlersCertificate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramHandle?: InputMaybe<Scalars['String']['input']>;
  isMealPlanShef?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInHandle?: InputMaybe<Scalars['String']['input']>;
  maxDishCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxOrderCapacity?: InputMaybe<Scalars['Int']['input']>;
  newOrderNotificationFrequency?: InputMaybe<NewOrderNotificationFrequency>;
  notes?: InputMaybe<Scalars['String']['input']>;
  onboardingCookingExperience?: InputMaybe<ShefOnboardingCookingExperience>;
  onboardingFormAnsweredAt?: InputMaybe<Scalars['DateTime']['input']>;
  onboardingPlatformUsage?: InputMaybe<ShefPlatformUsage>;
  orderCapacity?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  platformDesiredEarnings?: InputMaybe<ShefPlatformDesiredEarnings>;
  platformNewDesiredEarnings?: InputMaybe<ShefPlatformNewDesiredEarnings>;
  platformNewUsage?: InputMaybe<ShefPlatformUsage>;
  platformRecommendationScore?: InputMaybe<Scalars['Int']['input']>;
  platformUsage?: InputMaybe<ShefPlatformUsage>;
  previewFoodItemId?: InputMaybe<Scalars['Int']['input']>;
  printers?: InputMaybe<Array<Printer>>;
  resumeCommsAt?: InputMaybe<Scalars['Date']['input']>;
  setBadQualityAt?: InputMaybe<Scalars['DateTime']['input']>;
  shefStatus?: InputMaybe<ShefStatus>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  tikTokHandle?: InputMaybe<Scalars['String']['input']>;
  trialStatus?: InputMaybe<TrialStatus>;
  twitterHandle?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  youtubeHandle?: InputMaybe<Scalars['String']['input']>;
};

export type ShefPromoCodeInput = {
  codeBase: Scalars['String']['input'];
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  firstPromoOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isExplorePagePromo?: InputMaybe<Scalars['Boolean']['input']>;
  isPercentage: Scalars['Boolean']['input'];
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  maxUsesPerUser?: InputMaybe<Scalars['Int']['input']>;
  minOrderValue?: InputMaybe<Scalars['Int']['input']>;
  restrictedToUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Int']['input'];
};

export type ShefRating = {
  __typename?: 'ShefRating';
  count: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
};

export type ShefRecentDishRating = {
  __typename?: 'ShefRecentDishRating';
  numOfRatings: Scalars['Int']['output'];
  rating?: Maybe<Scalars['Float']['output']>;
};

export enum ShefRosterStatus {
  Favorite = 'FAVORITE',
  None = 'NONE',
  Recommended = 'RECOMMENDED'
}

export type ShefSearchResults = {
  __typename?: 'ShefSearchResults';
  cursor?: Maybe<Scalars['String']['output']>;
  hasMore: Scalars['Boolean']['output'];
  results: Array<PublicShef>;
};

export type ShefSegment = {
  __typename?: 'ShefSegment';
  foodItems: Array<FoodItem>;
  shef: PublicShef;
  shefRemainingAvailability: Scalars['Int']['output'];
};

export enum ShefStatus {
  Applicant = 'APPLICANT',
  Approved = 'APPROVED',
  Churned = 'CHURNED',
  None = 'NONE',
  Trial = 'TRIAL',
  Unapproved = 'UNAPPROVED'
}

export type ShefStripeConnect = {
  __typename?: 'ShefStripeConnect';
  accessToken?: Maybe<Scalars['String']['output']>;
  accountType: StripeAccountType;
  createdAt: Scalars['DateTime']['output'];
  currentBalance?: Maybe<ShefStripeConnectBalance>;
  dashboardLoginLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  livemode?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  stripePublishableKey?: Maybe<Scalars['String']['output']>;
  stripeUserId?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type ShefStripeConnectBalance = {
  __typename?: 'ShefStripeConnectBalance';
  available: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
};

export type ShefSubtotal = {
  shefId?: InputMaybe<Scalars['String']['input']>;
  subtotal?: InputMaybe<Scalars['Int']['input']>;
};

export type ShefTagInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type ShefTagType = {
  __typename?: 'ShefTagType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type ShefTags = {
  score: Scalars['Int']['input'];
  shefId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type ShefTimeWindowSelector = {
  ids: Array<Scalars['Int']['input']>;
};

export enum ShefTransferAggregateStatus {
  Fulfilled = 'fulfilled',
  Pending = 'pending'
}

export type ShefTransferForDate = {
  __typename?: 'ShefTransferForDate';
  debits: Array<ShefDebit>;
  deliveryDate: Scalars['String']['output'];
  payoutCents: Scalars['Int']['output'];
  pendingDebits: Array<ShefDebit>;
  shefId: Scalars['String']['output'];
  status: ShefTransferAggregateStatus;
  totalDebitsCents: Scalars['Int']['output'];
  transactions: Array<Transaction>;
  transferTotalCents: Scalars['Int']['output'];
};

export type ShortUrl = {
  __typename?: 'ShortUrl';
  hits: Scalars['Int']['output'];
  longUrl: Scalars['String']['output'];
  shortUrl: Scalars['String']['output'];
};

export type SideCategory = {
  __typename?: 'SideCategory';
  displayName: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SignUpAsTableRunShefInput = {
  address: AddressInput;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  hasAcceptedTermsOfService: Scalars['Boolean']['input'];
  hasOptedIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  subscribePricePerServingCents?: InputMaybe<Scalars['Int']['input']>;
  utm?: InputMaybe<UtmInput>;
};

export type SignUpAsTableRunShefResult = {
  __typename?: 'SignUpAsTableRunShefResult';
  authToken: Scalars['String']['output'];
  storefront: TableRunStorefront;
  userId: Scalars['String']['output'];
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  signedUrl: Scalars['String']['output'];
};

export type SignedUrlInput = {
  bucket: Scalars['String']['input'];
  fileName?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  operation: SignedUrlInputOperation;
  path?: InputMaybe<Scalars['String']['input']>;
};

export enum SignedUrlInputOperation {
  Get = 'GET',
  Put = 'PUT'
}

export type SkipMealPlanGroupOrderInput = {
  deliveryDate: Scalars['String']['input'];
  groupOrderId?: InputMaybe<Scalars['String']['input']>;
};

export type SkipMealPlanGroupOrderResponse = MutationResponse & {
  __typename?: 'SkipMealPlanGroupOrderResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartTableRunTrialInput = {
  storefrontId: Scalars['ID']['input'];
};

export type StartTableRunTrialResult = {
  __typename?: 'StartTableRunTrialResult';
  membershipId: Scalars['ID']['output'];
  storefront: TableRunStorefront;
  trialEndsAt: Scalars['DateTime']['output'];
};

export enum StripeAccountType {
  Express = 'EXPRESS',
  Standard = 'STANDARD'
}

export type SubcuisineSegmentDetails = {
  __typename?: 'SubcuisineSegmentDetails';
  rootCuisineRegion: Scalars['String']['output'];
  subcuisineId: Scalars['String']['output'];
};

export type SubmitLeadCaptureInput = {
  device: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  step: LeadCaptureStep;
  trigger: LeadCaptureTrigger;
};

export type SubmitLeadCaptureResult = {
  __typename?: 'SubmitLeadCaptureResult';
  success: Scalars['Boolean']['output'];
};

export type SubscribeToTableRunPlanInput = {
  paymentMethodId: Scalars['String']['input'];
  storefrontId: Scalars['ID']['input'];
};

export type SubscribeToTableRunPlanResult = {
  __typename?: 'SubscribeToTableRunPlanResult';
  membershipId: Scalars['ID']['output'];
  storefront: TableRunStorefront;
};

export type Subscription = {
  __typename?: 'Subscription';
  addressId: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  cuisinePreferences: Array<CuisineRegion>;
  fridayDelivery: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isVegan: Scalars['Boolean']['output'];
  isVegetarian: Scalars['Boolean']['output'];
  mondayDelivery: Scalars['Boolean']['output'];
  numMeals: Scalars['Int']['output'];
  numServings: Scalars['Int']['output'];
  orderTemplate?: Maybe<Order>;
  paymentMethodId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  recurringPeriodDays?: Maybe<Scalars['Int']['output']>;
  saturdayDelivery: Scalars['Boolean']['output'];
  status: SubscriptionStatus;
  sundayDelivery: Scalars['Boolean']['output'];
  thursdayDelivery: Scalars['Boolean']['output'];
  tuesdayDelivery: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  wednesdayDelivery: Scalars['Boolean']['output'];
};

export type SubscriptionBuildOrderInput = {
  deliveryDate: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
  timeWindowId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubscriptionConnection = {
  __typename?: 'SubscriptionConnection';
  edges: Array<SubscriptionEdge>;
  pageInfo: PageInfo;
};

export type SubscriptionCreateInput = {
  orderInputs?: InputMaybe<Array<SubscriptionOrderInput>>;
  subscriptionCycleId?: InputMaybe<Scalars['String']['input']>;
  subscriptionInput: SubscriptionInput;
  subscriptionPromoCode?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionEdge = {
  __typename?: 'SubscriptionEdge';
  cursor: Scalars['ID']['output'];
  node: Subscription;
};

export type SubscriptionInput = {
  cuisinePreferences: Array<CuisineRegion>;
  deliveryAddress?: InputMaybe<AddressInput>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  deliveryNotes?: InputMaybe<Scalars['String']['input']>;
  fridayDelivery: Scalars['Boolean']['input'];
  isMealPlan?: InputMaybe<Scalars['Boolean']['input']>;
  isVegan: Scalars['Boolean']['input'];
  isVegetarian: Scalars['Boolean']['input'];
  mondayDelivery: Scalars['Boolean']['input'];
  newCardInfo?: InputMaybe<SavedCreditCardInput>;
  orderTemplateId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recurringPeriodDays?: InputMaybe<Scalars['Int']['input']>;
  saturdayDelivery: Scalars['Boolean']['input'];
  savedCardId?: InputMaybe<Scalars['String']['input']>;
  stripeToken?: InputMaybe<Scalars['String']['input']>;
  subscriptionPriceId: Scalars['String']['input'];
  sundayDelivery: Scalars['Boolean']['input'];
  thursdayDelivery: Scalars['Boolean']['input'];
  tuesdayDelivery: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
  wednesdayDelivery: Scalars['Boolean']['input'];
};

export enum SubscriptionInvoiceStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Pause = 'PAUSE'
}

export type SubscriptionModifyInput = {
  cuisinePreferences?: InputMaybe<Array<CuisineRegion>>;
  deliveryAddressId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  isVegan?: InputMaybe<Scalars['Boolean']['input']>;
  isVegetarian?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SubscriptionStatus>;
  subscriptionPriceId?: InputMaybe<Scalars['String']['input']>;
  upcomingOrderToCancelDeliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionModifyResult = {
  __typename?: 'SubscriptionModifyResult';
  subscription: Subscription;
};

export type SubscriptionOption = {
  __typename?: 'SubscriptionOption';
  displayText: Scalars['String']['output'];
  promoCode?: Maybe<PromoCode>;
  recurringPeriod: RecurringPeriod;
};

export type SubscriptionOrderInput = {
  deliveryDate: Scalars['String']['input'];
  foodItemId: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shefId: Scalars['String']['input'];
  timeWindowId: Scalars['Int']['input'];
};

export type SubscriptionPauseInput = {
  deliveryDay?: InputMaybe<Scalars['String']['input']>;
  orderId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionCycleId?: InputMaybe<Scalars['String']['input']>;
  subscriptionInvoiceId: Scalars['String']['input'];
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Hold = 'HOLD'
}

export type SuggestedItem = {
  __typename?: 'SuggestedItem';
  foodItem: FoodItem;
  foodItemId: Scalars['Int']['output'];
  numAvailable?: Maybe<Scalars['Int']['output']>;
  orderAffinity: Scalars['Float']['output'];
};

export enum SurveyQuestion {
  AlcoholFree = 'ALCOHOL_FREE',
  CrossContaminationSecure = 'CROSS_CONTAMINATION_SECURE',
  GelatinFree = 'GELATIN_FREE',
  HalalDairy = 'HALAL_DAIRY',
  HalalMeats = 'HALAL_MEATS',
  PorkFree = 'PORK_FREE',
  Seafood = 'SEAFOOD'
}

/**
 * The three `DeliveryType` values a TableRun storefront may hold. Named as its own enum rather than
 * exposing `DeliveryType`, which carries a courier per value (`NASH`, `FRAYT`, `VAMO`) that TableRun
 * never sets. The values match the column's CHECK constraint, so no conversion is needed.
 */
export enum TableRunDeliveryMode {
  DirectViaNash = 'DIRECT_VIA_NASH',
  DirectViaShefs = 'DIRECT_VIA_SHEFS',
  Pickup = 'PICKUP'
}

export type TableRunEligibility = {
  __typename?: 'TableRunEligibility';
  hasExistingStorefront: Scalars['Boolean']['output'];
  isInMigrationCohort: Scalars['Boolean']['output'];
  isMarketActive: Scalars['Boolean']['output'];
  isTrialEligible: Scalars['Boolean']['output'];
};

export type TableRunMealPlan = {
  __typename?: 'TableRunMealPlan';
  deliveryAddressId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mealsPerWeek: Scalars['Int']['output'];
  nextDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  nextHeldGroupOrder?: Maybe<GroupOrder>;
  numServings: Scalars['Int']['output'];
  status: MealPlanStatus;
  storefront: TableRunStorefront;
  userId: Scalars['String']['output'];
};

export type TableRunMembershipCancellationResult = MutationResponse & {
  __typename?: 'TableRunMembershipCancellationResult';
  membership: TableRunShefMembership;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type TableRunShefMembership = {
  __typename?: 'TableRunShefMembership';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd: Scalars['DateTime']['output'];
  currentPeriodStart: Scalars['DateTime']['output'];
  feePerPeriodCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastChargedAt?: Maybe<Scalars['DateTime']['output']>;
  nextChargeAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type TableRunStorefront = {
  __typename?: 'TableRunStorefront';
  currentShefPost?: Maybe<ShefPost>;
  /**
   * What delivery to `zipCode` costs this customer, in cents. Priced on the distance from the shef,
   * with no subsidy, so it is the real cost of the trip and varies by how far away they are. Zero
   * when the storefront does not use a courier, because no one is paid to move the food.
   *
   * The zip is required: there is no fee to quote without somewhere to deliver to. Before the
   * customer has given an address the storefront advertises a floor instead of calling this.
   *
   * Null when `zipCode` is outside the shef's delivery radius: an order there would be refused, so
   * there is no price to show. Never null for a pickup storefront.
   */
  deliveryFeeCents?: Maybe<Scalars['Int']['output']>;
  /**
   * How food leaves this kitchen. Set by the shef and applied to every order on the storefront — a
   * customer cannot choose per order. `PICKUP` collects from the shef, so checkout asks for no
   * delivery address and charges no fee; the location shown before ordering is
   * `shef.shefProfile.approximateLocation`, never the exact address.
   */
  deliveryMode: TableRunDeliveryMode;
  /**
   * The delivery windows a customer can choose at checkout, derived from the shef's own pickup
   * windows. Offset an hour later than the shef's when the storefront delivers via a courier, who
   * needs time between collecting the food and handing it over; identical to the shef's for pickup
   * and for a shef who delivers themselves. Empty when the shef has set no pickup windows.
   */
  deliveryTimeWindows: Array<TimeWindow>;
  id: Scalars['ID']['output'];
  membership?: Maybe<TableRunShefMembership>;
  /**
   * The cheapest delivery this storefront can quote, for the "from $X" shown before a customer has
   * given an address. Zero when the storefront does not use a courier, so a pickup or
   * deliver-it-themselves storefront stops advertising a fee it will never charge.
   */
  minimumDeliveryFeeCents: Scalars['Int']['output'];
  shef: PublicShef;
  slug: Scalars['String']['output'];
  status: TableRunStorefrontStatus;
  subscribePricePerServingCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Median of the shef's approved main-dish prices, rounded to .99. Null when there are none.
   * Offered in the shef hub as the one-tap "Enable subscriptions at $X/serving" pre-fill; never written without the shef saving it.
   */
  suggestedSubscribePricePerServingCents?: Maybe<Scalars['Int']['output']>;
};


export type TableRunStorefrontDeliveryFeeCentsArgs = {
  zipCode: Scalars['String']['input'];
};

export type TableRunStorefrontResults = {
  __typename?: 'TableRunStorefrontResults';
  pagination: Pagination;
  storefronts: Array<TableRunStorefront>;
  totalCount: Scalars['Int']['output'];
};

export enum TableRunStorefrontStatus {
  Draft = 'DRAFT',
  Live = 'LIVE',
  Paused = 'PAUSED'
}

export enum TableRunStorefrontVisibility {
  NotFound = 'NOT_FOUND',
  NotYetOpen = 'NOT_YET_OPEN',
  Paused = 'PAUSED',
  Visible = 'VISIBLE'
}

export enum TagFilter {
  TopShef = 'TOP_SHEF'
}

export enum TaggedShefOp {
  And = 'AND',
  Or = 'OR'
}

export enum TaskStatus {
  Aborted = 'ABORTED',
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED',
  Skipped = 'SKIPPED',
  Succeeded = 'SUCCEEDED'
}

export type TasteProfile = {
  __typename?: 'TasteProfile';
  cuisinePreferences?: Maybe<Array<Scalars['String']['output']>>;
  dietType?: Maybe<DietType>;
  householdGoals?: Maybe<Array<HouseholdGoals>>;
  id?: Maybe<Scalars['String']['output']>;
  ingredientPriorities?: Maybe<Array<IngredientPriority>>;
  menuDietaryRestrictions?: Maybe<Array<DietaryRestriction>>;
  numAdults?: Maybe<Scalars['Int']['output']>;
  numBigEaters?: Maybe<Scalars['Int']['output']>;
  numLittleEaters?: Maybe<Scalars['Int']['output']>;
  preferredProteins?: Maybe<Array<Protein>>;
  replacementDietaryRestrictions?: Maybe<Array<DietaryRestriction>>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type TasteProfileInput = {
  cuisinePreferences?: InputMaybe<Array<Scalars['String']['input']>>;
  dietType?: InputMaybe<DietType>;
  householdGoals?: InputMaybe<Array<HouseholdGoals>>;
  ingredientPriorities?: InputMaybe<Array<IngredientPriority>>;
  menuDietaryRestrictions?: InputMaybe<Array<DietaryRestriction>>;
  numAdults?: InputMaybe<Scalars['Int']['input']>;
  numBigEaters?: InputMaybe<Scalars['Int']['input']>;
  numLittleEaters?: InputMaybe<Scalars['Int']['input']>;
  preferredProteins?: InputMaybe<Array<Protein>>;
  replacementDietaryRestrictions?: InputMaybe<Array<DietaryRestriction>>;
};

export type TasteProfileMutationInput = {
  tasteProfile: TasteProfileInput;
  userId: Scalars['String']['input'];
};

export type TasteProfileMutationResponse = MutationResponse & {
  __typename?: 'TasteProfileMutationResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  tasteProfile?: Maybe<TasteProfile>;
};

export type TimeInput = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
  second?: InputMaybe<Scalars['Float']['input']>;
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  endMsAfterMidnight: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  startMsAfterMidnight: Scalars['Int']['output'];
};

export type TimeWindowMigrationPairInput = {
  newTimeWindowId: Scalars['Int']['input'];
  oldTimeWindowId: Scalars['Int']['input'];
  regionId: Scalars['Int']['input'];
  rowIndex: Scalars['Int']['input'];
  zipCode: Scalars['String']['input'];
};

export type TimeWindowMigrationPreviewRow = {
  __typename?: 'TimeWindowMigrationPreviewRow';
  deliveryWindowsToCreate: Scalars['Int']['output'];
  groupOrdersToMove: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  ordersToMove: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  zipCode: Scalars['String']['output'];
};

export type TipOption = {
  __typename?: 'TipOption';
  label: Scalars['String']['output'];
  percent: Scalars['Float']['output'];
  value: Scalars['Int']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  createdAt: Scalars['DateTime']['output'];
  groupOrderId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusChangedAt?: Maybe<Scalars['DateTime']['output']>;
  transactionLineItems: Array<TransactionLineItem>;
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type TransactionLineItem = {
  __typename?: 'TransactionLineItem';
  amount: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  transactionId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export enum TrialStatus {
  Fail = 'FAIL',
  InProgress = 'IN_PROGRESS',
  None = 'NONE',
  Pass = 'PASS',
  Pretrial = 'PRETRIAL'
}

export type UnavailableFoodItem = {
  __typename?: 'UnavailableFoodItem';
  foodItem: FoodItem;
  quantityAvailable: Scalars['Int']['output'];
};

export type UnscanInput = {
  orderId: Scalars['Int']['input'];
};

export type UnskipMealPlanGroupOrderInput = {
  groupOrderId: Scalars['String']['input'];
};

export type UnskipMealPlanGroupOrderResponse = MutationResponse & {
  __typename?: 'UnskipMealPlanGroupOrderResponse';
  groupOrderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateDeliveryHubInput = {
  city: Scalars['String']['input'];
  code: Scalars['String']['input'];
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  dropoffWindowEndTimeMinutesFromMidnight?: InputMaybe<Scalars['Int']['input']>;
  dropoffWindowStartTimeMinutesFromMidnight?: InputMaybe<Scalars['Int']['input']>;
  fridayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isOutpost: Scalars['Boolean']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mondayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupInstructions: Scalars['String']['input'];
  province: Scalars['String']['input'];
  regionId: Scalars['Int']['input'];
  saturdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  street: Scalars['String']['input'];
  sundayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  thursdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  tuesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  wednesdayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UpdateDeliveryHubResult = {
  __typename?: 'UpdateDeliveryHubResult';
  id: Scalars['Int']['output'];
};

export type UpdateFoodItemMealPlanDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  flexibleSidesMinServings?: InputMaybe<Scalars['Int']['input']>;
  foodItemId: Scalars['Int']['input'];
  ingredients?: InputMaybe<Scalars['String']['input']>;
  isFlexibleSides?: InputMaybe<Scalars['Boolean']['input']>;
  isMainsPlusSides?: InputMaybe<Scalars['Boolean']['input']>;
  isMarketplace?: InputMaybe<Scalars['Boolean']['input']>;
  isSeedOilFree?: InputMaybe<Scalars['Boolean']['input']>;
  mealPlanFoodType?: InputMaybe<MealPlanFoodType>;
  name?: InputMaybe<Scalars['String']['input']>;
  portion?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<DishTag>>;
  upsellTierId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFoodItemMealPlanDataResponse = MutationResponse & {
  __typename?: 'UpdateFoodItemMealPlanDataResponse';
  foodItemId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdateGroupOrderOrderRouteInput = {
  groupOrderId: Scalars['String']['input'];
  orderRoute: Scalars['String']['input'];
};

export type UpdateGroupOrderOrderRouteResponse = MutationResponse & {
  __typename?: 'UpdateGroupOrderOrderRouteResponse';
  groupOrderId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum UpdateMembershipPaymentMethodOutcome {
  Charged = 'CHARGED',
  ChargeFailed = 'CHARGE_FAILED',
  ChargePending = 'CHARGE_PENDING',
  Saved = 'SAVED'
}

export type UpdateMerchandisePageTagFilterInput = {
  exclude?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  pageId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
};

export type UpdateMyTableRunStorefrontInput = {
  deliveryMode?: InputMaybe<TableRunDeliveryMode>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TableRunStorefrontStatus>;
  subscribePricePerServingCents?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * One row of a CSV bulk update. Exactly one of `id` or `code` identifies the promo code;
 * `code` is matched case-insensitively. Every other field is omitted to leave the stored
 * value alone, so a row only changes what it names.
 */
export type UpdatePromoCodeInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  /**
   * `true` disables the code as of now; `false` re-enables it by clearing `disabledAt`.
   * Omit to leave the code's enabled state untouched.
   */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMealPlanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isMealPlanExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  maxUsesPerUser?: InputMaybe<Scalars['Int']['input']>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateRegionInput = {
  deliveryEnabledAt: Scalars['DateTime']['input'];
  displayName: Scalars['String']['input'];
  fridayDelivery: Scalars['Boolean']['input'];
  launchedAt: Scalars['DateTime']['input'];
  mondayDelivery: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  saturdayDelivery: Scalars['Boolean']['input'];
  sundayDelivery: Scalars['Boolean']['input'];
  thursdayDelivery: Scalars['Boolean']['input'];
  trialShefsEnabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  tuesdayDelivery: Scalars['Boolean']['input'];
  wednesdayDelivery: Scalars['Boolean']['input'];
};

export type UpdateTableRunMembershipPaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type UpdateTableRunMembershipPaymentMethodResult = MutationResponse & {
  __typename?: 'UpdateTableRunMembershipPaymentMethodResult';
  failureCode?: Maybe<Scalars['String']['output']>;
  membership: TableRunShefMembership;
  message: Scalars['String']['output'];
  outcome: UpdateMembershipPaymentMethodOutcome;
  success: Scalars['Boolean']['output'];
};

export type UpdateTableRunStorefrontInput = {
  deliveryMode?: InputMaybe<TableRunDeliveryMode>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TableRunStorefrontStatus>;
  subscribePricePerServingCents?: InputMaybe<Scalars['Int']['input']>;
};

export type Upsell = {
  __typename?: 'Upsell';
  displayName: Scalars['String']['output'];
  foodItemGroup: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  shefPayout: Scalars['Int']['output'];
  tier: UpsellTier;
};

export enum UpsellTier {
  FullOrganic = 'FULL_ORGANIC',
  GrassFed = 'GRASS_FED',
  OrganicProtein = 'ORGANIC_PROTEIN',
  OrganicVegetarian = 'ORGANIC_VEGETARIAN',
  Premium = 'PREMIUM',
  PremiumPlus = 'PREMIUM_PLUS',
  PremiumProtein = 'PREMIUM_PROTEIN',
  WildCaught = 'WILD_CAUGHT'
}

export type UpsertMealPlanShefPayoutOverrideInput = {
  override: MealPlanShefPayoutOverrideInput;
};

export type UpsertMealPlanShefPayoutOverrideResponse = {
  __typename?: 'UpsertMealPlanShefPayoutOverrideResponse';
  message: Scalars['String']['output'];
  override?: Maybe<MealPlanShefPayoutOverride>;
  success: Scalars['Boolean']['output'];
};

export type User = {
  __typename?: 'User';
  activeAddresses: Array<Address>;
  admin: Scalars['Boolean']['output'];
  banReason?: Maybe<Scalars['String']['output']>;
  banned: Scalars['Boolean']['output'];
  bannedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  favoriteShefs: Array<PublicShef>;
  firstName: Scalars['String']['output'];
  flakeId: Scalars['String']['output'];
  followedShefs: Array<PublicShef>;
  foodItemCount?: Maybe<Scalars['Int']['output']>;
  foodItemFindings: UserFoodItemFindingsResults;
  fullName?: Maybe<Scalars['String']['output']>;
  groupOrders?: Maybe<Array<GroupOrder>>;
  hasActiveMealPlan?: Maybe<Scalars['Boolean']['output']>;
  hasActiveSubscription?: Maybe<Scalars['Boolean']['output']>;
  hasDiscountedSubtotalFromExperiment: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  isFirstTimeMealPlanUser: Scalars['Boolean']['output'];
  isMenuCurator: Scalars['Boolean']['output'];
  isPhotoEditor: Scalars['Boolean']['output'];
  isTasteTester: Scalars['Boolean']['output'];
  isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
  lastDetectedAppOpenAt?: Maybe<Scalars['DateTime']['output']>;
  lastName: Scalars['String']['output'];
  lastOrder?: Maybe<Order>;
  lastOrderByFulfillmentDate?: Maybe<Order>;
  lastOrderPhoneNumber?: Maybe<Scalars['String']['output']>;
  lastSearchedRegionId?: Maybe<Scalars['Int']['output']>;
  lastSearchedZipCode?: Maybe<Scalars['String']['output']>;
  lastSearchedZipCodeIsAvailableToCustomers?: Maybe<Scalars['Boolean']['output']>;
  mealPlanFavoritedFoodItems: Array<FoodItem>;
  mealPlanLastFourDigits?: Maybe<Scalars['Int']['output']>;
  orderCount: Scalars['Int']['output'];
  orderCountFromShef: Scalars['Int']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  organization?: Maybe<Organization>;
  pendingReferralRewards?: Maybe<Array<Maybe<PromoCodeUsage>>>;
  phone?: Maybe<Scalars['String']['output']>;
  promoCodes: PaginatedPromoCodes;
  publicName: Scalars['String']['output'];
  recentTasteTests: Scalars['Int']['output'];
  referralCode: ReferralCode;
  referralRewards?: Maybe<Array<Maybe<PromoCode>>>;
  savedCreditCards: Array<SavedCreditCard>;
  shefApplication?: Maybe<ShefApplication>;
  shefProfile?: Maybe<ShefProfile>;
  shefStatus: ShefStatus;
  shefStripeConnect?: Maybe<ShefStripeConnect>;
  tosLastAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  unlockedTrialShefDiscovery: Scalars['Boolean']['output'];
  unratedGroupOrder?: Maybe<GroupOrder>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  visitedMealPlanPreferences?: Maybe<Scalars['Boolean']['output']>;
};


export type UserActiveAddressesArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  shefId?: InputMaybe<Scalars['String']['input']>;
};


export type UserFoodItemFindingsArgs = {
  filter?: InputMaybe<FoodItemFindingsFilterInput>;
  orderBy?: InputMaybe<Array<UserFoodItemFindingsSort>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  resultsPerPage?: InputMaybe<Scalars['Int']['input']>;
};


export type UserHasDiscountedSubtotalFromExperimentArgs = {
  shefId: Scalars['String']['input'];
};


export type UserLastOrderByFulfillmentDateArgs = {
  deliveryDate: Scalars['String']['input'];
  shefId: Scalars['String']['input'];
};


export type UserMealPlanFavoritedFoodItemsArgs = {
  deliveryDate: Scalars['String']['input'];
  mealPlanTypeId?: InputMaybe<Scalars['Int']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type UserOrderCountFromShefArgs = {
  shefId: Scalars['String']['input'];
};


export type UserUnlockedTrialShefDiscoveryArgs = {
  deliveryDates?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UserFoodItemFindingsResults = {
  __typename?: 'UserFoodItemFindingsResults';
  foodItems: Array<ShefFoodItemFindings>;
  pagination: Pagination;
  ruleCounts: Array<FoodItemFindingRuleCount>;
};

export type UserFoodItemFindingsSort = {
  computedField?: InputMaybe<UserFoodItemFindingsSortField>;
  direction: SortDirection;
  field?: InputMaybe<Scalars['String']['input']>;
};

export enum UserFoodItemFindingsSortField {
  FindingCount = 'FINDING_COUNT',
  HighestSeverity = 'HIGHEST_SEVERITY',
  NewestFindingCreatedAt = 'NEWEST_FINDING_CREATED_AT',
  TotalSeverity = 'TOTAL_SEVERITY'
}

export type UserInput = {
  appleIdToken?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookIdToken?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  googleIdToken?: InputMaybe<Scalars['String']['input']>;
  hasAcceptedTermsOfService?: InputMaybe<Scalars['Boolean']['input']>;
  hasOptedIntoMarketingSms?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UserMealPlan = {
  __typename?: 'UserMealPlan';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  mealPlan?: Maybe<MealPlan>;
  mealPlanRegionId?: Maybe<Scalars['Int']['output']>;
  mealPlanZipCode?: Maybe<Scalars['String']['output']>;
  nextDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<MealPlanStatus>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  category: NotificationCategory;
  enabled: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserNotificationSettingInput = {
  category: NotificationCategory;
  enabled: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
};

export type UserNotificationSettingUpdate = {
  notificationSettings: Array<UserNotificationSettingInput>;
  userId: Scalars['String']['input'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  user: User;
};

export enum UserRoleEnum {
  Admin = 'ADMIN',
  MenuCurator = 'MENU_CURATOR',
  PhotoEditor = 'PHOTO_EDITOR'
}

export type UserRoleInput = {
  role: UserRoleEnum;
  value: Scalars['Boolean']['input'];
};

export type UserRoleResult = {
  __typename?: 'UserRoleResult';
  role: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
};

export type UtmInput = {
  campaign?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  cuisine?: InputMaybe<Scalars['String']['input']>;
  impactClickId?: InputMaybe<Scalars['String']['input']>;
  medium?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<Scalars['String']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateMealPlanPaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type ValidateMealPlanPaymentMethodResponse = MutationResponse & {
  __typename?: 'ValidateMealPlanPaymentMethodResponse';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type VamoDropoff = {
  __typename?: 'VamoDropoff';
  address: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type VamoGroupOrder = {
  __typename?: 'VamoGroupOrder';
  deliveryMode: Scalars['String']['output'];
  dropoff: VamoDropoff;
  groupOrderId: Scalars['String']['output'];
  isF4User: Scalars['Boolean']['output'];
  itemsCount: Scalars['Int']['output'];
  orderRoute?: Maybe<Scalars['String']['output']>;
  packageTip: Scalars['Float']['output'];
  packageValue: Scalars['Float']['output'];
  pickup: VamoPickup;
  province?: Maybe<Scalars['String']['output']>;
  timeWindow: VamoOrderTimeWindow;
};

export type VamoOrderTimeWindow = {
  __typename?: 'VamoOrderTimeWindow';
  dropoffEndDatetime: Scalars['DateTime']['output'];
  dropoffStartDatetime: Scalars['DateTime']['output'];
  pickupEndDatetime: Scalars['DateTime']['output'];
  pickupStartDatetime: Scalars['DateTime']['output'];
};

export type VamoPickup = {
  __typename?: 'VamoPickup';
  address?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  instructions?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type Variant = {
  __typename?: 'Variant';
  name: Scalars['String']['output'];
  weight: Scalars['Int']['output'];
};

export type VerifiedDietaryResponse = {
  __typename?: 'VerifiedDietaryResponse';
  questionId: Scalars['String']['output'];
  response: MultiResponse;
  responseDisplay?: Maybe<Scalars['String']['output']>;
  responseFreeText?: Maybe<Scalars['String']['output']>;
};

export enum WaitlistActionType {
  AppDownloaded = 'APP_DOWNLOADED',
  ConsumerPhoneAdded = 'CONSUMER_PHONE_ADDED',
  ConsumerReferralSignup = 'CONSUMER_REFERRAL_SIGNUP',
  ShefApplicationCreated = 'SHEF_APPLICATION_CREATED',
  ShefBioCompleted = 'SHEF_BIO_COMPLETED',
  ShefDishApproved = 'SHEF_DISH_APPROVED',
  ShefPhotoApproved = 'SHEF_PHOTO_APPROVED',
  ShefReferralApproved = 'SHEF_REFERRAL_APPROVED'
}

export type WaitlistRank = {
  __typename?: 'WaitlistRank';
  rank: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  waitlistType?: Maybe<WaitlistType>;
};

export enum WaitlistType {
  Consumer = 'CONSUMER',
  Shef = 'SHEF'
}

export enum WssEditProposalReason {
  DataIssue = 'DATA_ISSUE',
  DishAvailability = 'DISH_AVAILABILITY',
  MacrosUpdate = 'MACROS_UPDATE',
  MajorIngredient = 'MAJOR_INGREDIENT',
  MinorAdjustment = 'MINOR_ADJUSTMENT',
  MinorIngredient = 'MINOR_INGREDIENT',
  PortionSize = 'PORTION_SIZE',
  TierAdjustment = 'TIER_ADJUSTMENT'
}

export enum WssMenuStatus {
  ApprovedNotLive = 'APPROVED_NOT_LIVE',
  Core = 'CORE',
  Draft = 'DRAFT',
  LimitedTime = 'LIMITED_TIME',
  Live = 'LIVE',
  Proposed = 'PROPOSED',
  Seasonal = 'SEASONAL'
}

export enum WssNewDishProposalReason {
  Cost = 'COST',
  ExpandMenu = 'EXPAND_MENU',
  LimitedTimeDishes = 'LIMITED_TIME_DISHES',
  OrganicAndMore = 'ORGANIC_AND_MORE',
  Performance = 'PERFORMANCE',
  RotatingMenuGroups = 'ROTATING_MENU_GROUPS',
  SeasonalRefresh = 'SEASONAL_REFRESH'
}

export type ZipCode = {
  __typename?: 'ZipCode';
  availableToCustomers: Scalars['Boolean']['output'];
  availableToSubscriptions: Scalars['Boolean']['output'];
  canMailFood: Scalars['Boolean']['output'];
  deliveryFee?: Maybe<Scalars['Int']['output']>;
  deliveryHubId?: Maybe<Scalars['Int']['output']>;
  deliveryTimeRange: DeliveryTimeRange;
  deliveryType: Scalars['String']['output'];
  discountedDeliveryFee: Scalars['Int']['output'];
  hasMilkmanRecycling: Scalars['Boolean']['output'];
  isHubless: Scalars['Boolean']['output'];
  mailableDeliveryFee?: Maybe<Scalars['Int']['output']>;
  minimumAmountForDiscountedShipping?: Maybe<Scalars['Int']['output']>;
  minimumAmountForFreeShipping?: Maybe<Scalars['Int']['output']>;
  orderLabelCode?: Maybe<Scalars['String']['output']>;
  region: RegionInfo;
  regionId: Scalars['Int']['output'];
  shefServesZipCode: Scalars['Boolean']['output'];
  timeToShipInDays?: Maybe<Scalars['Int']['output']>;
  timeWindows: Array<TimeWindow>;
  timeZone: Scalars['String']['output'];
  upfrontDeliveryFeeEnabled: Scalars['Boolean']['output'];
  zipCode: Scalars['String']['output'];
};


export type ZipCodeShefServesZipCodeArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  shefId: Scalars['String']['input'];
};


export type ZipCodeTimeWindowsArgs = {
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
};

export type ZipCodeCelebrityEventMetadata = {
  __typename?: 'ZipCodeCelebrityEventMetadata';
  availabilityDate?: Maybe<Scalars['Date']['output']>;
  celebrityEventType?: Maybe<CelebrityEventType>;
  shefId?: Maybe<Scalars['String']['output']>;
};

export type ZipCodeInput = {
  deliveryFee?: InputMaybe<Scalars['Int']['input']>;
  deliveryHubId?: InputMaybe<Scalars['Int']['input']>;
  deliveryType: Scalars['String']['input'];
  orderLabelCode?: InputMaybe<Scalars['String']['input']>;
  regionId: Scalars['Int']['input'];
  timeWindowIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeZone: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type IngestAnalyticsEventMutationVariables = Exact<{
  eventName: Scalars['String']['input'];
  data?: InputMaybe<Scalars['String']['input']>;
}>;


export type IngestAnalyticsEventMutation = { __typename?: 'Mutation', ingestAnalyticsEvent: boolean };

export type CityPageDishFragment = { __typename?: 'CityPageDish', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug?: string | null, price: number, averageRating: number, ratingCount: number, portion: string, shef: { __typename?: 'CityPageDishShefInfo', publicName: string, formattedCuisineCategories?: string | null } };

export type CityPageShefFragment = { __typename?: 'CityPageShef', id: string, imageUrl?: string | null, publicName: string, bio?: string | null, formattedCuisineCategories?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null };

export type CityPageContentQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
  filter: CityPageFilterInput;
}>;


export type CityPageContentQuery = { __typename?: 'Query', cityPageContent2: { __typename?: 'CityPageContent', numDishes: number, dishes: Array<{ __typename?: 'CityPageDish', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug?: string | null, price: number, averageRating: number, ratingCount: number, portion: string, shef: { __typename?: 'CityPageDishShefInfo', publicName: string, formattedCuisineCategories?: string | null } }>, shefs: Array<{ __typename?: 'CityPageShef', id: string, imageUrl?: string | null, publicName: string, bio?: string | null, formattedCuisineCategories?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }> } };

export type RegionPageContentQueryVariables = Exact<{
  regionId: Scalars['Int']['input'];
  filter: CityPageFilterInput;
}>;


export type RegionPageContentQuery = { __typename?: 'Query', cityPageRegionContent: { __typename?: 'CityPageContent', numDishes: number, dishes: Array<{ __typename?: 'CityPageDish', id: number, userId: string, name?: string | null, imageUrl?: string | null, slug?: string | null, price: number, averageRating: number, ratingCount: number, portion: string, shef: { __typename?: 'CityPageDishShefInfo', publicName: string, formattedCuisineCategories?: string | null } }>, shefs: Array<{ __typename?: 'CityPageShef', id: string, imageUrl?: string | null, publicName: string, bio?: string | null, formattedCuisineCategories?: string | null, rating?: { __typename?: 'ShefRating', score: number, count: number } | null }> } };

export type CuisineCategoryFragment = { __typename?: 'CuisineCategory', id: string, title: string, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> };

export type CityPageFilterFragment = { __typename?: 'CityPageFilter', cuisineCategoryId?: string | null, dietaryFilter?: string | null, cuisineCategory?: { __typename?: 'CuisineCategory', id: string, title: string, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } | null };

export type RegionInfoFragment = { __typename?: 'RegionInfo', id: number, displayName: string, name: string };

export type CityPageCityFragment = { __typename?: 'CityPageCity', id: string, cityName: string, stateNameShort: string, zipCode: string, zipCodeInfo: { __typename?: 'ZipCode', deliveryHubId?: number | null, zipCode: string, region: { __typename?: 'RegionInfo', id: number, displayName: string, name: string } } };

export type CityPageCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CityPageCitiesQuery = { __typename?: 'Query', cityPageCities: Array<{ __typename?: 'CityPageCity', id: string, cityName: string, stateNameShort: string, zipCode: string, zipCodeInfo: { __typename?: 'ZipCode', deliveryHubId?: number | null, zipCode: string, region: { __typename?: 'RegionInfo', id: number, displayName: string, name: string } } }> };

export type FiltersForDeliveryHubQueryVariables = Exact<{
  deliveryHubId: Scalars['Int']['input'];
}>;


export type FiltersForDeliveryHubQuery = { __typename?: 'Query', filtersForDeliveryHub: Array<{ __typename?: 'CityPageFilter', cuisineCategoryId?: string | null, dietaryFilter?: string | null, cuisineCategory?: { __typename?: 'CuisineCategory', id: string, title: string, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } | null }> };

export type FiltersForZipQueryVariables = Exact<{
  zipCode: Scalars['String']['input'];
}>;


export type FiltersForZipQuery = { __typename?: 'Query', filtersForZip: Array<{ __typename?: 'CityPageFilter', cuisineCategoryId?: string | null, dietaryFilter?: string | null, cuisineCategory?: { __typename?: 'CuisineCategory', id: string, title: string, ancestorCuisines: Array<{ __typename?: 'CuisineCategory', id: string, isPrimary: boolean }> } | null }> };

export const CityPageDishFragmentDoc = gql`
    fragment CityPageDish on CityPageDish {
  id
  userId
  name
  imageUrl
  slug
  price
  averageRating
  ratingCount
  portion
  shef {
    publicName
    formattedCuisineCategories
  }
}
    `;
export const CityPageShefFragmentDoc = gql`
    fragment CityPageShef on CityPageShef {
  id
  imageUrl
  publicName
  bio
  rating {
    score
    count
  }
  formattedCuisineCategories
}
    `;
export const CuisineCategoryFragmentDoc = gql`
    fragment CuisineCategory on CuisineCategory {
  id
  title
  ancestorCuisines {
    id
    isPrimary
  }
}
    `;
export const CityPageFilterFragmentDoc = gql`
    fragment CityPageFilter on CityPageFilter {
  cuisineCategoryId
  cuisineCategory {
    ...CuisineCategory
  }
  dietaryFilter
}
    ${CuisineCategoryFragmentDoc}`;
export const RegionInfoFragmentDoc = gql`
    fragment RegionInfo on RegionInfo {
  id
  displayName
  name
}
    `;
export const CityPageCityFragmentDoc = gql`
    fragment CityPageCity on CityPageCity {
  id
  cityName
  stateNameShort
  zipCode
  zipCodeInfo {
    deliveryHubId
    zipCode
    region {
      ...RegionInfo
    }
  }
}
    ${RegionInfoFragmentDoc}`;
export const IngestAnalyticsEventDocument = gql`
    mutation IngestAnalyticsEvent($eventName: String!, $data: String) {
  ingestAnalyticsEvent(eventName: $eventName, data: $data)
}
    `;
export type IngestAnalyticsEventMutationFn = Apollo.MutationFunction<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>;
export type IngestAnalyticsEventMutationResult = Apollo.MutationResult<IngestAnalyticsEventMutation>;
export type IngestAnalyticsEventMutationOptions = Apollo.BaseMutationOptions<IngestAnalyticsEventMutation, IngestAnalyticsEventMutationVariables>;
export const CityPageContentDocument = gql`
    query CityPageContent($zipCode: String!, $filter: CityPageFilterInput!) {
  cityPageContent2(zipCode: $zipCode, filter: $filter) {
    dishes {
      ...CityPageDish
    }
    shefs {
      ...CityPageShef
    }
    numDishes
  }
}
    ${CityPageDishFragmentDoc}
${CityPageShefFragmentDoc}`;
export type CityPageContentQueryResult = Apollo.QueryResult<CityPageContentQuery, CityPageContentQueryVariables>;
export const RegionPageContentDocument = gql`
    query RegionPageContent($regionId: Int!, $filter: CityPageFilterInput!) {
  cityPageRegionContent(regionId: $regionId, filter: $filter) {
    dishes {
      ...CityPageDish
    }
    shefs {
      ...CityPageShef
    }
    numDishes
  }
}
    ${CityPageDishFragmentDoc}
${CityPageShefFragmentDoc}`;
export type RegionPageContentQueryResult = Apollo.QueryResult<RegionPageContentQuery, RegionPageContentQueryVariables>;
export const CityPageCitiesDocument = gql`
    query CityPageCities {
  cityPageCities {
    ...CityPageCity
  }
}
    ${CityPageCityFragmentDoc}`;
export type CityPageCitiesQueryResult = Apollo.QueryResult<CityPageCitiesQuery, CityPageCitiesQueryVariables>;
export const FiltersForDeliveryHubDocument = gql`
    query FiltersForDeliveryHub($deliveryHubId: Int!) {
  filtersForDeliveryHub(deliveryHubId: $deliveryHubId) {
    ...CityPageFilter
  }
}
    ${CityPageFilterFragmentDoc}`;
export type FiltersForDeliveryHubQueryResult = Apollo.QueryResult<FiltersForDeliveryHubQuery, FiltersForDeliveryHubQueryVariables>;
export const FiltersForZipDocument = gql`
    query FiltersForZip($zipCode: String!) {
  filtersForZip(zipCode: $zipCode) {
    ...CityPageFilter
  }
}
    ${CityPageFilterFragmentDoc}`;
export type FiltersForZipQueryResult = Apollo.QueryResult<FiltersForZipQuery, FiltersForZipQueryVariables>;